export function getTripMock() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            name: "SOL, Madrid",
            type: "ST",
            id: "A=1@O=SOL, Madrid@X=-3703259@Y=40416877@U=80@L=800001006@",
            extId: "800001006",
            lon: -3.703259,
            lat: 40.416877,
            routeIdx: 14,
            prognosisType: "PROGNOSED",
            time: "14:09:00",
            date: "2023-06-21",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
            mainMastExtId: "100018101",
            mainMastLon: -3.703214,
            mainMastLat: 40.416877,
          },
          Destination: {
            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
            type: "ST",
            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
            extId: "100051003",
            lon: -5.975274,
            lat: 37.392123,
            routeIdx: 4,
            prognosisType: "PROGNOSED",
            time: "18:25:00",
            date: "2023-06-21",
          },
          ServiceDays: [
            {
              planningPeriodBegin: "2023-05-16",
              planningPeriodEnd: "2024-03-11",
              sDaysR: "no cada día",
              sDaysI:
                "20. Jun hasta 29. Sep 2023 Lu - Vi; no 1. hasta 31. Ago 2023",
              sDaysB:
                "0000001F3E7CF9F3E7C800000009F3E7CF800000000000000000000000000000000000000000",
            },
          ],
          Freq: {
            waitMinimum: 5,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2719|CI20VCO|CI01",
                          },
                          {
                            name: "NAME",
                            value: "Elige Eurail",
                          },
                          {
                            name: "PRICE",
                            value: "650",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjcxOXxDSTIwVkNPfENJMDEiLCJwcmljZSI6Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qY3hPWHhEU1RJd1ZrTlBmRU5KTURFaUxDSndjbWxqWlNJNk5pNDFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Eurail",
                        price: 650,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjcxOXxDSTIwVkNPfENJMDEiLCJwcmljZSI6Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "EURAIL",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2714|CI20VCO|CI01",
                          },
                          {
                            name: "NAME",
                            value: "Elige Interrail",
                          },
                          {
                            name: "PRICE",
                            value: "650",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjcxNHxDSTIwVkNPfENJMDEiLCJwcmljZSI6Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qY3hOSHhEU1RJd1ZrTlBmRU5KTURFaUxDSndjbWxqWlNJNk5pNDFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Interrail",
                        price: 650,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjcxNHxDSTIwVkNPfENJMDEiLCJwcmljZSI6Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "INTERRAIL",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1011|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico Niño",
                          },
                          {
                            name: "PRICE",
                            value: "4545",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDAzVkNPfEMwNCIsInByaWNlIjo0NS40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvME5TNDBOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico Niño",
                        price: 4545,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDAzVkNPfEMwNCIsInByaWNlIjo0NS40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2011|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige Niño",
                          },
                          {
                            name: "PRICE",
                            value: "4895",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTAzVkNPfEMwNCIsInByaWNlIjo0OC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvME9DNDVOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Niño",
                        price: 4895,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTAzVkNPfEMwNCIsInByaWNlIjo0OC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "ELIGE",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1031|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "5305",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDAzVkNPfEMwNCIsInByaWNlIjo1My4wNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvMU15NHdOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico Más Renfe Joven",
                        price: 5305,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDAzVkNPfEMwNCIsInByaWNlIjo1My4wNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1013|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "5685",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDAzVkNPfEMwNCIsInByaWNlIjo1Ni44NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvMU5pNDROU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico T.Dorada",
                        price: 5685,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDAzVkNPfEMwNCIsInByaWNlIjo1Ni44NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2031|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "5715",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTAzVkNPfEMwNCIsInByaWNlIjo1Ny4xNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvMU55NHhOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Más Renfe Joven",
                        price: 5715,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTAzVkNPfEMwNCIsInByaWNlIjo1Ny4xNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "ELIGE",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2013|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "6120",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTAzVkNPfEMwNCIsInByaWNlIjo2MS4yLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvMk1TNHlMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige T.Dorada",
                        price: 6120,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTAzVkNPfEMwNCIsInByaWNlIjo2MS4yLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1548|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "6975",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDAzVkNPfEMwNCIsInByaWNlIjo2OS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvMk9TNDNOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico 4 o más",
                        price: 6975,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDAzVkNPfEMwNCIsInByaWNlIjo2OS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1030|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "7200",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDAzVkNPfEMwNCIsInByaWNlIjo3MiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvM01pd2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico C. Joven < 26",
                        price: 7200,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDAzVkNPfEMwNCIsInByaWNlIjo3MiwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2548|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "7510",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTAzVkNPfEMwNCIsInByaWNlIjo3NS4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvM05TNHhMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige 4 o más",
                        price: 7510,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTAzVkNPfEMwNCIsInByaWNlIjo3NS4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1033|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico Verano Joven",
                          },
                          {
                            name: "PRICE",
                            value: "7575",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzM3xDTDAzVkNPfEMwNCIsInByaWNlIjo3NS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNM3hEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvM05TNDNOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico Verano Joven",
                        price: 7575,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzM3xDTDAzVkNPfEMwNCIsInByaWNlIjo3NS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1010|CL03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Básico",
                          },
                          {
                            name: "PRICE",
                            value: "7580",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDAzVkNPfEMwNCIsInByaWNlIjo3NS44LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBelZrTlBmRU13TkNJc0luQnlhV05sSWpvM05TNDRMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico",
                        price: 7580,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDAzVkNPfEMwNCIsInByaWNlIjo3NS44LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "BASICO",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2030|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "7755",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTAzVkNPfEMwNCIsInByaWNlIjo3Ny41NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvM055NDFOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige C. Joven < 26",
                        price: 7755,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTAzVkNPfEMwNCIsInByaWNlIjo3Ny41NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "ELIGE",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2010|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige",
                          },
                          {
                            name: "PRICE",
                            value: "8160",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTAzVkNPfEMwNCIsInByaWNlIjo4MS42LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvNE1TNDJMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige",
                        price: 8160,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTAzVkNPfEMwNCIsInByaWNlIjo4MS42LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2033|CE03VCO|C04",
                          },
                          {
                            name: "NAME",
                            value: "Elige Verano Joven",
                          },
                          {
                            name: "PRICE",
                            value: "8160",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzM3xDRTAzVkNPfEMwNCIsInByaWNlIjo4MS42LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNM3hEUlRBelZrTlBmRU13TkNJc0luQnlhV05sSWpvNE1TNDJMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Verano Joven",
                        price: 8160,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzM3xDRTAzVkNPfEMwNCIsInByaWNlIjo4MS42LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          child: false,
                        },
                      },
                    ],
                    param: [
                      {
                        name: "TRAIN",
                        value: "09330",
                      },
                      {
                        name: "TRAIN_TYPE",
                        value: "026",
                      },
                      {
                        name: "DEPARTURE_TIME",
                        value: "1449",
                      },
                      {
                        name: "ARRIVAL_TIME",
                        value: "1656",
                      },
                      {
                        name: "TYPE",
                        value: "OUTWARD",
                      },
                      {
                        name: "SILENT_CAR",
                        value: "false",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe AVE LD MD Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe",
                  },
                  {
                    name: "secId",
                    value: "C-0:003",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:003",
                  },
                  {
                    name: "secIds",
                    value: "C-0:003",
                  },
                ],
                name: "Renfe AVE LD MD Pricing",
                fromLegId: 3,
                toLegId: 3,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "GL011",
                          },
                          {
                            name: "NAME",
                            value: "Nino",
                          },
                          {
                            name: "PRICE",
                            value: "1340",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInByaWNlIjoxMy40LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNU0lzSW5CeWFXTmxJam94TXk0MExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlKOQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Nino",
                        price: 1340,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInByaWNlIjoxMy40LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "BASICO",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "GL031",
                          },
                          {
                            name: "NAME",
                            value: "Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "1675",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInByaWNlIjoxNi43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNU0lzSW5CeWFXTmxJam94Tmk0M05Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Más Renfe Joven",
                        price: 1675,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInByaWNlIjoxNi43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "GL013",
                          },
                          {
                            name: "NAME",
                            value: "Tfa. Tarjeta Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "1675",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInByaWNlIjoxNi43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNeUlzSW5CeWFXTmxJam94Tmk0M05Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Tfa. Tarjeta Dorada",
                        price: 1675,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInByaWNlIjoxNi43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "GL030",
                          },
                          {
                            name: "NAME",
                            value: "C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "1785",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInByaWNlIjoxNy44NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNQ0lzSW5CeWFXTmxJam94Tnk0NE5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaWZRPT0=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "C. Joven < 26",
                        price: 1785,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInByaWNlIjoxNy44NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "GL410",
                          },
                          {
                            name: "NAME",
                            value: "Adulto Sólo Ida",
                          },
                          {
                            name: "PRICE",
                            value: "2230",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInByaWNlIjoyMi4zLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVE1pTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNRFl5TVNJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREUXhNQ0lzSW5CeWFXTmxJam95TWk0ekxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlKOQ==",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Adulto Sólo Ida",
                        price: 2230,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTMiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDIzMDYyMSIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInByaWNlIjoyMi4zLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "BASICO",
                          child: false,
                        },
                      },
                    ],
                    param: [
                      {
                        name: "TRAIN",
                        value: "08764",
                      },
                      {
                        name: "TRAIN_TYPE",
                        value: "008",
                      },
                      {
                        name: "DEPARTURE_TIME",
                        value: "1735",
                      },
                      {
                        name: "ARRIVAL_TIME",
                        value: "1825",
                      },
                      {
                        name: "TYPE",
                        value: "OUTWARD",
                      },
                      {
                        name: "SILENT_CAR",
                        value: "false",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe AVE LD MD Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe",
                  },
                  {
                    name: "secId",
                    value: "C-0:005",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:005",
                  },
                  {
                    name: "secIds",
                    value: "C-0:005",
                  },
                ],
                name: "Renfe AVE LD MD Pricing",
                fromLegId: 5,
                toLegId: 5,
              },
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Recorridos de hasta 5 estaciones: 1,50 €. Recorridos de 6 a 9 estaciones: 0,10 € adicionales por estación. Recorridos de 10 estaciones o más: 2,00 €. En las máquinas automáticas se selecciona el destino y automáticamente se calcula el número de estaciones y el precio correspondiente al itinerario más corto de entre los posibles.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Metro",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - MetroEste, MetroNorte y MetroSur",
                        price: 150,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - TFM",
                        price: 200,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Válido para Metro de Madrid, TFM, Metros Ligeros de Madrid y Metro Ligero Oeste.",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto - Combinado Metro",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value: "",
                          },
                          {
                            name: "PRICE.PREFIX",
                            value: "min.",
                          },
                        ],
                        name: "Billete Suplemento Aeropuerto de un viaje para un adulto",
                        price: 300,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "022_metro_madri",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona A",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-0:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona A",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.crtm.es/billetes-y-tarifas.aspx",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Tarifas de Metro de Madrid (CRTM) - Precio depende de nr. de estaciones",
                desc: "Zona A",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            economic: true,
            convenient: true,
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=SOL, Madrid@L=800001006@a=128@$A=1@O=ATOCHA, Madrid@L=700001049@a=128@$202306211409$202306211415$Con    1$$1$$$$$$§W$A=1@O=ATOCHA, Madrid@L=700001049@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202306211415$202306211417$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202306211419$202306211449$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202306211449$202306211656$RENInter$$1$$$$$$§G@F$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202306211705$202306211735$__CI$$1$$$$$$§T$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202306211735$202306211825$RENAVANT$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT4H16M",
          rtDuration: "PT4H16M",
          checksum: "866bfd4c_3",
          transferCount: 2,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "SOL, Madrid",
                  type: "ST",
                  id: "A=1@O=SOL, Madrid@X=-3703259@Y=40416877@U=80@L=800001006@",
                  extId: "800001006",
                  lon: -3.703259,
                  lat: 40.416877,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "14:09:00",
                  date: "2023-06-21",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                  mainMastExtId: "100018101",
                  mainMastLon: -3.703214,
                  mainMastLat: 40.416877,
                },
                Destination: {
                  name: "ATOCHA, Madrid",
                  type: "ST",
                  id: "A=1@O=ATOCHA, Madrid@X=-3689380@Y=40406593@U=80@L=700001049@",
                  extId: "700001049",
                  lon: -3.68938,
                  lat: 40.406593,
                  routeIdx: 18,
                  prognosisType: "PROGNOSED",
                  time: "14:15:00",
                  date: "2023-06-21",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  mainMastExtId: "100018000",
                  mainMastLon: -3.688957,
                  mainMastLat: 40.406153,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#76095#TA#51#DA#210623#1S#1151#1T#1345#LS#1186#LT#1442#PU#80#RT#1#CA#CRT#ZE#1#ZB#Con    1#PC#6#FR#1151#FT#1345#TO#1186#TT#1442#",
                },
                Freq: {
                  waitMinimum: 5,
                  waitMaximum: 5,
                  alternativeCount: 25,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 45,
                        g: 190,
                        b: 240,
                        hex: "#2DBEF0",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "Consorcio Regional de Transportes de Madrid",
                      nameS: "CRT",
                      nameN: "Consorci",
                      nameL: "Consorcio Regional de Transportes de Madrid",
                      id: "CRTM",
                    },
                    name: "Con 1",
                    internalName: "Con    1",
                    displayNumber: "1",
                    num: "65",
                    line: "1",
                    lineId: "4__1___(CRTM)022",
                    catOut: "Consorci",
                    catIn: "CRT",
                    catCode: "6",
                    cls: "64",
                    catOutS: "CRT",
                    catOutL: "Consorcio Regional de Transportes de Madrid",
                    operatorCode: "CRT",
                    operator: "Consorcio Regional de Transportes de Madrid",
                    admin: "022000",
                    routeIdxFrom: 14,
                    routeIdxTo: 18,
                    matchId: "1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "SOL, Madrid",
                      id: "A=1@O=SOL, Madrid@X=-3703259@Y=40416877@U=80@L=800001006@",
                      extId: "800001006",
                      routeIdx: 14,
                      lon: -3.703259,
                      lat: 40.416877,
                      depTime: "14:09:00",
                      depDate: "2023-06-21",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid-Sol, Madrid@X=-3703214@Y=40416877@U=80@L=100018101@",
                      mainMastExtId: "100018101",
                      mainMastLon: -3.703214,
                      mainMastLat: 40.416877,
                      depDir: "VALDECARROS",
                    },
                    {
                      name: "TIRSO DE MOLINA, Madrid",
                      id: "A=1@O=TIRSO DE MOLINA, Madrid@X=-3704661@Y=40412346@U=80@L=1017@",
                      extId: "1017",
                      routeIdx: 15,
                      lon: -3.704661,
                      lat: 40.412346,
                      depTime: "14:11:00",
                      depDate: "2023-06-21",
                      arrTime: "14:11:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "ANTON MARTIN, Madrid",
                      id: "A=1@O=ANTON MARTIN, Madrid@X=-3699367@Y=40412463@U=80@L=1027@",
                      extId: "1027",
                      routeIdx: 16,
                      lon: -3.699367,
                      lat: 40.412463,
                      depTime: "14:12:00",
                      depDate: "2023-06-21",
                      arrTime: "14:12:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "ESTACION DEL ARTE, Madrid",
                      id: "A=1@O=ESTACION DEL ARTE, Madrid@X=-3692490@Y=40408849@U=80@L=1038@",
                      extId: "1038",
                      routeIdx: 17,
                      lon: -3.69249,
                      lat: 40.408849,
                      depTime: "14:14:00",
                      depDate: "2023-06-21",
                      arrTime: "14:14:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "ATOCHA, Madrid",
                      id: "A=1@O=ATOCHA, Madrid@X=-3689380@Y=40406593@U=80@L=700001049@",
                      extId: "700001049",
                      routeIdx: 18,
                      lon: -3.68938,
                      lat: 40.406593,
                      arrTime: "14:15:00",
                      arrDate: "2023-06-21",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                      mainMastExtId: "100018000",
                      mainMastLon: -3.688957,
                      mainMastLat: 40.406153,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-06-21",
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#76095#TA#51#DA#210623#1S#1151#1T#1345#LS#1186#LT#1442#PU#80#RT#1#CA#CRT#ZE#1#ZB#Con    1#PC#6#FR#1151#FT#1345#TO#1186#TT#1442#",
                },
                id: "C-0:000",
                idx: 0,
                name: "Con 1",
                number: "1",
                category: "CRT",
                type: "JNY",
                reachable: true,
                direction: "VALDECARROS",
                directionFlag: "0",
                duration: "PT6M",
                dist: 2039,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.703259,
                      lat: 40.416877,
                    },
                    {
                      order: 1,
                      lon: -3.704661,
                      lat: 40.412346,
                    },
                    {
                      order: 2,
                      lon: -3.699367,
                      lat: 40.412463,
                    },
                    {
                      order: 3,
                      lon: -3.69249,
                      lat: 40.408849,
                    },
                    {
                      order: 4,
                      lon: -3.68938,
                      lat: 40.406593,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "ATOCHA, Madrid",
                  type: "ST",
                  id: "A=1@O=ATOCHA, Madrid@X=-3689380@Y=40406593@U=80@L=700001049@",
                  extId: "700001049",
                  lon: -3.68938,
                  lat: 40.406593,
                  time: "14:15:00",
                  date: "2023-06-21",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                  mainMastExtId: "100018000",
                  mainMastLon: -3.688957,
                  mainMastLat: 40.406153,
                },
                Destination: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  time: "14:17:00",
                  date: "2023-06-21",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=ATOCHA, Madrid@L=700001049@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202306211415$202306211417$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT2M",
                dist: 129,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.68938,
                      lat: 40.406593,
                    },
                    {
                      order: 1,
                      lon: -3.69089,
                      lat: 40.40644,
                    },
                  ],
                  dist: 129,
                  durS: "PT2M",
                  dirGeo: 16,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  time: "14:19:00",
                  date: "2023-06-21",
                },
                Destination: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  time: "14:49:00",
                  date: "2023-06-21",
                },
                Product: [
                  {
                    icon: {
                      res: "check_in",
                    },
                    name: "Ingreso",
                    internalName: "Ingreso",
                  },
                ],
                id: "C-0:002",
                idx: 2,
                name: "Ingreso",
                type: "CHKI",
                duration: "PT30M",
                dist: 0,
                GisRoute: {
                  dist: 0,
                  durS: "PT30M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "14:49:00",
                  date: "2023-06-21",
                },
                Destination: {
                  name: "Estación de tren Cordoba, Córdoba",
                  type: "ST",
                  id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                  extId: "100050500",
                  lon: -4.789453,
                  lat: 37.888292,
                  routeIdx: 4,
                  prognosisType: "PROGNOSED",
                  time: "16:56:00",
                  date: "2023-06-21",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85939#TA#0#DA#210623#1S#100060000#1T#1449#LS#100055020#LT#2007#PU#80#RT#1#CA#107#ZE#Intercit#ZB#RENInter#PC#2#FR#100060000#FT#1449#TO#100055020#TT#2007#",
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 0,
                        g: 0,
                        b: 0,
                        hex: "#000000",
                      },
                      backgroundColor: {
                        r: 242,
                        g: 245,
                        b: 245,
                        hex: "#F2F5F5",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "RENFE OPERADORA",
                      nameS: "107",
                      nameN: "RENFE OP",
                      nameL: "RENFE OPERADORA",
                      id: "1071",
                    },
                    name: "RENInter",
                    internalName: "RENInter",
                    displayNumber: "Intercit",
                    num: "793",
                    line: "Intercit",
                    lineId: "6000055020GL026(1071)030",
                    catOut: "RENFE OP",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "RENFE OPERADORA",
                    operatorCode: "107",
                    operator: "RENFE OPERADORA",
                    admin: "030000",
                    routeIdxFrom: 0,
                    routeIdxTo: 4,
                    matchId: "Intercit",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                      extId: "100060000",
                      routeIdx: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                      depPrognosisType: "PROGNOSED",
                      depTime: "14:49:00",
                      depDate: "2023-06-21",
                      depDir: "Estación de tren Algeciras, Algeciras",
                    },
                    {
                      name: "Estación de tren Ciudad Real, Ciudad Real",
                      id: "A=1@O=Estación de tren Ciudad Real, Ciudad Real@X=-3913634@Y=38985300@U=80@L=100037200@",
                      extId: "100037200",
                      routeIdx: 1,
                      lon: -3.913634,
                      lat: 38.9853,
                      depTime: "15:41:00",
                      depDate: "2023-06-21",
                      arrTime: "15:40:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "Estación de tren Puertollano, Puertollano",
                      id: "A=1@O=Estación de tren Puertollano, Puertollano@X=-4111657@Y=38691280@U=80@L=100037300@",
                      extId: "100037300",
                      routeIdx: 2,
                      lon: -4.111657,
                      lat: 38.69128,
                      depTime: "15:59:00",
                      depDate: "2023-06-21",
                      arrTime: "15:58:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "Estación de tren Villanueva de Cordoba-Los Pedroch",
                      id: "A=1@O=Estación de tren Villanueva de Cordoba-Los Pedroch@X=-4570952@Y=38255403@U=80@L=100037704@",
                      extId: "100037704",
                      routeIdx: 3,
                      lon: -4.570952,
                      lat: 38.255403,
                      depTime: "16:29:00",
                      depDate: "2023-06-21",
                      arrTime: "16:28:00",
                      arrDate: "2023-06-21",
                    },
                    {
                      name: "Estación de tren Cordoba, Córdoba",
                      id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                      extId: "100050500",
                      routeIdx: 4,
                      lon: -4.789453,
                      lat: 37.888292,
                      arrTime: "16:56:00",
                      arrDate: "2023-06-21",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-06-21",
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85939#TA#0#DA#210623#1S#100060000#1T#1449#LS#100055020#LT#2007#PU#80#RT#1#CA#107#ZE#Intercit#ZB#RENInter#PC#2#FR#100060000#FT#1449#TO#100055020#TT#2007#",
                },
                id: "C-0:003",
                idx: 3,
                name: "RENInter",
                number: "Intercit",
                category: "107",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Algeciras, Algeciras",
                directionFlag: "0",
                duration: "PT2H7M",
                dist: 304134,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                    },
                    {
                      order: 1,
                      lon: -3.913634,
                      lat: 38.9853,
                    },
                    {
                      order: 2,
                      lon: -4.111657,
                      lat: 38.69128,
                    },
                    {
                      order: 3,
                      lon: -4.570952,
                      lat: 38.255403,
                    },
                    {
                      order: 4,
                      lon: -4.789453,
                      lat: 37.888292,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Cordoba, Córdoba",
                  type: "ST",
                  id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                  extId: "100050500",
                  lon: -4.789453,
                  lat: 37.888292,
                  routeIdx: 3,
                  time: "17:05:00",
                  date: "2023-06-21",
                },
                Destination: {
                  name: "Estación de tren Cordoba, Córdoba",
                  type: "ST",
                  id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                  extId: "100050500",
                  lon: -4.789453,
                  lat: 37.888292,
                  routeIdx: 3,
                  time: "17:35:00",
                  date: "2023-06-21",
                },
                Product: [
                  {
                    icon: {
                      res: "check_in",
                    },
                    name: "Ingreso",
                    internalName: "Ingreso",
                  },
                ],
                id: "C-0:004",
                idx: 4,
                name: "Ingreso",
                type: "CHKI",
                duration: "PT30M",
                dist: 0,
                GisRoute: {
                  dist: 0,
                  durS: "PT30M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Estación de tren Cordoba, Córdoba",
                  type: "ST",
                  id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                  extId: "100050500",
                  lon: -4.789453,
                  lat: 37.888292,
                  routeIdx: 3,
                  prognosisType: "PROGNOSED",
                  time: "17:35:00",
                  date: "2023-06-21",
                },
                Destination: {
                  name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                  type: "ST",
                  id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                  extId: "100051003",
                  lon: -5.975274,
                  lat: 37.392123,
                  routeIdx: 4,
                  prognosisType: "PROGNOSED",
                  time: "18:25:00",
                  date: "2023-06-21",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85898#TA#0#DA#210623#1S#54413#1T#1625#LS#100051003#LT#1825#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#1625#TO#100051003#TT#1825#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Cordoba, Córdoba",
                            id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            extId: "100050500",
                            routeIdx: 19,
                            lon: -4.789453,
                            lat: 37.888292,
                            depTime: "18:36:00",
                            depDate: "2023-06-21",
                            depDir: "Estación de tren Cádiz, Cádiz",
                          },
                          {
                            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                            extId: "100051003",
                            routeIdx: 20,
                            lon: -5.975274,
                            lat: 37.392123,
                            arrTime: "19:30:00",
                            arrDate: "2023-06-21",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1686837077#PI#0#ZI#84529#TA#0#DA#210623#1S#100071801#1T#830#LS#100051405#LT#2120#PU#80#RT#1#CA#107#ZE#TORRE OR#ZB#RENTORRE#PC#2#FR#100071801#FT#830#TO#100051405#TT#2120#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "RENTORRE",
                        internalName: "RENTORRE",
                        displayNumber: "TORRE OR",
                        num: "116",
                        line: "TORRE OR",
                        lineId: "7180151405GL026(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "TORRE OR",
                      },
                      name: "RENTORRE",
                      direction: "Estación de tren Cádiz, Cádiz",
                      trainNumber: "TORRE OR",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Cordoba, Córdoba",
                            id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            extId: "100050500",
                            routeIdx: 4,
                            lon: -4.789453,
                            lat: 37.888292,
                            depTime: "18:39:00",
                            depDate: "2023-06-21",
                            depDir: "Estación de tren Cádiz, Cádiz",
                          },
                          {
                            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                            extId: "100051003",
                            routeIdx: 9,
                            lon: -5.975274,
                            lat: 37.392123,
                            arrTime: "20:06:00",
                            arrDate: "2023-06-21",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1686837077#PI#0#ZI#86074#TA#0#DA#210623#1S#100003100#1T#1656#LS#100051405#LT#2155#PU#80#RT#1#CA#107#ZE#MD#ZB#REN   MD#PC#2#FR#100003100#FT#1656#TO#100051405#TT#2155#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN MD",
                        internalName: "REN   MD",
                        displayNumber: "MD",
                        num: "915",
                        line: "MD",
                        lineId: "0310051405VRX(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "MD",
                      },
                      name: "REN MD",
                      direction: "Estación de tren Cádiz, Cádiz",
                      trainNumber: "MD",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Cordoba, Córdoba",
                            id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            extId: "100050500",
                            routeIdx: 5,
                            lon: -4.789453,
                            lat: 37.888292,
                            depTime: "19:25:00",
                            depDate: "2023-06-21",
                            depDir:
                              "Estación de tren Sevilla-Santa Justa, Sevilla",
                          },
                          {
                            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                            extId: "100051003",
                            routeIdx: 6,
                            lon: -5.975274,
                            lat: 37.392123,
                            arrTime: "20:15:00",
                            arrDate: "2023-06-21",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85892#TA#0#DA#210623#1S#100005000#1T#1745#LS#100051003#LT#2015#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100005000#FT#1745#TO#100051003#TT#2015#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "RENAVANT",
                        internalName: "RENAVANT",
                        displayNumber: "AVANT",
                        num: "741",
                        line: "AVANT",
                        lineId: "0500051003AV008(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVANT",
                      },
                      name: "RENAVANT",
                      direction:
                        "Estación de tren Sevilla-Santa Justa, Sevilla",
                      trainNumber: "AVANT",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Cordoba, Córdoba",
                            id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            extId: "100050500",
                            routeIdx: 3,
                            lon: -4.789453,
                            lat: 37.888292,
                            depTime: "19:35:00",
                            depDate: "2023-06-21",
                            depDir:
                              "Estación de tren Sevilla-Santa Justa, Sevilla",
                          },
                          {
                            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                            extId: "100051003",
                            routeIdx: 4,
                            lon: -5.975274,
                            lat: 37.392123,
                            arrTime: "20:25:00",
                            arrDate: "2023-06-21",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85899#TA#0#DA#210623#1S#54413#1T#1825#LS#100051003#LT#2025#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#1825#TO#100051003#TT#2025#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "RENAVANT",
                        internalName: "RENAVANT",
                        displayNumber: "AVANT",
                        num: "749",
                        line: "AVANT",
                        lineId: "5441351003AV008(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVANT",
                      },
                      name: "RENAVANT",
                      direction:
                        "Estación de tren Sevilla-Santa Justa, Sevilla",
                      trainNumber: "AVANT",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Cordoba, Córdoba",
                            id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                            extId: "100050500",
                            routeIdx: 4,
                            lon: -4.789453,
                            lat: 37.888292,
                            depTime: "20:10:00",
                            depDate: "2023-06-21",
                            depDir: "Estación de tren Cádiz, Cádiz",
                          },
                          {
                            name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                            id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                            extId: "100051003",
                            routeIdx: 9,
                            lon: -5.975274,
                            lat: 37.392123,
                            arrTime: "21:30:00",
                            arrDate: "2023-06-21",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1686837077#PI#0#ZI#86085#TA#0#DA#210623#1S#100003100#1T#1832#LS#100051405#LT#2335#PU#80#RT#1#CA#107#ZE#MD#ZB#REN   MD#PC#2#FR#100003100#FT#1832#TO#100051405#TT#2335#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ic",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN MD",
                        internalName: "REN   MD",
                        displayNumber: "MD",
                        num: "925",
                        line: "MD",
                        lineId: "0310051405VRX(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "2",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "MD",
                      },
                      name: "REN MD",
                      direction: "Estación de tren Cádiz, Cádiz",
                      trainNumber: "MD",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 3,
                  waitMaximum: 61,
                  alternativeCount: 5,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 0,
                        g: 0,
                        b: 0,
                        hex: "#000000",
                      },
                      backgroundColor: {
                        r: 242,
                        g: 245,
                        b: 245,
                        hex: "#F2F5F5",
                      },
                      res: "prod_ic",
                    },
                    operatorInfo: {
                      name: "RENFE OPERADORA",
                      nameS: "107",
                      nameN: "RENFE OP",
                      nameL: "RENFE OPERADORA",
                      id: "1071",
                    },
                    name: "RENAVANT",
                    internalName: "RENAVANT",
                    displayNumber: "AVANT",
                    num: "748",
                    line: "AVANT",
                    lineId: "5441351003AV008(1071)030",
                    catOut: "RENFE OP",
                    catIn: "107",
                    catCode: "2",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "RENFE OPERADORA",
                    operatorCode: "107",
                    operator: "RENFE OPERADORA",
                    admin: "030000",
                    routeIdxFrom: 3,
                    routeIdxTo: 4,
                    matchId: "AVANT",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Cordoba, Córdoba",
                      id: "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                      extId: "100050500",
                      routeIdx: 3,
                      lon: -4.789453,
                      lat: 37.888292,
                      depTime: "17:35:00",
                      depDate: "2023-06-21",
                      depDir: "Estación de tren Sevilla-Santa Justa, Sevilla",
                    },
                    {
                      name: "Estación de tren Sevilla-Santa Justa, Sevilla",
                      id: "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                      extId: "100051003",
                      routeIdx: 4,
                      lon: -5.975274,
                      lat: 37.392123,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "18:25:00",
                      arrDate: "2023-06-21",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-06-21",
                  ref: "2|#VN#1#ST#1686837077#PI#0#ZI#85898#TA#0#DA#210623#1S#54413#1T#1625#LS#100051003#LT#1825#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#1625#TO#100051003#TT#1825#",
                },
                id: "C-0:005",
                idx: 5,
                name: "RENAVANT",
                number: "AVANT",
                category: "107",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Sevilla-Santa Justa, Sevilla",
                directionFlag: "0",
                duration: "PT50M",
                dist: 118144,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -4.789453,
                      lat: 37.888292,
                    },
                    {
                      order: 1,
                      lon: -5.975274,
                      lat: 37.392123,
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  };
}

export function getTripMockExample() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            mcpData: [
              {
                name: "provider",
                value: "taxi",
              },
              {
                name: "providerName",
                value: "Taxi",
              },
              {
                name: "availability",
                value: "A",
              },
              {
                name: "mcpId",
                value: "taxi:transient",
              },
              {
                name: "externalId",
                value: "transient",
              },
              {
                name: "mcpType",
                value: "V",
              },
            ],
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:15:00",
            date: "2023-01-26",
            mcp: true,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:19:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.501595,
            type: "IMT",
            rating: 0,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "900",
                          },
                          {
                            name: "estimateHigh",
                            value: "900",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 900,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2250",
                          },
                          {
                            name: "estimateHigh",
                            value: "2250",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 2250,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1350",
                          },
                          {
                            name: "estimateHigh",
                            value: "1350",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1350,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2501",
                          },
                          {
                            name: "estimateHigh",
                            value: "2501",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 2501,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2728",
                          },
                          {
                            name: "estimateHigh",
                            value: "2728",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:OTFkNmNiZWEtMDllMC00MzVkLTlkODctMDM5NWU0Y2MzY2M1O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "3",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "91d6cbea-09e0-435d-9d87-0395e4cc3cc5",
                          },
                          {
                            name: "FLEET_NAME",
                            value:
                              "Will Always Decline After Acc (Robot Fleet)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/bea1240a-c4b7-4746-8353-83a253042c2e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6T1RGa05tTmlaV0V0TURsbE1DMDBNelZrTFRsa09EY3RNRE01TldVMFkyTXpZMk0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUMVJHYTA1dFRtbGFWMFYwVFVSc2JFMURNREJOZWxaclRGUnNhMDlFWTNSTlJFMDFUbGRWTUZreVRYcFpNazB4VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Will Always Decline After Acc (Robot Fleet)",
                        price: 2728,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6T1RGa05tTmlaV0V0TURsbE1DMDBNelZrTFRsa09EY3RNRE01TldVMFkyTXpZMk0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1170",
                          },
                          {
                            name: "estimateHigh",
                            value: "1170",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "1",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1170,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1046",
                          },
                          {
                            name: "estimateHigh",
                            value: "1046",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2VsZWN0cmljO3N0YW5kYXJkO2VsZWN0cmlj",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "2",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Electric",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV2MxcFhUakJqYld4cVR6Tk9NRmxYTld0WldFcHJUekpXYzFwWFRqQmpiV3hxSWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1046,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWc1pXTjBjbWxqTzNOMFlXNWtZWEprTzJWc1pXTjBjbWxqIiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1240",
                          },
                          {
                            name: "estimateHigh",
                            value: "1240",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Taxi",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1240,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1800",
                          },
                          {
                            name: "estimateHigh",
                            value: "1800",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:MjM5YjI3YTAtMDgzZS00YzZmLWJjZmQtODcwYjY3NTVkMmEzO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "239b27a0-083e-4c6f-bcfd-870b6755d2a3",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "VTC Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUV3BOTlZscVNUTlpWRUYwVFVSbmVscFRNREJaZWxwdFRGZEthbHB0VVhSUFJHTjNXV3BaTTA1VVZtdE5iVVY2VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "VTC Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6TWpNNVlqSTNZVEF0TURnelpTMDBZelptTFdKalptUXRPRGN3WWpZM05UVmtNbUV6TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2228",
                          },
                          {
                            name: "estimateHigh",
                            value: "2228",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO2V4ZWN1dGl2ZTtzdGFuZGFyZDtsdXh1cnk=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYzJSWWFERmpibXM5SWl3aVpYaHdhWEo1SWpvaU1qQXlNeTB3TVMweU5sUXhNem93Tnpvek5Dc3dNVG93TUNKOQ==",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2228,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0c2RYaDFjbms9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1591",
                          },
                          {
                            name: "estimateHigh",
                            value: "1591",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 1591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2340",
                          },
                          {
                            name: "estimateHigh",
                            value: "2340",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2340,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "352",
                          },
                          {
                            name: "estimateHigh",
                            value: "352",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:NmFjZWU3NjctYzU5Zi00MTU5LWE4OWItMjlhMTY0YmY1Y2Q3O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Delayed Allocation Fleet (Robot Fleet GB)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://karhoo.com/fleettcs/6acee767-c59f-4159-a89b-29a164bf5cd7",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZUbTFHYWxwWFZUTk9hbU4wV1hwVk5WcHBNREJOVkZVMVRGZEZORTlYU1hSTmFteG9UVlJaTUZsdFdURlpNbEV6VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Delayed Allocation Fleet (Robot Fleet GB)",
                        price: 352,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6Tm1GalpXVTNOamN0WXpVNVppMDBNVFU1TFdFNE9XSXRNamxoTVRZMFltWTFZMlEzTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "600",
                          },
                          {
                            name: "estimateHigh",
                            value: "600",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3RheGk7c3RhbmRhcmQ7dGF4aQ==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "2",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Taxi",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOU2FHVkhhemRqTTFKb1ltMVNhR050VVRka1IwWTBZVkU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 600,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNSaGVHazdjM1JoYm1SaGNtUTdkR0Y0YVE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2700",
                          },
                          {
                            name: "estimateHigh",
                            value: "2700",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O21wdjttcHY7Y2hpbGQtc2VhdA==",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpJeGQyUnFkSFJqU0ZrM1dUSm9jR0pIVVhSak1sWm9aRUU5UFNJc0ltVjRjR2x5ZVNJNklqSXdNak10TURFdE1qWlVNVE02TURjNk16UXJNREU2TURBaWZRPT0=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 2700,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzIxd2RqdHRjSFk3WTJocGJHUXRjMlZoZEE9PSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "2591",
                          },
                          {
                            name: "estimateHigh",
                            value: "2591",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:Y2M5NGRkMGUtOThjZS00NjNjLTlkYzQtM2ZlZDJlOTQ3ZGEyO21wdjttcHY7",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "6",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "MPV",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "MPV",
                          },
                          {
                            name: "FLEET_ID",
                            value: "cc94dd0e-98ce-463c-9dc4-3fed2e947da2",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global Taxi (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/0cc949b5bc06c6f3a2584fbdf4aff9c2.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVEpOTlU1SFVtdE5SMVYwVDFSb2FscFRNREJPYWs1cVRGUnNhMWw2VVhSTk1scHNXa1JLYkU5VVVUTmFSMFY1VHpJeGQyUnFkSFJqU0ZrM0lpd2laWGh3YVhKNUlqb2lNakF5TXkwd01TMHlObFF4TXpvd056b3pOQ3N3TVRvd01DSjk=",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global Taxi (Robot Fleet WWW)",
                        price: 2591,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WTJNNU5HUmtNR1V0T1RoalpTMDBOak5qTFRsa1l6UXRNMlpsWkRKbE9UUTNaR0V5TzIxd2RqdHRjSFk3IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1364",
                          },
                          {
                            name: "estimateHigh",
                            value: "1364",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1364,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1710",
                          },
                          {
                            name: "estimateHigh",
                            value: "1710",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:ZDU5MDVhM2QtZGE4MC00NWRjLWJkZjItOTAzZWE5ZWEyMjM1O3NhbG9vbjtzdGFuZGFyZDs=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "FIXED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "4",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Saloon",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "d5905a3d-da80-45dc-bdf2-903ea9ea2235",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Global PHV (Robot Fleet WWW)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.net/d/slas/80652d0064b468e23413ee3e66b35321.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXa1JWTlUxRVZtaE5NbEYwV2tkRk5FMURNREJPVjFKcVRGZEthMXBxU1hSUFZFRjZXbGRGTlZwWFJYbE5hazB4VHpOT2FHSkhPWFppYW5SNlpFZEdkVnBIUm5sYVJITTlJaXdpWlhod2FYSjVJam9pTWpBeU15MHdNUzB5TmxReE16b3dOem96TkNzd01Ub3dNQ0o5",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Global PHV (Robot Fleet WWW)",
                        price: 1710,
                        cur: "GBP",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WkRVNU1EVmhNMlF0WkdFNE1DMDBOV1JqTFdKa1pqSXRPVEF6WldFNVpXRXlNak0xTzNOaGJHOXZianR6ZEdGdVpHRnlaRHM9IiwiZXhwaXJ5IjoiMjAyMy0wMS0yNlQxMzowNzozNCswMTowMCJ9",
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "estimateLow",
                            value: "1800",
                          },
                          {
                            name: "estimateHigh",
                            value: "1800",
                          },
                          {
                            name: "PRODUCT_ID",
                            value:
                              "518abf93-9d71-11ed-bad4-46051c5d27a6:YmYxNjFlNzUtMDMxOC00NzJlLTgyOWYtOTRjNTUxN2VmZDZhO2V4ZWN1dGl2ZTtzdGFuZGFyZDtleGVjdXRpdmU=",
                          },
                          {
                            name: "OFFER_TYPE",
                            value: "METERED",
                          },
                          {
                            name: "PICKUP_TYPE",
                            value: "DEFAULT",
                          },
                          {
                            name: "AVAILABLE_SEATS",
                            value: "3",
                          },
                          {
                            name: "LUGGAGE_CAPACITY",
                            value: "2",
                          },
                          {
                            name: "VEHICLE_CLASS",
                            value: "Exec",
                          },
                          {
                            name: "VEHICLE_TYPE",
                            value: "STANDARD",
                          },
                          {
                            name: "FLEET_ID",
                            value: "bf161e75-0318-472e-829f-94c5517efd6a",
                          },
                          {
                            name: "FLEET_NAME",
                            value: "Taxi Fleet (Robot Fleet ES)",
                          },
                          {
                            name: "TERMS_AND_CONDITIONS_LINK",
                            value:
                              "https://cdn.karhoo.com/d/terms/fleets/d3b42f33-fbe6-4e63-9028-3fc7a56ada0e/index.html",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "taxi",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Taxi",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pYTJGeWFHOXZJaXdpZG1WeWMybHZiaUk2SWpFdU1UTWlMQ0p4ZFc5MFpYTkpaQ0k2SWpVeE9HRmlaamt6TFRsa056RXRNVEZsWkMxaVlXUTBMVFEyTURVeFl6VmtNamRoTmlJc0luRjFiM1JsU1dRaU9pSTFNVGhoWW1ZNU15MDVaRGN4TFRFeFpXUXRZbUZrTkMwME5qQTFNV00xWkRJM1lUWTZXVzFaZUU1cVJteE9lbFYwVFVSTmVFOURNREJPZWtwc1RGUm5lVTlYV1hSUFZGSnFUbFJWZUU0eVZtMWFSRnBvVHpKV05GcFhUakZrUjJ3eVdsUjBlbVJIUm5WYVIwWjVXa1IwYkdWSFZtcGtXRkp3WkcxVlBTSXNJbVY0Y0dseWVTSTZJakl3TWpNdE1ERXRNalpVTVRNNk1EYzZNelFyTURFNk1EQWlmUT09",
                          provider: "taxi",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Taxi Fleet (Robot Fleet ES)",
                        price: 1800,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoia2FyaG9vIiwidmVyc2lvbiI6IjEuMTMiLCJxdW90ZXNJZCI6IjUxOGFiZjkzLTlkNzEtMTFlZC1iYWQ0LTQ2MDUxYzVkMjdhNiIsInF1b3RlSWQiOiI1MThhYmY5My05ZDcxLTExZWQtYmFkNC00NjA1MWM1ZDI3YTY6WW1ZeE5qRmxOelV0TURNeE9DMDBOekpsTFRneU9XWXRPVFJqTlRVeE4yVm1aRFpoTzJWNFpXTjFkR2wyWlR0emRHRnVaR0Z5WkR0bGVHVmpkWFJwZG1VPSIsImV4cGlyeSI6IjIwMjMtMDEtMjZUMTM6MDc6MzQrMDE6MDAifQ==",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Karhoo Pricing",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Karhoo Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@T$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261315$202301261319$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDEtMjYiLCJyVGltZSI6IjEzOjE1IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9UQVhJIn0=",
          duration: "PT4M",
          checksum: "50c293c4_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  mcpData: [
                    {
                      name: "provider",
                      value: "taxi",
                    },
                    {
                      name: "providerName",
                      value: "Taxi",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "taxi:transient",
                    },
                    {
                      name: "externalId",
                      value: "transient",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:15:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:19:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@T|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|131500|131900|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$f@$f@$f@$t@0@40000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 105,
                        g: 3,
                        b: 194,
                        hex: "#6903C2",
                      },
                      res: "prod_taxi",
                    },
                    name: "Karhoo",
                    internalName: "Taxi",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Karhoo",
                type: "TAXI",
                duration: "PT4M",
                dist: 2333,
                GisRoute: {
                  Notes: {
                    Note: [
                      {
                        value:
                          "Desgraciadamente, este viaje no está disponible. Rogamos buscar conexiones alternativas.",
                        key: "text.connection.section.show.with.info.UNKNOWN",
                        type: "I",
                        txtN: "Desgraciadamente, este viaje no está disponible. Rogamos buscar conexiones alternativas.",
                      },
                    ],
                  },
                  dist: 2333,
                  durS: "PT4M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:15:00",
            date: "2023-01-26",
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:30:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.01098,
            type: "IMT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "REQUIRED",
                          },
                          {
                            name: "TARIFF_INFO",
                            value:
                              "eyJ2ZXJzaW9uIjoxLCJwYXlsb2FkIjpbeyJpZCI6InZfM25nejlrazFleDZudjI3MmQ2NGgiLCJuYW1lIjoia2lja19zY29vdGVyIHRhcmlmZiIsImN1cnJlbmN5IjoiRVVSIiwiYmFzZUNvc3QiOiIwLjAwIiwiY29zdFBlclNlY29uZCI6W3siYW1vdW50IjoiMC4wNSIsInJhbmdlIjp7fSwiaW50ZXJ2YWwiOjYwfV19XX0=",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVieS1lc2Nvb3RlciIsInZlcnNpb24iOiIxLjEyIiwidmVoaWNsZUlkIjoidl8zbmd6OWtrMWV4Nm52MjcyZDY0aCJ9",
                          },
                          {
                            name: "PROVIDER_ID",
                            value: "reby-escooter",
                          },
                          {
                            name: "PROVIDER_NAME",
                            value: "Reby eScooter",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WaWVTMWxjMk52YjNSbGNpSXNJblpsY25OcGIyNGlPaUl4TGpFeUlpd2lkbVZvYVdOc1pVbGtJam9pZGw4emJtZDZPV3RyTVdWNE5tNTJNamN5WkRZMGFDSjk=",
                          provider: "reby-escooter",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "kick_scooter tariff",
                        price: 60,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVieS1lc2Nvb3RlciIsInZlcnNpb24iOiIxLjEyIiwidmVoaWNsZUlkIjoidl8zbmd6OWtrMWV4Nm52MjcyZDY0aCJ9",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Reby eScooter",
                  },
                  {
                    name: "secId",
                    value: "C-0:001",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:001",
                  },
                  {
                    name: "secIds",
                    value: "C-0:001",
                  },
                ],
                name: "Reby eScooter",
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶G@F$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@a=128@$202301261315$202301261318$$$1$$$$$$§G@B$A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261318$202301261330$$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KRCC¶#VE#1#¶PC¶eyJyRGF0ZSI6IjIwMjMtMDEtMjYiLCJyVGltZSI6IjEzOjE1IiwickRpciI6IkYiLCJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSIn0=",
          duration: "PT15M",
          checksum: "27847e7d_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:15:00",
                  date: "2023-01-26",
                },
                Destination: {
                  Notes: {
                    Note: [
                      {
                        value: "kick_scooter",
                        key: "VEHICLE_TYPE",
                        type: "W",
                        txtN: "kick_scooter",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "reby-escooter",
                    },
                    {
                      name: "providerName",
                      value: "Reby eScooter",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "reby-escooter:bookee_v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "externalId",
                      value: "v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Barcelona, 10 Vinos.Com",
                  type: "MCP",
                  id: "A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h@S=2@",
                  extId:
                    "%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h",
                  lon: 2.175956,
                  lat: 41.405447,
                  time: "13:18:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@|26012023|131500|131800|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 229,
                GisRoute: {
                  dist: 229,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  Notes: {
                    Note: [
                      {
                        value: "kick_scooter",
                        key: "VEHICLE_TYPE",
                        type: "W",
                        txtN: "kick_scooter",
                      },
                    ],
                  },
                  mcpData: [
                    {
                      name: "provider",
                      value: "reby-escooter",
                    },
                    {
                      name: "providerName",
                      value: "Reby eScooter",
                    },
                    {
                      name: "availability",
                      value: "A",
                    },
                    {
                      name: "mcpId",
                      value: "reby-escooter:bookee_v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "externalId",
                      value: "v_3ngz9kk1ex6nv272d64h",
                    },
                    {
                      name: "mcpType",
                      value: "V",
                    },
                  ],
                  name: "Barcelona, 10 Vinos.Com",
                  type: "MCP",
                  id: "A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h@S=2@",
                  extId:
                    "%23mcp%3AV%3Areby-escooter%3Abookee_v_3ngz9kk1ex6nv272d64h",
                  lon: 2.175956,
                  lat: 41.405447,
                  time: "13:18:00",
                  date: "2023-01-26",
                  mcp: true,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:30:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@B|A=2048@O=Barcelona, 10 Vinos.Com@X=2175956@Y=41405447@u=3@L=JTIzbWNwJTNBViUzQXJlYnktZXNjb290ZXIlM0Fib29rZWVfdl8zbmd6OWtrMWV4Nm52MjcyZDY0aA==@S=2@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|131800|133000|ft|ft@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tf@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 97,
                        g: 62,
                        b: 234,
                        hex: "#613EEA",
                      },
                      res: "prod_reby",
                    },
                    name: "Reby eScooter",
                    internalName: "Reby eScooter",
                  },
                ],
                id: "C-0:001",
                idx: 1,
                name: "Reby eScooter",
                type: "BIKE",
                duration: "PT12M",
                dist: 2678,
                GisRoute: {
                  dist: 2678,
                  durS: "PT12M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:17:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:30:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.090214,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-0:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
            unsharp: true,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$202301261317$202301261322$TMB   L2$$1$$$$$$§W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261322$202301261326$$$1$$$$$$§G@F$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261326$202301261330$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT13M",
          rtDuration: "PT13M",
          checksum: "3f474102_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:17:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:22:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4670",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 14,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:17:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:18:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                id: "C-0:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT5M",
                dist: 2098,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  time: "13:22:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:30:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261322$202301261326$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Metro Pg de Gràcia, Barcelona@X=2167524@Y=41389923@U=80@L=100002429@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|132600|133000|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:002&001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 290,
                GisRoute: {
                  dist: 290,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:17:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:32:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.136052,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-1:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-1:000 C-1:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Universitat, Barcelona@L=100000038@a=128@$202301261317$202301261323$TMB   L2$$1$$$$$$§W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261323$202301261324$$$1$$$$$$§T$A=1@O=Universitat, Barcelona@L=100000020@a=128@$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$202301261324$202301261325$TMB   L1$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261325$202301261329$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261329$202301261332$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT15M",
          rtDuration: "PT15M",
          checksum: "f7e51e25_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:17:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:23:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4670",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 15,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:17:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:18:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      depTime: "13:22:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                      extId: "100000038",
                      routeIdx: 15,
                      lon: 2.16391,
                      lat: 41.384772,
                      arrTime: "13:23:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32880#TA#0#DA#260123#1S#100000053#1T#1259#LS#100000036#LT#1327#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1259#TO#100000036#TT#1327#",
                },
                id: "C-1:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT6M",
                dist: 2729,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                    {
                      order: 4,
                      lon: 2.16391,
                      lat: 41.384772,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  time: "13:23:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261323$202301261324$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 120,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.16391, 41.384772, 2.164288, 41.385815],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 120,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:25:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37094#TA#3#DA#260123#1S#100000001#1T#1302#LS#100000035#LT#1348#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1302#TO#100000035#TT#1348#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 206,
                        g: 17,
                        b: 38,
                        hex: "#CE1126",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L1",
                    internalName: "TMB   L1",
                    displayNumber: "L1",
                    num: "1173",
                    line: "L1",
                    lineId: "1.1.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 14,
                    routeIdxTo: 15,
                    matchId: "L1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                      extId: "100000020",
                      routeIdx: 14,
                      lon: 2.164288,
                      lat: 41.385815,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                      depDir: "Fondo",
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                      extId: "60000021",
                      routeIdx: 15,
                      lon: 2.168998,
                      lat: 41.387487,
                      arrTime: "13:25:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37094#TA#3#DA#260123#1S#100000001#1T#1302#LS#100000035#LT#1348#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1302#TO#100000035#TT#1348#",
                },
                id: "C-1:002",
                idx: 2,
                name: "TMB L1",
                number: "L1",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Fondo",
                directionFlag: "0",
                duration: "PT1M",
                dist: 435,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.164288,
                      lat: 41.385815,
                    },
                    {
                      order: 1,
                      lon: 2.168998,
                      lat: 41.387487,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  time: "13:25:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:32:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261325$202301261329$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|132900|133200|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT7M",
                dist: 186,
                GisRoute: {
                  dist: 186,
                  durS: "PT7M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
            extId: "100000116",
            lon: 2.173619,
            lat: 41.403838,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:18:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:35:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.128269,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.321685,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-2:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-2:000 C-2:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000116@a=128@$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$202301261318$202301261320$TMB   L5$$1$$$$$$§W$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$202301261320$202301261321$$$1$$$$$$§T$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$202301261324$202301261327$TMB   L3$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261327$202301261332$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261332$202301261335$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT17M",
          rtDuration: "PT17M",
          checksum: "6c37cb62_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
                  extId: "100000116",
                  lon: 2.173619,
                  lat: 41.403838,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:18:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                  extId: "100000114",
                  lon: 2.158831,
                  lat: 41.394436,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "13:20:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#36305#TA#1#DA#260123#1S#100000127#1T#1258#LS#30000102#LT#1341#PU#80#RT#1#CA#TMB#ZE#L5#ZB#TMB   L5#PC#6#FR#100000127#FT#1258#TO#30000102#TT#1341#",
                },
                Freq: {
                  waitMinimum: 3,
                  waitMaximum: 4,
                  alternativeCount: 37,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 0,
                        g: 90,
                        b: 151,
                        hex: "#005A97",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L5",
                    internalName: "TMB   L5",
                    displayNumber: "L5",
                    num: "8708",
                    line: "L5",
                    lineId: "1.5.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "L5",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2173619@Y=41403838@U=80@L=100000116@",
                      extId: "100000116",
                      routeIdx: 11,
                      lon: 2.173619,
                      lat: 41.403838,
                      depTime: "13:18:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Cornellà Centre",
                    },
                    {
                      name: "Verdaguer, Barcelona",
                      id: "A=1@O=Verdaguer, Barcelona@X=2167092@Y=41398948@U=80@L=100000115@",
                      extId: "100000115",
                      routeIdx: 12,
                      lon: 2.167092,
                      lat: 41.398948,
                      depTime: "13:19:00",
                      depDate: "2023-01-26",
                      arrTime: "13:19:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Verdaguer, Barcelona@X=2168063@Y=41400369@U=80@L=100003224@",
                      mainMastExtId: "100003224",
                      mainMastLon: 2.168063,
                      mainMastLat: 41.400369,
                    },
                    {
                      name: "Diagonal, Barcelona",
                      id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                      extId: "100000114",
                      routeIdx: 13,
                      lon: 2.158831,
                      lat: 41.394436,
                      arrTime: "13:20:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                      mainMastExtId: "100003201",
                      mainMastLon: 2.160045,
                      mainMastLat: 41.395892,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#36305#TA#1#DA#260123#1S#100000127#1T#1258#LS#30000102#LT#1341#PU#80#RT#1#CA#TMB#ZE#L5#ZB#TMB   L5#PC#6#FR#100000127#FT#1258#TO#30000102#TT#1341#",
                },
                id: "C-2:000",
                idx: 0,
                name: "TMB L5",
                number: "L5",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Cornellà Centre",
                directionFlag: "1",
                duration: "PT2M",
                dist: 1623,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.173619,
                      lat: 41.403838,
                    },
                    {
                      order: 1,
                      lon: 2.167092,
                      lat: 41.398948,
                    },
                    {
                      order: 2,
                      lon: 2.158831,
                      lat: 41.394436,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2158831@Y=41394436@U=80@L=100000114@",
                  extId: "100000114",
                  lon: 2.158831,
                  lat: 41.394436,
                  time: "13:20:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                Destination: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                  extId: "100000068",
                  lon: 2.160045,
                  lat: 41.395892,
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Diagonal, Barcelona@L=100000114@a=128@$A=1@O=Diagonal, Barcelona@L=100000068@a=128@$202301261320$202301261321$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 191,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.158831, 41.394436, 2.160045, 41.395892],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 191,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Diagonal, Barcelona",
                  type: "ST",
                  id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                  extId: "100000068",
                  lon: 2.160045,
                  lat: 41.395892,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:24:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                  mainMastExtId: "100003201",
                  mainMastLon: 2.160045,
                  mainMastLat: 41.395892,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                  extId: "30000066",
                  lon: 2.170095,
                  lat: 41.386318,
                  routeIdx: 13,
                  prognosisType: "PROGNOSED",
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#33791#TA#0#DA#260123#1S#100000079#1T#1304#LS#100000054#LT#1346#PU#80#RT#1#CA#TMB#ZE#L3#ZB#TMB   L3#PC#6#FR#100000079#FT#1304#TO#100000054#TT#1346#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 27,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 30,
                        g: 181,
                        b: 58,
                        hex: "#1EB53A",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L3",
                    internalName: "TMB   L3",
                    displayNumber: "L3",
                    num: "5894",
                    line: "L3",
                    lineId: "1.3.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 13,
                    matchId: "L3",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Diagonal, Barcelona",
                      id: "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100000068@",
                      extId: "100000068",
                      routeIdx: 11,
                      lon: 2.160045,
                      lat: 41.395892,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Diagonal, Barcelona@X=2160045@Y=41395892@U=80@L=100003201@",
                      mainMastExtId: "100003201",
                      mainMastLon: 2.160045,
                      mainMastLat: 41.395892,
                      depDir: "Zona Universitària",
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2165349@Y=41391604@U=80@L=30000067@",
                      extId: "30000067",
                      routeIdx: 12,
                      lon: 2.165349,
                      lat: 41.391604,
                      depTime: "13:26:00",
                      depDate: "2023-01-26",
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                      extId: "30000066",
                      routeIdx: 13,
                      lon: 2.170095,
                      lat: 41.386318,
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#33791#TA#0#DA#260123#1S#100000079#1T#1304#LS#100000054#LT#1346#PU#80#RT#1#CA#TMB#ZE#L3#ZB#TMB   L3#PC#6#FR#100000079#FT#1304#TO#100000054#TT#1346#",
                },
                id: "C-2:002",
                idx: 2,
                name: "TMB L3",
                number: "L3",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Zona Universitària",
                directionFlag: "1",
                duration: "PT3M",
                dist: 1360,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.160045,
                      lat: 41.395892,
                    },
                    {
                      order: 1,
                      lon: 2.165349,
                      lat: 41.391604,
                    },
                    {
                      order: 2,
                      lon: 2.170095,
                      lat: 41.386318,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=30000066@",
                  extId: "30000066",
                  lon: 2.170095,
                  lat: 41.386318,
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:35:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=30000066@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261327$202301261332$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133200|133500|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 336,
                GisRoute: {
                  dist: 336,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            extId: "100003180",
            lon: 2.175102,
            lat: 41.403982,
            time: "13:18:00",
            date: "2023-01-26",
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:42:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.220088,
            type: "PUT",
            rating: 2,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 8,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdStart",
                    value: "C-3:001",
                  },
                  {
                    name: "LastSectIdx",
                    value: "1",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-3:001",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-3:001",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 1,
                toLegId: 1,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 3,
          tripId: "C-3",
          ctxRecon:
            "¶HKI¶G@F$A=1@O=Sagrada Família, Barcelona@L=100003180@a=128@$A=1@O=Mallorca - Marina, Barcelona@L=100000396@a=128@$202301261318$202301261320$$$1$$$$$$§T$A=1@O=Mallorca - Marina, Barcelona@L=100000396@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261320$202301261339$TMB  D50$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261339$202301261342$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT24M",
          rtDuration: "PT24M",
          checksum: "b1cf2a3c_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  extId: "100003180",
                  lon: 2.175102,
                  lat: 41.403982,
                  time: "13:18:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Mallorca - Marina, Barcelona",
                  type: "ST",
                  id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                  extId: "100000396",
                  lon: 2.175938,
                  lat: 41.403955,
                  time: "13:20:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@|A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@|26012023|131800|132000|bf|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:000",
                idx: 0,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT2M",
                dist: 81,
                GisRoute: {
                  dist: 81,
                  durS: "PT2M",
                  dirGeo: 0,
                },
              },
              {
                Origin: {
                  name: "Mallorca - Marina, Barcelona",
                  type: "ST",
                  id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                  extId: "100000396",
                  lon: 2.175938,
                  lat: 41.403955,
                  routeIdx: 29,
                  prognosisType: "PROGNOSED",
                  time: "13:20:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                  extId: "800000330",
                  lon: 2.169313,
                  lat: 41.387757,
                  routeIdx: 37,
                  prognosisType: "PROGNOSED",
                  time: "13:39:00",
                  date: "2023-01-26",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#24400#TA#1#DA#260123#1S#100000634#1T#1236#LS#100002183#LT#1353#PU#80#RT#1#CA#TMB#ZE#D50#ZB#TMB  D50#PC#8#FR#100000634#FT#1236#TO#100002183#TT#1353#",
                },
                Freq: {
                  waitMinimum: 8,
                  waitMaximum: 10,
                  alternativeCount: 14,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 16,
                        b: 126,
                        hex: "#93107E",
                      },
                      res: "prod_bus",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB D50",
                    internalName: "TMB  D50",
                    displayNumber: "D50",
                    num: "34241",
                    line: "D50",
                    lineId: "2.250.3051(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "8",
                    cls: "256",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 29,
                    routeIdxTo: 37,
                    matchId: "D50",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Mallorca - Marina, Barcelona",
                      id: "A=1@O=Mallorca - Marina, Barcelona@X=2175938@Y=41403955@U=80@L=100000396@",
                      extId: "100000396",
                      routeIdx: 29,
                      lon: 2.175938,
                      lat: 41.403955,
                      depTime: "13:20:00",
                      depDate: "2023-01-26",
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Mallorca - Nàpols, Barcelona",
                      id: "A=1@O=Mallorca - Nàpols, Barcelona@X=2172351@Y=41401276@U=80@L=100001876@",
                      extId: "100001876",
                      routeIdx: 30,
                      lon: 2.172351,
                      lat: 41.401276,
                      depTime: "13:22:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de Sant Joan - Pl Mossèn Jacint Verdaguer, Barc",
                      id: "A=1@O=Pg de Sant Joan - Pl Mossèn Jacint Verdaguer, Barc@X=2170427@Y=41398625@U=80@L=100000554@",
                      extId: "100000554",
                      routeIdx: 31,
                      lon: 2.170427,
                      lat: 41.398625,
                      depTime: "13:25:00",
                      depDate: "2023-01-26",
                      arrTime: "13:25:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg Sant Joan - Consell de Cent, Barcelona",
                      id: "A=1@O=Pg Sant Joan - Consell de Cent, Barcelona@X=2172522@Y=41397043@U=80@L=100001921@",
                      extId: "100001921",
                      routeIdx: 32,
                      lon: 2.172522,
                      lat: 41.397043,
                      depTime: "13:27:00",
                      depDate: "2023-01-26",
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de Sant Joan - Diputació, Barcelona",
                      id: "A=1@O=Pg de Sant Joan - Diputació, Barcelona@X=2174670@Y=41395416@U=80@L=100001738@",
                      extId: "100001738",
                      routeIdx: 33,
                      lon: 2.17467,
                      lat: 41.395416,
                      depTime: "13:28:00",
                      depDate: "2023-01-26",
                      arrTime: "13:28:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pg de St Joan - Ausiàs March, Barcelona",
                      id: "A=1@O=Pg de St Joan - Ausiàs March, Barcelona@X=2178680@Y=41392404@U=80@L=800001800@",
                      extId: "800001800",
                      routeIdx: 34,
                      lon: 2.17868,
                      lat: 41.392404,
                      depTime: "13:32:00",
                      depDate: "2023-01-26",
                      arrTime: "13:32:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Ronda Sant Pere - Girona, Barcelona",
                      id: "A=1@O=Ronda Sant Pere - Girona, Barcelona@X=2175965@Y=41390247@U=80@L=100000542@",
                      extId: "100000542",
                      routeIdx: 35,
                      lon: 2.175965,
                      lat: 41.390247,
                      depTime: "13:34:00",
                      depDate: "2023-01-26",
                      arrTime: "13:34:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Metro Urquinaona, Barcelona",
                      id: "A=1@O=Metro Urquinaona, Barcelona@X=2172783@Y=41389024@U=80@L=100000221@",
                      extId: "100000221",
                      routeIdx: 36,
                      lon: 2.172783,
                      lat: 41.389024,
                      depTime: "13:36:00",
                      depDate: "2023-01-26",
                      arrTime: "13:36:00",
                      arrDate: "2023-01-26",
                    },
                    {
                      name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                      id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                      extId: "800000330",
                      routeIdx: 37,
                      lon: 2.169313,
                      lat: 41.387757,
                      arrTime: "13:39:00",
                      arrDate: "2023-01-26",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#24400#TA#1#DA#260123#1S#100000634#1T#1236#LS#100002183#LT#1353#PU#80#RT#1#CA#TMB#ZE#D50#ZB#TMB  D50#PC#8#FR#100000634#FT#1236#TO#100002183#TT#1353#",
                },
                id: "C-3:001",
                idx: 1,
                name: "TMB D50",
                number: "D50",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT19M",
                dist: 2684,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175938,
                      lat: 41.403955,
                    },
                    {
                      order: 1,
                      lon: 2.172351,
                      lat: 41.401276,
                    },
                    {
                      order: 2,
                      lon: 2.170427,
                      lat: 41.398625,
                    },
                    {
                      order: 3,
                      lon: 2.172522,
                      lat: 41.397043,
                    },
                    {
                      order: 4,
                      lon: 2.17467,
                      lat: 41.395416,
                    },
                    {
                      order: 5,
                      lon: 2.17868,
                      lat: 41.392404,
                    },
                    {
                      order: 6,
                      lon: 2.175965,
                      lat: 41.390247,
                    },
                    {
                      order: 7,
                      lon: 2.172783,
                      lat: 41.389024,
                    },
                    {
                      order: 8,
                      lon: 2.169313,
                      lat: 41.387757,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Pl Catalunya - Pg de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@",
                  extId: "800000330",
                  lon: 2.169313,
                  lat: 41.387757,
                  time: "13:39:00",
                  date: "2023-01-26",
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:42:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133900|134200|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-3:002",
                idx: 2,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 146,
                GisRoute: {
                  dist: 146,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:21:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:34:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.090214,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-4:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-4:000",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-4:000",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
            unsharp: true,
          },
          idx: 4,
          tripId: "C-4",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$202301261321$202301261326$TMB   L2$$1$$$$$$§W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261326$202301261330$$$1$$$$$$§G@F$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261330$202301261334$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT13M",
          rtDuration: "PT13M",
          checksum: "411616bc_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:26:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4706",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 14,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:21:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:23:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      arrTime: "13:24:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                id: "C-4:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT5M",
                dist: 2098,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Passeig de Gràcia, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                  extId: "40000039",
                  lon: 2.168243,
                  lat: 41.38942,
                  time: "13:26:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                  mainMastExtId: "100001721",
                  mainMastLon: 2.16756,
                  mainMastLat: 41.390139,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:34:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Passeig de Gràcia, Barcelona@L=40000039@a=128@$A=1@O=Metro Pg de Gràcia, Barcelona@L=100002429@a=128@$202301261326$202301261330$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Metro Pg de Gràcia, Barcelona@X=2167524@Y=41389923@U=80@L=100002429@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133000|133400|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-4:002&001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT8M",
                dist: 290,
                GisRoute: {
                  dist: 290,
                  durS: "PT8M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Sagrada Família, Barcelona",
            type: "ST",
            id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
            extId: "100000042",
            lon: 2.175102,
            lat: 41.403982,
            routeIdx: 11,
            prognosisType: "PROGNOSED",
            time: "13:21:00",
            date: "2023-01-26",
            hasMainMast: true,
            mainMastId:
              "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
            mainMastExtId: "100003180",
            mainMastLon: 2.175102,
            mainMastLat: 41.403982,
          },
          Destination: {
            name: "Passeig de Gràcia/C. de Casp, Barcelona",
            type: "ST",
            id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
            extId: "100013002",
            lon: 2.169268,
            lat: 41.388647,
            time: "13:36:00",
            date: "2023-01-26",
          },
          Eco: {
            co2: 0.136052,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 0.330161,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2022-12-26",
              planningPeriodEnd: "2023-10-22",
              sDaysR: "no cada día",
              sDaysI:
                "26. Ene hasta 13. Sep 2023 Lu - Vi; no 7., 10. Abr, 1. May, 5. Jun, 15. Ago, 11. Sep",
              sDaysB:
                "0000000F9F3E7CF9F3E7CF9F3C3CF9F1E7CF9F3E3CF9F3E7CF9F3E7CF973E7CF8C0000000000",
            },
          ],
          Freq: {
            waitMinimum: 4,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete de TMB válido para realizar un viaje en metro (excepto en las estaciones de metro Aeroport T1 y Aeroport T2 de la línea L9 Sud), en bus o en el funicular de Montjuïc. Es un billete unipersonal no integrado.",
                          },
                        ],
                        name: "Billete sencillo de un viaje para un adulto",
                        price: 240,
                        cur: "EUR",
                      },
                    ],
                    param: [
                      {
                        name: "hasSamplePrice",
                        value: "1",
                      },
                    ],
                  },
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "ProductRemark",
                            value:
                              "Billete unipersonal de metro no integrado que permite realizar un viaje entre las paradas Aeroport T1 y Aeroport T2 de la línea L9 Sud y el resto de la red de metro.",
                          },
                        ],
                        name: "Billete sencillo de un viaje al aeropuerto para un adulto",
                        price: 515,
                        cur: "EUR",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "Supplier",
                    value: "006_tmb_barce",
                  },
                  {
                    name: "DatasetVersion",
                    value: "2022-1",
                  },
                  {
                    name: "PSetName",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "OrigZone",
                    value: "33",
                  },
                  {
                    name: "DestZone",
                    value: "33",
                  },
                  {
                    name: "PSetDesc",
                    value: "Zona 1",
                  },
                  {
                    name: "FirstSectIdx",
                    value: "0",
                  },
                  {
                    name: "secIdStart",
                    value: "C-5:000",
                  },
                  {
                    name: "LastSectIdx",
                    value: "2",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-5:002",
                  },
                  {
                    name: "NAME",
                    value:
                      "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                  },
                  {
                    name: "DESCRIPTION",
                    value: "Zona 1",
                  },
                  {
                    name: "TariffURL",
                    value: "https://www.tmb.cat/es/tarifas-metro-bus-barcelona",
                  },
                  {
                    name: "secIds",
                    value: "C-5:000 C-5:002",
                  },
                ],
                name: "Tarifas de autobús y metro de Barcelona (TMB) - 1 zona",
                desc: "Zona 1",
                fromLegId: 0,
                toLegId: 2,
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            convenient: true,
            hintCode: 0,
            unsharp: true,
          },
          idx: 5,
          tripId: "C-5",
          ctxRecon:
            "¶HKI¶T$A=1@O=Sagrada Família, Barcelona@L=100000042@a=128@$A=1@O=Universitat, Barcelona@L=100000038@a=128@$202301261321$202301261327$TMB   L2$$1$$$$$$§W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261327$202301261328$$$1$$$$$$§T$A=1@O=Universitat, Barcelona@L=100000020@a=128@$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$202301261328$202301261329$TMB   L1$$1$$$$$$§W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261329$202301261333$$$1$$$$$$§G@F$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@L=100013002@a=128@$202301261333$202301261336$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9UQVhJX1BUX1NDT09URVIifQ==",
          duration: "PT15M",
          rtDuration: "PT15M",
          checksum: "2299c4a7_3",
          transferCount: 1,
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Sagrada Família, Barcelona",
                  type: "ST",
                  id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                  extId: "100000042",
                  lon: 2.175102,
                  lat: 41.403982,
                  routeIdx: 11,
                  prognosisType: "PROGNOSED",
                  time: "13:21:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                  mainMastExtId: "100003180",
                  mainMastLon: 2.175102,
                  mainMastLat: 41.403982,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 147,
                        g: 36,
                        b: 143,
                        hex: "#93248F",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L2",
                    internalName: "TMB   L2",
                    displayNumber: "L2",
                    num: "4706",
                    line: "L2",
                    lineId: "1.2.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 11,
                    routeIdxTo: 15,
                    matchId: "L2",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Sagrada Família, Barcelona",
                      id: "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100000042@",
                      extId: "100000042",
                      routeIdx: 11,
                      lon: 2.175102,
                      lat: 41.403982,
                      depTime: "13:21:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Sagrada Família, Barcelona@X=2175102@Y=41403982@U=80@L=100003180@",
                      mainMastExtId: "100003180",
                      mainMastLon: 2.175102,
                      mainMastLat: 41.403982,
                      depDir: "Paral·lel",
                    },
                    {
                      name: "Monumental, Barcelona",
                      id: "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100000041@",
                      extId: "100000041",
                      routeIdx: 12,
                      lon: 2.179462,
                      lat: 41.400521,
                      depTime: "13:23:00",
                      depDate: "2023-01-26",
                      arrTime: "13:22:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Monumental, Barcelona@X=2179462@Y=41400521@U=80@L=100003179@",
                      mainMastExtId: "100003179",
                      mainMastLon: 2.179462,
                      mainMastLat: 41.400521,
                    },
                    {
                      name: "Tetuan, Barcelona",
                      id: "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100000040@",
                      extId: "100000040",
                      routeIdx: 13,
                      lon: 2.17556,
                      lat: 41.394885,
                      depTime: "13:24:00",
                      depDate: "2023-01-26",
                      arrTime: "13:24:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Tetuan, Barcelona@X=2175560@Y=41394885@U=80@L=100003178@",
                      mainMastExtId: "100003178",
                      mainMastLon: 2.17556,
                      mainMastLat: 41.394885,
                    },
                    {
                      name: "Passeig de Gràcia, Barcelona",
                      id: "A=1@O=Passeig de Gràcia, Barcelona@X=2168243@Y=41389420@U=80@L=40000039@",
                      extId: "40000039",
                      routeIdx: 14,
                      lon: 2.168243,
                      lat: 41.38942,
                      depTime: "13:26:00",
                      depDate: "2023-01-26",
                      arrTime: "13:26:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Pg de Gràcia - Gran Via, Barcelona@X=2167560@Y=41390139@U=80@L=100001721@",
                      mainMastExtId: "100001721",
                      mainMastLon: 2.16756,
                      mainMastLat: 41.390139,
                    },
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                      extId: "100000038",
                      routeIdx: 15,
                      lon: 2.16391,
                      lat: 41.384772,
                      arrTime: "13:27:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#32902#TA#0#DA#260123#1S#100000053#1T#1303#LS#100000036#LT#1331#PU#80#RT#1#CA#TMB#ZE#L2#ZB#TMB   L2#PC#6#FR#100000053#FT#1303#TO#100000036#TT#1331#",
                },
                id: "C-5:000",
                idx: 0,
                name: "TMB L2",
                number: "L2",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Paral·lel",
                directionFlag: "1",
                duration: "PT6M",
                dist: 2729,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.175102,
                      lat: 41.403982,
                    },
                    {
                      order: 1,
                      lon: 2.179462,
                      lat: 41.400521,
                    },
                    {
                      order: 2,
                      lon: 2.17556,
                      lat: 41.394885,
                    },
                    {
                      order: 3,
                      lon: 2.168243,
                      lat: 41.38942,
                    },
                    {
                      order: 4,
                      lon: 2.16391,
                      lat: 41.384772,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100000038@",
                  extId: "100000038",
                  lon: 2.16391,
                  lat: 41.384772,
                  time: "13:27:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  time: "13:28:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Universitat, Barcelona@L=100000038@a=128@$A=1@O=Universitat, Barcelona@L=100000020@a=128@$202301261327$202301261328$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-5:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT1M",
                dist: 120,
                GisRoute: {
                  polylineGroup: {
                    polylineDesc: [
                      {
                        crd: [2.16391, 41.384772, 2.164288, 41.385815],
                        delta: false,
                        dim: 2,
                        crdEncS: "NN",
                      },
                    ],
                  },
                  dist: 120,
                  durS: "PT1M",
                  dirGeo: 6,
                },
              },
              {
                Origin: {
                  name: "Universitat, Barcelona",
                  type: "ST",
                  id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                  extId: "100000020",
                  lon: 2.164288,
                  lat: 41.385815,
                  routeIdx: 14,
                  prognosisType: "PROGNOSED",
                  time: "13:28:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                  mainMastExtId: "100003159",
                  mainMastLon: 2.16391,
                  mainMastLat: 41.384772,
                },
                Destination: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  routeIdx: 15,
                  prognosisType: "PROGNOSED",
                  time: "13:29:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37264#TA#3#DA#260123#1S#100000001#1T#1307#LS#100000035#LT#1352#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1307#TO#100000035#TT#1352#",
                },
                Freq: {
                  waitMinimum: 4,
                  waitMaximum: 5,
                  alternativeCount: 30,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 206,
                        g: 17,
                        b: 38,
                        hex: "#CE1126",
                      },
                      res: "prod_sub",
                    },
                    operatorInfo: {
                      name: "TMB",
                      nameS: "TMB",
                      nameN: "TMB",
                      nameL: "TMB",
                    },
                    name: "TMB L1",
                    internalName: "TMB   L1",
                    displayNumber: "L1",
                    num: "1191",
                    line: "L1",
                    lineId: "1.1.1(DEFAULT_AGENCY_gtfs)006",
                    catOut: "TMB",
                    catIn: "TMB",
                    catCode: "6",
                    cls: "64",
                    catOutS: "TMB",
                    catOutL: "TMB",
                    operatorCode: "TMB",
                    operator: "TMB",
                    admin: "006000",
                    routeIdxFrom: 14,
                    routeIdxTo: 15,
                    matchId: "L1",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Universitat, Barcelona",
                      id: "A=1@O=Universitat, Barcelona@X=2164288@Y=41385815@U=80@L=100000020@",
                      extId: "100000020",
                      routeIdx: 14,
                      lon: 2.164288,
                      lat: 41.385815,
                      depTime: "13:28:00",
                      depDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Universitat, Barcelona@X=2163910@Y=41384772@U=80@L=100003159@",
                      mainMastExtId: "100003159",
                      mainMastLon: 2.16391,
                      mainMastLat: 41.384772,
                      depDir: "Fondo",
                    },
                    {
                      name: "Catalunya, Barcelona",
                      id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                      extId: "60000021",
                      routeIdx: 15,
                      lon: 2.168998,
                      lat: 41.387487,
                      arrTime: "13:29:00",
                      arrDate: "2023-01-26",
                      hasMainMast: true,
                      mainMastId:
                        "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                      mainMastExtId: "900003160",
                      mainMastLon: 2.170095,
                      mainMastLat: 41.386318,
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-01-26",
                  ref: "2|#VN#1#ST#1674655675#PI#0#ZI#37264#TA#3#DA#260123#1S#100000001#1T#1307#LS#100000035#LT#1352#PU#80#RT#1#CA#TMB#ZE#L1#ZB#TMB   L1#PC#6#FR#100000001#FT#1307#TO#100000035#TT#1352#",
                },
                id: "C-5:002",
                idx: 2,
                name: "TMB L1",
                number: "L1",
                category: "TMB",
                type: "JNY",
                reachable: true,
                direction: "Fondo",
                directionFlag: "0",
                duration: "PT1M",
                dist: 435,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: 2.164288,
                      lat: 41.385815,
                    },
                    {
                      order: 1,
                      lon: 2.168998,
                      lat: 41.387487,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Catalunya, Barcelona",
                  type: "ST",
                  id: "A=1@O=Catalunya, Barcelona@X=2168998@Y=41387487@U=80@L=60000021@",
                  extId: "60000021",
                  lon: 2.168998,
                  lat: 41.387487,
                  time: "13:29:00",
                  date: "2023-01-26",
                  hasMainMast: true,
                  mainMastId:
                    "A=1@O=Catalunya, Barcelona@X=2170095@Y=41386318@U=80@L=900003160@",
                  mainMastExtId: "900003160",
                  mainMastLon: 2.170095,
                  mainMastLat: 41.386318,
                },
                Destination: {
                  name: "Passeig de Gràcia/C. de Casp, Barcelona",
                  type: "ST",
                  id: "A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@",
                  extId: "100013002",
                  lon: 2.169268,
                  lat: 41.388647,
                  time: "13:36:00",
                  date: "2023-01-26",
                },
                GisRef: {
                  ref: "H|1|W$A=1@O=Catalunya, Barcelona@L=60000021@a=128@$A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@L=800000330@a=128@$202301261329$202301261333$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#±G|1|G@F|A=1@O=Pl Catalunya - Pg de Gràcia, Barcelona@X=2169313@Y=41387757@U=80@L=800000330@|A=1@O=Passeig de Gràcia/C. de Casp, Barcelona@X=2169268@Y=41388647@U=80@L=100013002@|26012023|133300|133600|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@5000@120@1@100@1@@0@@@@profile=cooltra,reby-escooter*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@0@25000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-5:004&003",
                idx: 3,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT7M",
                dist: 186,
                GisRoute: {
                  dist: 186,
                  durS: "PT7M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
      ],
    },
  };
}

export function getLongMover() {
  return {
    data: {
      Trip: [
        {
          Origin: {
            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
            type: "ST",
            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
            extId: "100060000",
            lon: -3.69089,
            lat: 40.40644,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "14:30:00",
            date: "2023-11-28",
          },
          Destination: {
            name: "Barcelona, Barcelona Sants Train Station",
            type: "POI",
            id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
            extId: "970882906",
            lon: 2.139864,
            lat: 41.379738,
            time: "17:23:00",
            date: "2023-11-28",
          },
          Eco: {
            co2: 12.138227,
            dist: 527891,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 93.42819201167526,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-10-18",
              planningPeriodEnd: "2024-08-13",
              sDaysR: "Lu - Vi, Do",
              sDaysB:
                "0000003EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDFB8",
            },
          ],
          Freq: {
            waitMinimum: 30,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3011|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Niño",
                          },
                          {
                            name: "PRICE",
                            value: "7495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvM05DNDVOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Niño",
                        price: 7495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4011|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Niño",
                          },
                          {
                            name: "PRICE",
                            value: "8635",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA3VkNPfEIwNyIsInByaWNlIjo4Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNE5pNHpOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Niño",
                        price: 8635,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA3VkNPfEIwNyIsInByaWNlIjo4Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3031|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "8745",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInByaWNlIjo4Ny40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNE55NDBOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Más Renfe Joven",
                        price: 8745,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInByaWNlIjo4Ny40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3013|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "9370",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInByaWNlIjo5My43LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNU15NDNMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort T.Dorada",
                        price: 9370,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInByaWNlIjo5My43LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "CONFORT",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4031|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "10075",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA3VkNPfEIwNyIsInByaWNlIjoxMDAuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1EQXVOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Más Renfe Joven",
                        price: 10075,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA3VkNPfEIwNyIsInByaWNlIjoxMDAuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4013|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "10795",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA3VkNPfEIwNyIsInByaWNlIjoxMDcuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1EY3VPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium T.Dorada",
                        price: 10795,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA3VkNPfEIwNyIsInByaWNlIjoxMDcuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3548|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "11495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1UUXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort 4 o más",
                        price: 11495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3030|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "11870",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTguNywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1UZ3VOeXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort C. Joven < 26",
                        price: 11870,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTguNywiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3010|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Elige Confort",
                          },
                          {
                            name: "PRICE",
                            value: "12495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1qUXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Confort",
                        price: 12495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4548|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "13240",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzIuNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE16SXVOQ3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium 4 o más",
                        price: 13240,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzIuNCwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4030|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "13675",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzYuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE16WXVOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium C. Joven < 26",
                        price: 13675,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzYuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4010|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium",
                          },
                          {
                            name: "PRICE",
                            value: "14395",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxNDMuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "5",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE5ETXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium",
                        price: 14395,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxNDMuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          child: false,
                        },
                      },
                    ],
                    param: [
                      {
                        name: "TRAIN",
                        value: "03151",
                      },
                      {
                        name: "TRAIN_TYPE",
                        value: "006",
                      },
                      {
                        name: "DEPARTURE_TIME",
                        value: "1500",
                      },
                      {
                        name: "ARRIVAL_TIME",
                        value: "1729",
                      },
                      {
                        name: "TYPE",
                        value: "OUTWARD",
                      },
                      {
                        name: "SILENT_CAR",
                        value: "true",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe AVE LD MD Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe",
                  },
                  {
                    name: "secId",
                    value: "C-0:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-0:000",
                  },
                  {
                    name: "secIds",
                    value: "C-0:000",
                  },
                ],
                name: "Renfe AVE LD MD Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 0,
          tripId: "C-0",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$202311281430$202311281720$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@L=970882906@a=128@$202311281720$202311281723$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT2H53M",
          rtDuration: "PT2H53M",
          checksum: "dc575a27_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "14:30:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  routeIdx: 3,
                  prognosisType: "PROGNOSED",
                  time: "17:20:00",
                  date: "2023-11-28",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94889#TA#0#DA#281123#1S#100060000#1T#1430#LS#100004307#LT#1825#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1430#TO#100004307#TT#1825#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "15:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "17:29:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94894#TA#0#DA#281123#1S#100060000#1T#1500#LS#100071801#LT#1729#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1500#TO#100071801#TT#1729#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "286",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "16:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "18:30:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94898#TA#0#DA#281123#1S#100060000#1T#1600#LS#100071801#LT#1830#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1600#TO#100071801#TT#1830#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "291",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "16:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Figueres Vilafant, Vilafant",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 2,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:15:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94901#TA#0#DA#281123#1S#100060000#1T#1630#LS#100004307#LT#2028#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1630#TO#100004307#TT#2028#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "296",
                        line: "AVE",
                        lineId: "6000004307AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Figueres Vilafant, Vilafant",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "17:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:30:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94904#TA#0#DA#281123#1S#100060000#1T#1700#LS#100071801#LT#1930#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1700#TO#100071801#TT#1930#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "299",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 30,
                  waitMaximum: 60,
                  alternativeCount: 4,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 0,
                        g: 0,
                        b: 0,
                        hex: "#000000",
                      },
                      backgroundColor: {
                        r: 242,
                        g: 245,
                        b: 245,
                        hex: "#F2F5F5",
                      },
                      res: "prod_ice",
                    },
                    operatorInfo: {
                      name: "RENFE OPERADORA",
                      nameS: "107",
                      nameN: "RENFE OP",
                      nameL: "RENFE OPERADORA",
                      id: "1071",
                    },
                    name: "REN AVE",
                    internalName: "REN  AVE",
                    displayNumber: "AVE",
                    num: "281",
                    line: "AVE",
                    lineId: "6000004307AV006(1071)030",
                    catOut: "RENFE OP",
                    catIn: "107",
                    catCode: "1",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "RENFE OPERADORA",
                    operatorCode: "107",
                    operator: "RENFE OPERADORA",
                    admin: "030000",
                    routeIdxFrom: 0,
                    routeIdxTo: 3,
                    matchId: "AVE",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                      extId: "100060000",
                      routeIdx: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                      depPrognosisType: "PROGNOSED",
                      depTime: "14:30:00",
                      depDate: "2023-11-28",
                      depDir: "Estación de tren Figueres Vilafant, Vilafant",
                    },
                    {
                      name: "Estación de tren Calatayud, Calatayud",
                      id: "A=1@O=Estación de tren Calatayud, Calatayud@X=-1638680@Y=41346694@U=80@L=100070600@",
                      extId: "100070600",
                      routeIdx: 1,
                      lon: -1.63868,
                      lat: 41.346694,
                      depTime: "15:26:00",
                      depDate: "2023-11-28",
                      arrTime: "15:25:00",
                      arrDate: "2023-11-28",
                    },
                    {
                      name: "Estación de tren Zaragoza-Delicias, Zaragoza",
                      id: "A=1@O=Estación de tren Zaragoza-Delicias, Zaragoza@X=-911614@Y=41658647@U=80@L=100004040@",
                      extId: "100004040",
                      routeIdx: 2,
                      lon: -0.911614,
                      lat: 41.658647,
                      depTime: "15:52:00",
                      depDate: "2023-11-28",
                      arrTime: "15:51:00",
                      arrDate: "2023-11-28",
                    },
                    {
                      name: "Estación de tren Barcelona-Sants, Barcelona",
                      id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                      extId: "100071801",
                      routeIdx: 3,
                      lon: 2.140628,
                      lat: 41.379217,
                      arrTime: "17:20:00",
                      arrDate: "2023-11-28",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-11-28",
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94889#TA#0#DA#281123#1S#100060000#1T#1430#LS#100004307#LT#1825#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1430#TO#100004307#TT#1825#",
                },
                id: "C-0:000",
                idx: 0,
                name: "REN AVE",
                number: "AVE",
                category: "107",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Figueres Vilafant, Vilafant",
                directionFlag: "0",
                duration: "PT2H50M",
                dist: 527749,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                    },
                    {
                      order: 1,
                      lon: -1.63868,
                      lat: 41.346694,
                    },
                    {
                      order: 2,
                      lon: -0.911614,
                      lat: 41.658647,
                    },
                    {
                      order: 3,
                      lon: 2.140628,
                      lat: 41.379217,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  time: "17:20:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Barcelona, Barcelona Sants Train Station",
                  type: "POI",
                  id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
                  extId: "970882906",
                  lon: 2.139864,
                  lat: 41.379738,
                  time: "17:23:00",
                  date: "2023-11-28",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@|A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@|28112023|172000|172300|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-0:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 142,
                GisRoute: {
                  dist: 142,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
            type: "ST",
            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
            extId: "100060000",
            lon: -3.69089,
            lat: 40.40644,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "15:00:00",
            date: "2023-11-28",
          },
          Destination: {
            name: "Barcelona, Barcelona Sants Train Station",
            type: "POI",
            id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
            extId: "970882906",
            lon: 2.139864,
            lat: 41.379738,
            time: "17:32:00",
            date: "2023-11-28",
          },
          Eco: {
            co2: 11.547932000000001,
            dist: 502226,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 93.42819201167526,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-10-18",
              planningPeriodEnd: "2024-08-13",
              sDaysR: "no cada día",
              sDaysI:
                "28. Nov 2023 hasta 19. Jul 2024 Lu - Vi; no 6. hasta 8. Dic 2023, 25. Dic 2023 hasta 9. Feb 2024, 25. hasta 29. Mar 2024, 1. hasta 3. May 2024, 15. May",
              sDaysB:
                "0000003E7CF983E7C0000000000007CF9F3E7CF803E7CF9F307CD9F3E7CF9F3E7CF9F0000000",
            },
          ],
          Freq: {
            waitMinimum: 30,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3011|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Niño",
                          },
                          {
                            name: "PRICE",
                            value: "7495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvM05DNDVOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Niño",
                        price: 7495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4011|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Niño",
                          },
                          {
                            name: "PRICE",
                            value: "8635",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA3VkNPfEIwNyIsInByaWNlIjo4Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNE5pNHpOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Niño",
                        price: 8635,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA3VkNPfEIwNyIsInByaWNlIjo4Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3031|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "8745",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInByaWNlIjo4Ny40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNE55NDBOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Más Renfe Joven",
                        price: 8745,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInByaWNlIjo4Ny40NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3013|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "9370",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInByaWNlIjo5My43LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpvNU15NDNMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort T.Dorada",
                        price: 9370,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInByaWNlIjo5My43LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "CONFORT",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4031|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "10075",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA3VkNPfEIwNyIsInByaWNlIjoxMDAuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1EQXVOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Más Renfe Joven",
                        price: 10075,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA3VkNPfEIwNyIsInByaWNlIjoxMDAuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4013|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "10795",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA3VkNPfEIwNyIsInByaWNlIjoxMDcuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1EY3VPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium T.Dorada",
                        price: 10795,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA3VkNPfEIwNyIsInByaWNlIjoxMDcuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3548|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "11495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1UUXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort 4 o más",
                        price: 11495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3030|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "11870",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTguNywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1UZ3VOeXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort C. Joven < 26",
                        price: 11870,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMTguNywiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3010|BE07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Elige Confort",
                          },
                          {
                            name: "PRICE",
                            value: "12495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE1qUXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Confort",
                        price: 12495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4548|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "13240",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzIuNCwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE16SXVOQ3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium 4 o más",
                        price: 13240,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzIuNCwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4030|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "13675",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzYuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE16WXVOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium C. Joven < 26",
                        price: 13675,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxMzYuNzUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4010|BB07VCO|B07",
                          },
                          {
                            name: "NAME",
                            value: "Prémium",
                          },
                          {
                            name: "PRICE",
                            value: "14395",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxNDMuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "2",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUxTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBM1ZrTlBmRUl3TnlJc0luQnlhV05sSWpveE5ETXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium",
                        price: 14395,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE1MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA3VkNPfEIwNyIsInByaWNlIjoxNDMuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          child: false,
                        },
                      },
                    ],
                    param: [
                      {
                        name: "TRAIN",
                        value: "03151",
                      },
                      {
                        name: "TRAIN_TYPE",
                        value: "006",
                      },
                      {
                        name: "DEPARTURE_TIME",
                        value: "1500",
                      },
                      {
                        name: "ARRIVAL_TIME",
                        value: "1729",
                      },
                      {
                        name: "TYPE",
                        value: "OUTWARD",
                      },
                      {
                        name: "SILENT_CAR",
                        value: "true",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe AVE LD MD Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe",
                  },
                  {
                    name: "secId",
                    value: "C-1:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-1:000",
                  },
                  {
                    name: "secIds",
                    value: "C-1:000",
                  },
                ],
                name: "Renfe AVE LD MD Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 1,
          tripId: "C-1",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$202311281500$202311281729$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@L=970882906@a=128@$202311281729$202311281732$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT2H32M",
          rtDuration: "PT2H32M",
          checksum: "9fe28dc5_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "15:00:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  routeIdx: 1,
                  prognosisType: "PROGNOSED",
                  time: "17:29:00",
                  date: "2023-11-28",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94894#TA#0#DA#281123#1S#100060000#1T#1500#LS#100071801#LT#1729#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1500#TO#100071801#TT#1729#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "16:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "18:30:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94898#TA#0#DA#281123#1S#100060000#1T#1600#LS#100071801#LT#1830#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1600#TO#100071801#TT#1830#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "291",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "16:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Figueres Vilafant, Vilafant",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 2,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:15:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94901#TA#0#DA#281123#1S#100060000#1T#1630#LS#100004307#LT#2028#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1630#TO#100004307#TT#2028#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "296",
                        line: "AVE",
                        lineId: "6000004307AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Figueres Vilafant, Vilafant",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "17:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:30:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94904#TA#0#DA#281123#1S#100060000#1T#1700#LS#100071801#LT#1930#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1700#TO#100071801#TT#1930#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "299",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "17:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 5,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "20:42:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94908#TA#0#DA#281123#1S#100060000#1T#1730#LS#100071801#LT#2042#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1730#TO#100071801#TT#2042#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "301",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 30,
                  waitMaximum: 60,
                  alternativeCount: 4,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 0,
                        g: 0,
                        b: 0,
                        hex: "#000000",
                      },
                      backgroundColor: {
                        r: 242,
                        g: 245,
                        b: 245,
                        hex: "#F2F5F5",
                      },
                      res: "prod_ice",
                    },
                    operatorInfo: {
                      name: "RENFE OPERADORA",
                      nameS: "107",
                      nameN: "RENFE OP",
                      nameL: "RENFE OPERADORA",
                      id: "1071",
                    },
                    name: "REN AVE",
                    internalName: "REN  AVE",
                    displayNumber: "AVE",
                    num: "286",
                    line: "AVE",
                    lineId: "6000071801AV006(1071)030",
                    catOut: "RENFE OP",
                    catIn: "107",
                    catCode: "1",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "RENFE OPERADORA",
                    operatorCode: "107",
                    operator: "RENFE OPERADORA",
                    admin: "030000",
                    routeIdxFrom: 0,
                    routeIdxTo: 1,
                    matchId: "AVE",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                      extId: "100060000",
                      routeIdx: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                      depPrognosisType: "PROGNOSED",
                      depTime: "15:00:00",
                      depDate: "2023-11-28",
                      depDir: "Estación de tren Barcelona-Sants, Barcelona",
                    },
                    {
                      name: "Estación de tren Barcelona-Sants, Barcelona",
                      id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                      extId: "100071801",
                      routeIdx: 1,
                      lon: 2.140628,
                      lat: 41.379217,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "17:29:00",
                      arrDate: "2023-11-28",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-11-28",
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94894#TA#0#DA#281123#1S#100060000#1T#1500#LS#100071801#LT#1729#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1500#TO#100071801#TT#1729#",
                },
                id: "C-1:000",
                idx: 0,
                name: "REN AVE",
                number: "AVE",
                category: "107",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Barcelona-Sants, Barcelona",
                directionFlag: "0",
                duration: "PT2H29M",
                dist: 502084,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                    },
                    {
                      order: 1,
                      lon: 2.140628,
                      lat: 41.379217,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  time: "17:29:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Barcelona, Barcelona Sants Train Station",
                  type: "POI",
                  id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
                  extId: "970882906",
                  lon: 2.139864,
                  lat: 41.379738,
                  time: "17:32:00",
                  date: "2023-11-28",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@|A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@|28112023|172900|173200|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-1:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 142,
                GisRoute: {
                  dist: 142,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
        {
          Origin: {
            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
            type: "ST",
            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
            extId: "100060000",
            lon: -3.69089,
            lat: 40.40644,
            routeIdx: 0,
            prognosisType: "PROGNOSED",
            time: "16:00:00",
            date: "2023-11-28",
          },
          Destination: {
            name: "Barcelona, Barcelona Sants Train Station",
            type: "POI",
            id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
            extId: "970882906",
            lon: 2.139864,
            lat: 41.379738,
            time: "18:33:00",
            date: "2023-11-28",
          },
          Eco: {
            co2: 11.547932000000001,
            dist: 502226,
            type: "PUT",
            rating: 3,
          },
          EcoCmp: [
            {
              co2: 93.42819201167526,
              type: "BEE",
            },
          ],
          ServiceDays: [
            {
              planningPeriodBegin: "2023-10-18",
              planningPeriodEnd: "2024-08-13",
              sDaysR: "no cada día",
              sDaysI:
                "28. Nov 2023 hasta 14. Jul 2024 Lu - Vi, Do; no 8. Dic, 25. Dic 2023 hasta 5. Ene 2024, 15. May",
              sDaysB:
                "0000003EFDFBE7EFD0007EFDFBF7EFDFBF7EFDFBF7EFDFBF7EFDDBF7EFDFBF7EFDFA00000000",
            },
          ],
          Freq: {
            waitMinimum: 30,
          },
          TariffResult: {
            fareSetItem: [
              {
                fareItem: [
                  {
                    ticket: [
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1011|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico Niño",
                          },
                          {
                            name: "PRICE",
                            value: "4025",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA4VkNPfEMwOCIsInByaWNlIjo0MC4yNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvME1DNHlOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico Niño",
                        price: 4025,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA4VkNPfEMwOCIsInByaWNlIjo0MC4yNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1031|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "4695",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA4VkNPfEMwOCIsInByaWNlIjo0Ni45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvME5pNDVOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico Más Renfe Joven",
                        price: 4695,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA4VkNPfEMwOCIsInByaWNlIjo0Ni45NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2011|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige Niño",
                          },
                          {
                            name: "PRICE",
                            value: "4830",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA4VkNPfEMwOCIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvME9DNHpMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Niño",
                        price: 4830,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA4VkNPfEMwOCIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1013|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "5035",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA4VkNPfEMwOCIsInByaWNlIjo1MC4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMU1DNHpOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico T.Dorada",
                        price: 5035,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA4VkNPfEMwOCIsInByaWNlIjo1MC4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2031|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "5635",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA4VkNPfEMwOCIsInByaWNlIjo1Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMU5pNHpOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Más Renfe Joven",
                        price: 5635,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA4VkNPfEMwOCIsInByaWNlIjo1Ni4zNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "ELIGE",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2013|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "6040",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA4VkNPfEMwOCIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMk1DNDBMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige T.Dorada",
                        price: 6040,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA4VkNPfEMwOCIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1548|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "6175",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA4VkNPfEMwOCIsInByaWNlIjo2MS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMk1TNDNOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico 4 o más",
                        price: 6175,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA4VkNPfEMwOCIsInByaWNlIjo2MS43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1030|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "6375",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA4VkNPfEMwOCIsInByaWNlIjo2My43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMk15NDNOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico C. Joven < 26",
                        price: 6375,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA4VkNPfEMwOCIsInByaWNlIjo2My43NSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "BASICO",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N1010|CL08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Básico",
                          },
                          {
                            name: "PRICE",
                            value: "6710",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA4VkNPfEMwOCIsInByaWNlIjo2Ny4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvMk55NHhMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Básico",
                        price: 6710,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA4VkNPfEMwOCIsInByaWNlIjo2Ny4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "BASICO",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2548|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "7410",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA4VkNPfEMwOCIsInByaWNlIjo3NC4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvM05DNHhMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige 4 o más",
                        price: 7410,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA4VkNPfEMwOCIsInByaWNlIjo3NC4xLCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2030|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "7650",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA4VkNPfEMwOCIsInByaWNlIjo3Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvM05pNDFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige C. Joven < 26",
                        price: 7650,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA4VkNPfEMwOCIsInByaWNlIjo3Ni41LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "SITTING_TOURIST",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N2010|CE08VCO|C08",
                          },
                          {
                            name: "NAME",
                            value: "Elige",
                          },
                          {
                            name: "PRICE",
                            value: "8050",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA4VkNPfEMwOCIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiJ9",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBNFZrTlBmRU13T0NJc0luQnlhV05sSWpvNE1DNDFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSjk=",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige",
                        price: 8050,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA4VkNPfEMwOCIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiJ9",
                        group: {
                          type: "ELIGE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3011|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Niño",
                          },
                          {
                            name: "PRICE",
                            value: "10710",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA0VkNPfEIwNCIsInByaWNlIjoxMDcuMSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE1EY3VNU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Niño",
                        price: 10710,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA0VkNPfEIwNCIsInByaWNlIjoxMDcuMSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4011|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Niño",
                          },
                          {
                            name: "PRICE",
                            value: "11850",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA0VkNPfEIwNCIsInByaWNlIjoxMTguNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE1UZ3VOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Niño",
                        price: 11850,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA0VkNPfEIwNCIsInByaWNlIjoxMTguNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          child: true,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3031|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "12495",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA0VkNPfEIwNCIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE1qUXVPVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort Más Renfe Joven",
                        price: 12495,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA0VkNPfEIwNCIsInByaWNlIjoxMjQuOTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3013|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "13385",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA0VkNPfEIwNCIsInByaWNlIjoxMzMuODUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE16TXVPRFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort T.Dorada",
                        price: 13385,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA0VkNPfEIwNCIsInByaWNlIjoxMzMuODUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4031|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium Más Renfe Joven",
                          },
                          {
                            name: "PRICE",
                            value: "13825",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA0VkNPfEIwNCIsInByaWNlIjoxMzguMjUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE16Z3VNalVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium Más Renfe Joven",
                        price: 13825,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA0VkNPfEIwNCIsInByaWNlIjoxMzguMjUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "PREMIUM",
                          discount: "MASRENFE",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4013|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium T.Dorada",
                          },
                          {
                            name: "PRICE",
                            value: "14810",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA0VkNPfEIwNCIsInByaWNlIjoxNDguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE5EZ3VNU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium T.Dorada",
                        price: 14810,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA0VkNPfEIwNCIsInByaWNlIjoxNDguMSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          discount: "DORADA",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3548|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "16420",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNjQuMiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE5qUXVNaXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort 4 o más",
                        price: 16420,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNjQuMiwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3030|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "E.Confort C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "16955",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNjkuNTUsImN1cnJlbmN5IjoiRVVSIn0=",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE5qa3VOVFVzSW1OMWNuSmxibU41SWpvaVJWVlNJbjA9",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "E.Confort C. Joven < 26",
                        price: 16955,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNjkuNTUsImN1cnJlbmN5IjoiRVVSIn0=",
                        group: {
                          type: "CONFORT",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N3010|BE04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Elige Confort",
                          },
                          {
                            name: "PRICE",
                            value: "17850",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNzguNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE56Z3VOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Elige Confort",
                        price: 17850,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA0VkNPfEIwNCIsInByaWNlIjoxNzguNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "CONFORT",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4548|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium 4 o más",
                          },
                          {
                            name: "PRICE",
                            value: "18170",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA0VkNPfEIwNCIsInByaWNlIjoxODEuNywiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE9ERXVOeXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium 4 o más",
                        price: 18170,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA0VkNPfEIwNCIsInByaWNlIjoxODEuNywiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          discount: "4OMAS",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4030|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium C. Joven < 26",
                          },
                          {
                            name: "PRICE",
                            value: "18760",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA0VkNPfEIwNCIsInByaWNlIjoxODcuNiwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE9EY3VOaXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium C. Joven < 26",
                        price: 18760,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA0VkNPfEIwNCIsInByaWNlIjoxODcuNiwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          discount: "JOVEN",
                          child: false,
                        },
                      },
                      {
                        param: [
                          {
                            name: "STATUS",
                            value: "AVAILABLE",
                          },
                          {
                            name: "SEAT_TYPE",
                            value: "SITTING",
                          },
                          {
                            name: "CLASS_TYPE",
                            value: "CONFORT",
                          },
                          {
                            name: "TICKET_ID",
                            value: "N4010|BB04VCO|B04",
                          },
                          {
                            name: "NAME",
                            value: "Prémium",
                          },
                          {
                            name: "PRICE",
                            value: "19750",
                          },
                          {
                            name: "BOOKING_CONTEXT",
                            value:
                              "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA0VkNPfEIwNCIsInByaWNlIjoxOTcuNSwiY3VycmVuY3kiOiJFVVIifQ==",
                          },
                          {
                            name: "AVAILABILITY",
                            value: "Si",
                          },
                        ],
                        externalContent: {
                          content:
                            "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNVFVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpjeE9EQXhJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESXpNVEV5T0NJc0luUnlZV2x1U1dRaU9pSXdNekUyTVNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBMFZrTlBmRUl3TkNJc0luQnlhV05sSWpveE9UY3VOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlmUT09",
                          text: "Ver oferta",
                          contentType: "XBOOK_CTX",
                        },
                        name: "Prémium",
                        price: 19750,
                        cur: "EUR",
                        shpCtx:
                          "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMTUiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjcxODAxIiwidHJpcERhdGUiOiIyMDIzMTEyOCIsInRyYWluSWQiOiIwMzE2MSIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA0VkNPfEIwNCIsInByaWNlIjoxOTcuNSwiY3VycmVuY3kiOiJFVVIifQ==",
                        group: {
                          type: "PREMIUM",
                          child: false,
                        },
                      },
                    ],
                    param: [
                      {
                        name: "TRAIN",
                        value: "03161",
                      },
                      {
                        name: "TRAIN_TYPE",
                        value: "006",
                      },
                      {
                        name: "DEPARTURE_TIME",
                        value: "1600",
                      },
                      {
                        name: "ARRIVAL_TIME",
                        value: "1830",
                      },
                      {
                        name: "TYPE",
                        value: "OUTWARD",
                      },
                      {
                        name: "SILENT_CAR",
                        value: "true",
                      },
                    ],
                  },
                ],
                param: [
                  {
                    name: "NAME",
                    value: "Renfe AVE LD MD Pricing",
                  },
                  {
                    name: "providerId",
                    value: "Renfe",
                  },
                  {
                    name: "secId",
                    value: "C-2:000",
                  },
                  {
                    name: "secIdEnd",
                    value: "C-2:000",
                  },
                  {
                    name: "secIds",
                    value: "C-2:000",
                  },
                ],
                name: "Renfe AVE LD MD Pricing",
                fromLegId: 0,
                toLegId: 0,
              },
            ],
            param: [
              {
                name: "providerId",
                value: "Renfe",
              },
            ],
          },
          calculation: "INITIAL",
          TripStatus: {
            hintCode: 0,
          },
          idx: 2,
          tripId: "C-2",
          ctxRecon:
            "¶HKI¶T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$202311281600$202311281830$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Barcelona-Sants, Barcelona@L=100071801@a=128@$A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@L=970882906@a=128@$202311281830$202311281833$$$1$$$$$$¶GP¶ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#¶PC¶eyJncnBJZCI6IkFQSV9HUk9VUF9TQ09PVEVSX1BUX1RBWEkifQ==",
          duration: "PT2H33M",
          rtDuration: "PT2H33M",
          checksum: "0e4c58e5_3",
          LegList: {
            Leg: [
              {
                Origin: {
                  name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                  type: "ST",
                  id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                  extId: "100060000",
                  lon: -3.69089,
                  lat: 40.40644,
                  routeIdx: 0,
                  prognosisType: "PROGNOSED",
                  time: "16:00:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  routeIdx: 1,
                  prognosisType: "PROGNOSED",
                  time: "18:30:00",
                  date: "2023-11-28",
                },
                JourneyDetailRef: {
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94898#TA#0#DA#281123#1S#100060000#1T#1600#LS#100071801#LT#1830#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1600#TO#100071801#TT#1830#",
                },
                Freq: {
                  journey: [
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "16:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Figueres Vilafant, Vilafant",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 2,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:15:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94901#TA#0#DA#281123#1S#100060000#1T#1630#LS#100004307#LT#2028#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1630#TO#100004307#TT#2028#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "296",
                        line: "AVE",
                        lineId: "6000004307AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Figueres Vilafant, Vilafant",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "17:00:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 1,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "19:30:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94904#TA#0#DA#281123#1S#100060000#1T#1700#LS#100071801#LT#1930#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1700#TO#100071801#TT#1930#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "299",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "17:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 5,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "20:42:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94908#TA#0#DA#281123#1S#100060000#1T#1730#LS#100071801#LT#2042#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1730#TO#100071801#TT#2042#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "301",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                    {
                      Stops: {
                        Stop: [
                          {
                            name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                            extId: "100060000",
                            routeIdx: 0,
                            lon: -3.69089,
                            lat: 40.40644,
                            depTime: "18:30:00",
                            depDate: "2023-11-28",
                            depDir:
                              "Estación de tren Barcelona-Sants, Barcelona",
                          },
                          {
                            name: "Estación de tren Barcelona-Sants, Barcelona",
                            id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                            extId: "100071801",
                            routeIdx: 3,
                            lon: 2.140628,
                            lat: 41.379217,
                            arrTime: "21:20:00",
                            arrDate: "2023-11-28",
                          },
                        ],
                      },
                      JourneyDetailRef: {
                        ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94913#TA#0#DA#281123#1S#100060000#1T#1830#LS#100071801#LT#2120#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1830#TO#100071801#TT#2120#",
                      },
                      Product: {
                        icon: {
                          foregroundColor: {
                            r: 0,
                            g: 0,
                            b: 0,
                            hex: "#000000",
                          },
                          backgroundColor: {
                            r: 242,
                            g: 245,
                            b: 245,
                            hex: "#F2F5F5",
                          },
                          res: "prod_ice",
                        },
                        operatorInfo: {
                          name: "RENFE OPERADORA",
                          nameS: "107",
                          nameN: "RENFE OP",
                          nameL: "RENFE OPERADORA",
                          id: "1071",
                        },
                        name: "REN AVE",
                        internalName: "REN  AVE",
                        displayNumber: "AVE",
                        num: "306",
                        line: "AVE",
                        lineId: "6000071801AV006(1071)030",
                        catOut: "RENFE OP",
                        catIn: "107",
                        catCode: "1",
                        cls: "4",
                        catOutS: "107",
                        catOutL: "RENFE OPERADORA",
                        operatorCode: "107",
                        operator: "RENFE OPERADORA",
                        admin: "030000",
                        matchId: "AVE",
                      },
                      name: "REN AVE",
                      direction: "Estación de tren Barcelona-Sants, Barcelona",
                      trainNumber: "AVE",
                      trainCategory: "107",
                    },
                  ],
                  waitMinimum: 30,
                  waitMaximum: 60,
                  alternativeCount: 4,
                },
                JourneyStatus: "P",
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 0,
                        g: 0,
                        b: 0,
                        hex: "#000000",
                      },
                      backgroundColor: {
                        r: 242,
                        g: 245,
                        b: 245,
                        hex: "#F2F5F5",
                      },
                      res: "prod_ice",
                    },
                    operatorInfo: {
                      name: "RENFE OPERADORA",
                      nameS: "107",
                      nameN: "RENFE OP",
                      nameL: "RENFE OPERADORA",
                      id: "1071",
                    },
                    name: "REN AVE",
                    internalName: "REN  AVE",
                    displayNumber: "AVE",
                    num: "291",
                    line: "AVE",
                    lineId: "6000071801AV006(1071)030",
                    catOut: "RENFE OP",
                    catIn: "107",
                    catCode: "1",
                    cls: "4",
                    catOutS: "107",
                    catOutL: "RENFE OPERADORA",
                    operatorCode: "107",
                    operator: "RENFE OPERADORA",
                    admin: "030000",
                    routeIdxFrom: 0,
                    routeIdxTo: 1,
                    matchId: "AVE",
                  },
                ],
                Stops: {
                  Stop: [
                    {
                      name: "Estación de tren Madrid-Puerta de Atocha, Madrid",
                      id: "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                      extId: "100060000",
                      routeIdx: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                      depPrognosisType: "PROGNOSED",
                      depTime: "16:00:00",
                      depDate: "2023-11-28",
                      depDir: "Estación de tren Barcelona-Sants, Barcelona",
                    },
                    {
                      name: "Estación de tren Barcelona-Sants, Barcelona",
                      id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                      extId: "100071801",
                      routeIdx: 1,
                      lon: 2.140628,
                      lat: 41.379217,
                      arrPrognosisType: "PROGNOSED",
                      arrTime: "18:30:00",
                      arrDate: "2023-11-28",
                    },
                  ],
                },
                JourneyDetail: {
                  dayOfOperation: "2023-11-28",
                  ref: "2|#VN#1#ST#1700221058#PI#0#ZI#94898#TA#0#DA#281123#1S#100060000#1T#1600#LS#100071801#LT#1830#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1600#TO#100071801#TT#1830#",
                },
                id: "C-2:000",
                idx: 0,
                name: "REN AVE",
                number: "AVE",
                category: "107",
                type: "JNY",
                reachable: true,
                direction: "Estación de tren Barcelona-Sants, Barcelona",
                directionFlag: "0",
                duration: "PT2H30M",
                dist: 502084,
                GisRoute: {
                  coordinates: [
                    {
                      order: 0,
                      lon: -3.69089,
                      lat: 40.40644,
                    },
                    {
                      order: 1,
                      lon: 2.140628,
                      lat: 41.379217,
                    },
                  ],
                },
              },
              {
                Origin: {
                  name: "Estación de tren Barcelona-Sants, Barcelona",
                  type: "ST",
                  id: "A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@",
                  extId: "100071801",
                  lon: 2.140628,
                  lat: 41.379217,
                  time: "18:30:00",
                  date: "2023-11-28",
                },
                Destination: {
                  name: "Barcelona, Barcelona Sants Train Station",
                  type: "POI",
                  id: "A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@",
                  extId: "970882906",
                  lon: 2.139864,
                  lat: 41.379738,
                  time: "18:33:00",
                  date: "2023-11-28",
                },
                GisRef: {
                  ref: "G|1|G@F|A=1@O=Estación de tren Barcelona-Sants, Barcelona@X=2140628@Y=41379217@U=80@L=100071801@|A=4@O=Barcelona, Barcelona Sants Train Station@X=2139864@Y=41379738@U=101@L=970882906@|28112023|183000|183300|fb|ft@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$t@1000@5000@120@1@100@1@@0@@@@profile=cooltra*vehiclemode=sharing@false@0@-1@0@-1@-1@$f@$f@$f@$f@$§bt@0@1500@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$t@1000@25000@120@2@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$§tt@0@5000@120@1@100@1@@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§||||",
                },
                Product: [
                  {
                    icon: {
                      foregroundColor: {
                        r: 255,
                        g: 255,
                        b: 255,
                        hex: "#FFFFFF",
                      },
                      backgroundColor: {
                        r: 244,
                        g: 168,
                        b: 0,
                        hex: "#F4A800",
                      },
                      res: "prod_walk",
                    },
                    name: "Trayecto a pie",
                    internalName: "Trayecto a pie",
                  },
                ],
                id: "C-2:001",
                idx: 1,
                name: "Trayecto a pie",
                type: "WALK",
                duration: "PT3M",
                dist: 142,
                GisRoute: {
                  dist: 142,
                  durS: "PT3M",
                  dirGeo: 0,
                },
              },
            ],
          },
        },
      ],
    },
  };
}

export function getAve() {
  return {
    "data": {
        "Trip": [
           /* {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "13:05:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 2,
                    "prognosisType": "PROGNOSED",
                    "time": "16:43:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 9.759735000000001,
                    "dist": 420721,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi",
                        "sDaysB": "0000000E7CF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5315"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjUzLjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qVXpMakUxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 5315,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjUzLjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5795"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo1Ny45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpvMU55NDVOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnNE5EYzNMVE14TkRBd01ERXRNVGN5TlRJME1EY3hOVGcyTVMwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 5795,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo1Ny45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6200"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZOaklzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 6200,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6640"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjY2LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPalkyTGpRc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 6640,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjY2LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6760"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY3LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qWTNMallzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 6760,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY3LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7245"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo3Mi40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqbzNNaTQwTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 7245,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo3Mi40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8145"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjgxLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPamd4TGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 8145,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjgxLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8410"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6ODQuMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk9EUXVNU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnNE5EYzNMVE14TkRBd01ERXRNVGN5TlRJME1EY3hOVGcyTVMwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 8410,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6ODQuMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8855"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjg4LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPamc0TGpVMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 8855,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjg4LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8885"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo4OC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqbzRPQzQ0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 8885,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo4OC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9175"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjkxLjc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2preExqYzFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56Y3RNekUwTURBd01TMHhOekkxTWpRd056RTFPRFl4TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 9175,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjkxLjc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE04VCO|C04"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9660"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo5Ni42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBMFZrTlBmRU13TkNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzVOaTQyTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 9660,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA0VkNPfEMwNCIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo5Ni42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6425"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOalF1TWpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 6425,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7495"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8zTkM0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 7495,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7565"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo3NS42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzNOUzQyTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 7565,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo3NS42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8030"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6ODAuMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2T0RBdU15d2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 8030,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6ODAuMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8825"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjg4LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPamc0TGpJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 8825,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjg4LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9455"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo5NC41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam81TkM0MU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 9455,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo5NC41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9850"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6OTguNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2T1RndU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 9850,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6OTguNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10170"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoxMDEuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqb3hNREV1Tnl3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 10170,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoxMDEuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10705"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjEwNy4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qRXdOeTR3TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 10705,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjEwNy4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11600"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMTYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam94TVRZc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 11600,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMTYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11975"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qRXhPUzQzTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 11975,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "12605"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMjYuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam94TWpZdU1EVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 12605,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMjYuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02140"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1400"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1643"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-0:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-0:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-0:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 0,
                "tripId": "C-0",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021305$202409021318$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021318$202409021322$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021330$202409021400$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021400$202409021643$REN  AVE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H38M",
                "rtDuration": "PT3H38M",
                "checksum": "3cd700ba_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "13:05:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "13:18:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107391#TA#1#DA#20924#1S#100010000#1T#1305#LS#100017000#LT#1332#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1305#TO#100017000#TT#1332#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "844",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "13:05:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "13:08:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:08:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "13:11:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:11:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "13:13:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:13:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "13:18:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107391#TA#1#DA#20924#1S#100010000#1T#1305#LS#100017000#LT#1332#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1305#TO#100017000#TT#1332#"
                            },
                            "id": "C-0:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "13:18:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "13:22:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021318$202409021322$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-0:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "13:30:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "14:00:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-0:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "14:00:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 2,
                                "prognosisType": "PROGNOSED",
                                "time": "16:43:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108674#TA#0#DA#20924#1S#100060000#1T#1400#LS#100051003#LT#1643#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1400#TO#100051003#TT#1643#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "226",
                                    "line": "AVE",
                                    "lineId": "6000051003AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 2,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "14:00:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "15:49:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "15:47:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "16:43:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108674#TA#0#DA#20924#1S#100060000#1T#1400#LS#100051003#LT#1643#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1400#TO#100051003#TT#1643#"
                            },
                            "id": "C-0:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H43M",
                            "dist": 413865,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "13:40:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 4,
                    "prognosisType": "PROGNOSED",
                    "time": "18:34:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 11.295607,
                    "dist": 420720,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi",
                        "sDaysB": "000000007CF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5560"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjU1LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qVTFMallzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 5560,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjU1LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5960"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo1OS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpvMU9TNDJMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RjNU5qTXRNekUwTURBd01TMHhOekkxTWpRd05qYzBNREU1TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 5960,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo1OS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6490"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NjQuOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZOalF1T1N3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 6490,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NjQuOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6950"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjY5LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPalk1TGpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 6950,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjY5LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6950"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY5LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qWTVMalVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 6950,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY5LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7450"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo3NC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqbzNOQzQxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 7450,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo3NC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8525"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjg1LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPamcxTGpJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpNdE16RTBNREF3TVMweE56STFNalF3TmpjME1ERTVMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 8525,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjg1LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8805"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6ODguMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk9EZ3VNRFVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 8805,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6ODguMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9135"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo5MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqbzVNUzR6TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 9135,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo5MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9270"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjkyLjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPamt5TGpjc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 9270,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjkyLjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9435"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2prMExqTTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RjNU5qTXRNekUwTURBd01TMHhOekkxTWpRd05qYzBNREU1TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 9435,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE02VCO|C03"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9930"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo5OS4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBeVZrTlBmRU13TXlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzVPUzR6TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 9930,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTAyVkNPfEMwMyIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo5OS4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5810"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTguMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOVGd1TVN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 5810,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTguMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6780"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo2Ny44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8yTnk0NExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpNdE16RTBNREF3TVMweE56STFNalF3TmpjME1ERTVMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 6780,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo2Ny44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6950"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2OS41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzJPUzQxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 6950,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2OS41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7265"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NzIuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TnpJdU5qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 7265,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NzIuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8110"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjgxLjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPamd4TGpFc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 8110,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjgxLjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8690"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo4Ni45LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam80Tmk0NUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpNdE16RTBNREF3TVMweE56STFNalF3TmpjME1ERTVMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 8690,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo4Ni45LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8910"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6ODkuMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2T0RrdU1Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZekxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQXhPUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 8910,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6ODkuMSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9200"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo5MiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzVNaXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWXpMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREF4T1Mwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 9200,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo5MiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9685"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjk2Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qazJMamcxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 9685,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjk2Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10660"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMDYuNiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam94TURZdU5pd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZekxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQXhPUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 10660,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMDYuNiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11005"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExMC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qRXhNQzR3TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 11005,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExMC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB05VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11585"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMTUuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUwTWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBMVZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam94TVRVdU9EVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 11585,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE0MiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA1VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMTUuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02142"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1435"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1624"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-1:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-1:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-1:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL011"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Nino"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1340"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNU0lzSW5SaGNtbG1aazVoYldVaU9pSk9hVzV2SWl3aWNISnBZMlVpT2pFekxqUXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM01TMHpNVFF3TURBeExURTNNalV5TkRBM01UVTRORE10TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtGT1ZDSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Nino",
                                            "price": 1340,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL031"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNU0lzSW5SaGNtbG1aazVoYldVaU9pSk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qRTJMamMxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOekV0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RRekxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkJUbFFpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Más Renfe Joven",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL013"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Tfa. Tarjeta Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNeUlzSW5SaGNtbG1aazVoYldVaU9pSlVabUV1SUZSaGNtcGxkR0VnUkc5eVlXUmhJaXdpY0hKcFkyVWlPakUyTGpjMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpFdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EUXpMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpCVGxRaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Tfa. Tarjeta Dorada",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL030"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1785"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pFM0xqZzFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56RXRNekUwTURBd01TMHhOekkxTWpRd056RTFPRFF6TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaQlRsUWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "C. Joven < 26",
                                            "price": 1785,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL410"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Adulto Sólo Ida"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2230"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRGMyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREUXhNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkJaSFZzZEc4Z1U4T3piRzhnU1dSaElpd2ljSEpwWTJVaU9qSXlMak1zSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrRk9WQ0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Adulto Sólo Ida",
                                            "price": 2230,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODc2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "08764"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVANT"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1742"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1834"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-1:005"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-1:005"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-1:005"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 5,
                            "toLegId": 5
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 455
                },
                "idx": 1,
                "tripId": "C-1",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021340$202409021352$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021352$202409021356$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021405$202409021435$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409021435$202409021624$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409021712$202409021742$__CI$$1$$$$$$§T$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021742$202409021834$RENAVANT$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT4H54M",
                "rtDuration": "PT4H54M",
                "checksum": "3bb5d532_3",
                "transferCount": 2,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "13:40:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "13:52:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107393#TA#0#DA#20924#1S#100010000#1T#1340#LS#100017000#LT#1407#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1340#TO#100017000#TT#1407#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "950",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "13:40:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "13:42:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:42:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "13:45:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:45:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "13:47:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "13:47:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "13:52:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107393#TA#0#DA#20924#1S#100010000#1T#1340#LS#100017000#LT#1407#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1340#TO#100017000#TT#1407#"
                            },
                            "id": "C-1:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT12M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "13:52:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "13:56:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021352$202409021356$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-1:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "14:05:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "14:35:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-1:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "14:35:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "16:24:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108676#TA#0#DA#20924#1S#100060000#1T#1435#LS#54413#LT#1737#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1435#TO#54413#TT#1737#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "228",
                                    "line": "AVE",
                                    "lineId": "6000054413AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "14:35:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Malaga Maria Zambrano, Málaga"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "arrTime": "16:24:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108676#TA#0#DA#20924#1S#100060000#1T#1435#LS#54413#LT#1737#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1435#TO#54413#TT#1737#"
                            },
                            "id": "C-1:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Malaga Maria Zambrano, Málaga",
                            "directionFlag": "0",
                            "duration": "PT1H49M",
                            "dist": 295721,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 3,
                                "time": "17:12:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 3,
                                "time": "17:42:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-1:004",
                            "idx": 4,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 3,
                                "prognosisType": "PROGNOSED",
                                "time": "17:42:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "18:34:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109280#TA#0#DA#20924#1S#54413#1T#1632#LS#100051003#LT#1834#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#1632#TO#100051003#TT#1834#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENAVANT",
                                    "internalName": "RENAVANT",
                                    "displayNumber": "AVANT",
                                    "num": "803",
                                    "line": "AVANT",
                                    "lineId": "5441351003AV008(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 3,
                                    "routeIdxTo": 4,
                                    "matchId": "AVANT"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 3,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "17:42:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 4,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "18:34:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109280#TA#0#DA#20924#1S#54413#1T#1632#LS#100051003#LT#1834#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#1632#TO#100051003#TT#1834#"
                            },
                            "id": "C-1:005",
                            "idx": 5,
                            "name": "RENAVANT",
                            "number": "AVANT",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT52M",
                            "dist": 118144,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 10,
                    "prognosisType": "PROGNOSED",
                    "time": "14:21:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 20,
                    "prognosisType": "PROGNOSED",
                    "time": "19:31:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 15.442848000000001,
                    "dist": 429133,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi",
                        "sDaysB": "0000000E7CF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2450"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjI0LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qSTBMalVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKSmJuUmxjbU5wZEhraWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 2450,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjI0LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2800"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpveU9Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZekxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQXhPUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa2x1ZEdWeVkybDBlU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 2800,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2855"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjguNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZNamd1TlRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkpiblJsY21OcGRIa2lmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 2855,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjguNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3060"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjMwLjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPak13TGpZc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkpiblJsY21OcGRIa2lmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 3060,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjMwLjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3265"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjMyLjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qTXlMalkxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVNXNTBaWEpqYVhSNUluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 3265,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjMyLjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3500"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqb3pOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWXpMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREF4T1Mwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtsdWRHVnlZMmwwZVNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 3500,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3755"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjM3LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPak0zTGpVMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpNdE16RTBNREF3TVMweE56STFNalF3TmpjME1ERTVMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lTVzUwWlhKamFYUjVJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 3755,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjM3LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3875"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzguNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk16Z3VOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKSmJuUmxjbU5wZEhraWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 3875,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzguNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4080"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjQwLjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPalF3TGpnc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkpiblJsY21OcGRIa2lmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 4080,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjQwLjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4290"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo0Mi45LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqbzBNaTQ1TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVNXNTBaWEpqYVhSNUluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 4290,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo0Mi45LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4430"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQ0LjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pRMExqTXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpKYm5SbGNtTnBkSGtpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 4430,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQ0LjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE08VCO|C08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4665"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Ni42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBNFZrTlBmRU13T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzBOaTQyTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrbHVkR1Z5WTJsMGVTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 4665,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA4VkNPfEMwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Ni42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4650"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDYuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZORFl1TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrbHVkR1Z5WTJsMGVTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 4650,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDYuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5430"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1NC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8xTkM0ekxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpNdE16RTBNREF3TVMweE56STFNalF3TmpjME1ERTVMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lTVzUwWlhKamFYUjVJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 5430,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1NC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5815"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTguMTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TlRndU1UVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpKYm5SbGNtTnBkSGtpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 5815,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTguMTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7135"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzEuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TnpFdU16VXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpKYm5SbGNtTnBkSGtpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 7135,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzEuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJJbnRlcmNpdHkifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7365"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo3My42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzNNeTQyTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFl6TFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBeE9TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrbHVkR1Z5WTJsMGVTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 7365,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo3My42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkludGVyY2l0eSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7755"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjc3LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPVE16TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qYzNMalUxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVNXNTBaWEpqYVhSNUluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 7755,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwOTMzMCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjc3LjU1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiSW50ZXJjaXR5In0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "09330"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "Intercity"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1514"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1741"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-2:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-2:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-2:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1250"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjEyLjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qRXlMalVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKVVQxSlNSU0JQVWs4aWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 1250,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjEyLjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1405"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoxNC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpveE5DNHdOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnNE5EY3hMVE14TkRBd01ERXRNVGN5TlRJME1EY3hOVGcwTXkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWxSUFVsSkZJRTlTVHlKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 1405,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoxNC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1455"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MTQuNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZNVFF1TlRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTVMwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5ETXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSlVUMUpTUlNCUFVrOGlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 1455,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MTQuNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1560"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjE1LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPakUxTGpZc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTVMwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5ETXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSlVUMUpTUlNCUFVrOGlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 1560,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjE1LjYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1640"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qRTJMalFzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKVVQxSlNSU0JQVWs4aWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 1640,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1755"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjoxNy41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqb3hOeTQxTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGN4TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnME15MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklsUlBVbEpGSUU5U1R5Sjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 1755,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjoxNy41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1915"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjE5LjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPakU1TGpFMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpFdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EUXpMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lWRTlTVWtVZ1QxSlBJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 1915,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjE5LjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1975"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MTkuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk1Ua3VOelVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKVVQxSlNSU0JQVWs4aWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 1975,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MTkuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2080"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjIwLjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPakl3TGpnc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTVMwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5ETXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSlVUMUpTUlNCUFVrOGlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 2080,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjIwLjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2155"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjoyMS41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqb3lNUzQxTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGN4TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnME15MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklsUlBVbEpGSUU5U1R5Sjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 2155,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjoyMS41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2225"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjIyLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pJeUxqSTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56RXRNekUwTURBd01TMHhOekkxTWpRd056RTFPRFF6TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pVkU5U1VrVWdUMUpQSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 2225,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjIyLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE05VCO|C05"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2340"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjoyMy40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBMVZrTlBmRU13TlNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqb3lNeTQwTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOekV0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RRekxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVZFOVNVa1VnVDFKUEluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 2340,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA1VkNPfEMwNSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjoyMy40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiVE9SUkUgT1JPIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1455"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MTQuNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZNVFF1TlRVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTVMwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5ETXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSlVUMUpTUlNCUFVrOGlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 1455,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MTQuNTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1695"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjoxNi45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam94Tmk0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjeExUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzBNeTB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJbFJQVWxKRklFOVNUeUo5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 1695,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjoxNi45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1815"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MTguMTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TVRndU1UVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM01TMHpNVFF3TURBeExURTNNalV5TkRBM01UVTRORE10TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpVVDFKU1JTQlBVazhpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 1815,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MTguMTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2225"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6MjIuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TWpJdU1qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM01TMHpNVFF3TURBeExURTNNalV5TkRBM01UVTRORE10TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpVVDFKU1JTQlBVazhpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 2225,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6MjIuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2300"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoyMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqb3lNeXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnNE5EY3hMVE14TkRBd01ERXRNVGN5TlRJME1EY3hOVGcwTXkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWxSUFVsSkZJRTlTVHlKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 2300,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoyMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDcxLTMxNDAwMDEtMTcyNTI0MDcxNTg0My0wMSIsInRyYWluVHlwZSI6IlRPUlJFIE9STyJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE07VCO|B07"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2420"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjI0LjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNRFk1TnlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBM1ZrTlBmRUl3TnlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qSTBMaklzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKVVQxSlNSU0JQVWs4aWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 2420,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMDY5NyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwNyIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjI0LjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJUT1JSRSBPUk8ifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "00697"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "TORRE ORO"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1832"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1931"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-2:005"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-2:005"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-2:005"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 5,
                            "toLegId": 5
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "economic": true,
                    "convenient": true,
                    "hintCode": 0
                },
                "idx": 2,
                "tripId": "C-2",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021421$202409021434$Ren  C10$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021434$202409021438$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021444$202409021514$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409021514$202409021741$RENInter$$1$$$$$$§G@F$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409021802$202409021832$__CI$$1$$$$$$§T$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021832$202409021931$RENTORRE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT5H10M",
                "rtDuration": "PT5H10M",
                "checksum": "b1bb33d9_3",
                "transferCount": 2,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 10,
                                "prognosisType": "PROGNOSED",
                                "time": "14:21:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 14,
                                "prognosisType": "PROGNOSED",
                                "time": "14:34:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104278#TA#2#DA#20924#1S#100010200#1T#1343#LS#100017000#LT#1449#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#1343#TO#100017000#TT#1449#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 156,
                                            "g": 200,
                                            "b": 62,
                                            "hex": "#9CC83E"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C10",
                                    "internalName": "Ren  C10",
                                    "displayNumber": "C10",
                                    "num": "1069",
                                    "line": "C10",
                                    "lineId": "10T0003C10(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 10,
                                    "routeIdxTo": 14,
                                    "matchId": "C10"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 10,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depTime": "14:21:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 11,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "14:24:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "14:24:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 12,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "14:27:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "14:27:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 13,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "14:29:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "14:29:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 14,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "14:34:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104278#TA#2#DA#20924#1S#100010200#1T#1343#LS#100017000#LT#1449#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#1343#TO#100017000#TT#1449#"
                            },
                            "id": "C-2:000",
                            "idx": 0,
                            "name": "Ren C10",
                            "number": "C10",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "14:34:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "14:38:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021434$202409021438$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-2:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "14:44:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "15:14:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-2:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "15:14:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "17:41:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109358#TA#0#DA#20924#1S#100060000#1T#1514#LS#100055020#LT#2127#PU#80#RT#1#CA#107#ZE#Intercit#ZB#RENInter#PC#2#FR#100060000#FT#1514#TO#100055020#TT#2127#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENInter",
                                    "internalName": "RENInter",
                                    "displayNumber": "Intercit",
                                    "num": "890",
                                    "line": "Intercit",
                                    "lineId": "6000055020GL026(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "Intercit"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "15:14:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Algeciras, Algeciras"
                                    },
                                    {
                                        "name": "Estación de tren Ciudad Real, Ciudad Real",
                                        "id": "A=1@O=Estación de tren Ciudad Real, Ciudad Real@X=-3913634@Y=38985300@U=80@L=100037200@",
                                        "extId": "100037200",
                                        "routeIdx": 1,
                                        "lon": -3.913634,
                                        "lat": 38.9853,
                                        "depTime": "16:22:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "16:20:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Puertollano, Puertollano",
                                        "id": "A=1@O=Estación de tren Puertollano, Puertollano@X=-4111657@Y=38691280@U=80@L=100037300@",
                                        "extId": "100037300",
                                        "routeIdx": 2,
                                        "lon": -4.111657,
                                        "lat": 38.69128,
                                        "depTime": "16:40:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "16:38:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Villanueva de Cordoba-Los Pedroches, Villanueva de Córdoba",
                                        "id": "A=1@O=Estación de tren Villanueva de Cordoba-Los Pedroches, Villanueva de Córdoba@X=-4570952@Y=38255403@U=80@L=100037704@",
                                        "extId": "100037704",
                                        "routeIdx": 3,
                                        "lon": -4.570952,
                                        "lat": 38.255403,
                                        "depTime": "17:15:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:14:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 4,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "arrTime": "17:41:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109358#TA#0#DA#20924#1S#100060000#1T#1514#LS#100055020#LT#2127#PU#80#RT#1#CA#107#ZE#Intercit#ZB#RENInter#PC#2#FR#100060000#FT#1514#TO#100055020#TT#2127#"
                            },
                            "id": "C-2:003",
                            "idx": 3,
                            "name": "RENInter",
                            "number": "Intercit",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Algeciras, Algeciras",
                            "directionFlag": "0",
                            "duration": "PT2H27M",
                            "dist": 304134,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.913634,
                                        "lat": 38.9853
                                    },
                                    {
                                        "order": 2,
                                        "lon": -4.111657,
                                        "lat": 38.69128
                                    },
                                    {
                                        "order": 3,
                                        "lon": -4.570952,
                                        "lat": 38.255403
                                    },
                                    {
                                        "order": 4,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 19,
                                "time": "18:02:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 19,
                                "time": "18:32:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-2:004",
                            "idx": 4,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 19,
                                "prognosisType": "PROGNOSED",
                                "time": "18:32:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 20,
                                "prognosisType": "PROGNOSED",
                                "time": "19:31:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107955#TA#0#DA#20924#1S#100071801#1T#745#LS#100051405#LT#2120#PU#80#RT#1#CA#107#ZE#TORRE OR#ZB#RENTORRE#PC#2#FR#100071801#FT#745#TO#100051405#TT#2120#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENTORRE",
                                    "internalName": "RENTORRE",
                                    "displayNumber": "TORRE OR",
                                    "num": "144",
                                    "line": "TORRE OR",
                                    "lineId": "7180151405GL026(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 19,
                                    "routeIdxTo": 20,
                                    "matchId": "TORRE OR"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 19,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "18:32:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Cádiz, Cádiz"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 20,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrTime": "19:31:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107955#TA#0#DA#20924#1S#100071801#1T#745#LS#100051405#LT#2120#PU#80#RT#1#CA#107#ZE#TORRE OR#ZB#RENTORRE#PC#2#FR#100071801#FT#745#TO#100051405#TT#2120#"
                            },
                            "id": "C-2:005",
                            "idx": 5,
                            "name": "RENTORRE",
                            "number": "TORRE OR",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Cádiz, Cádiz",
                            "directionFlag": "0",
                            "duration": "PT59M",
                            "dist": 118144,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "15:07:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 2,
                    "prognosisType": "PROGNOSED",
                    "time": "18:41:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 9.759735000000001,
                    "dist": 420721,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 14. Sep 2024",
                        "sDaysB": "0000000FFFFC0000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4345"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjQzLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qUXpMalExTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 4345,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjQzLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4830"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpvME9DNHpMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56Y3RNekUwTURBd01TMHhOekkxTWpRd056RTFPRFl4TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 4830,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5070"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NTAuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZOVEF1Tnl3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 5070,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NTAuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5435"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjU0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPalUwTGpNMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 5435,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjU0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5635"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU2LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qVTJMak0xTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 5635,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU2LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6040"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqbzJNQzQwTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 6040,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6665"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjY2LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPalkyTGpZMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 6665,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjY2LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6885"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6NjguODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk5qZ3VPRFVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 6885,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6NjguODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7245"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjcyLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPamN5TGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 7245,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjcyLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7405"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo3NC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqbzNOQzR3TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 7405,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo3NC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7650"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjc2LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pjMkxqVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 7650,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjc2LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "No"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8050"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzRNQzQxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 8050,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5140"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTEuNCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOVEV1TkN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 5140,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTEuNCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5995"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1OS45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8xT1M0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 5995,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1OS45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6280"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2Mi44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzJNaTQ0TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 6280,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2Mi44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6425"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TmpRdU1qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 6425,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7325"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjczLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPamN6TGpJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 7325,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjczLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7850"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3OC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8zT0M0MUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 7850,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3OC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7880"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzguOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TnpndU9Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 7880,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzguOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8135"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo4MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzRNUzR6TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 8135,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo4MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8565"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjg1LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qZzFMalkxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 8565,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjg1LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9630"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo5Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam81Tmk0ekxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 9630,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo5Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9940"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk5LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qazVMalFzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 9940,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk5LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10465"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMDQuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUyTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam94TURRdU5qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 10465,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE2MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMDQuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02160"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1559"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1841"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-3:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-3:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-3:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 3,
                "tripId": "C-3",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021507$202409021520$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021520$202409021524$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021529$202409021559$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021559$202409021841$REN  AVE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H34M",
                "rtDuration": "PT3H34M",
                "checksum": "0dbe92c9_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "15:07:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "15:20:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107337#TA#0#DA#20924#1S#100010000#1T#1507#LS#100017000#LT#1535#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1507#TO#100017000#TT#1535#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "850",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "15:07:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "15:10:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "15:10:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "15:13:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "15:13:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "15:15:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "15:15:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "15:20:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107337#TA#0#DA#20924#1S#100010000#1T#1507#LS#100017000#LT#1535#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1507#TO#100017000#TT#1535#"
                            },
                            "id": "C-3:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "15:20:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "15:24:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021520$202409021524$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-3:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "15:29:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "15:59:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-3:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "15:59:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 2,
                                "prognosisType": "PROGNOSED",
                                "time": "18:41:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108684#TA#0#DA#20924#1S#100060000#1T#1559#LS#100051003#LT#1841#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1559#TO#100051003#TT#1841#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "235",
                                    "line": "AVE",
                                    "lineId": "6000051003AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 2,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "15:59:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "17:48:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:46:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "18:41:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108684#TA#0#DA#20924#1S#100060000#1T#1559#LS#100051003#LT#1841#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1559#TO#100051003#TT#1841#"
                            },
                            "id": "C-3:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H42M",
                            "dist": 413865,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "16:07:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 2,
                    "prognosisType": "PROGNOSED",
                    "time": "19:50:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 9.759735000000001,
                    "dist": 420721,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi, Do",
                        "sDaysB": "0000000EFDF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4345"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjQzLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qUXpMalExTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 4345,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjQzLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4830"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpvME9DNHpMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56Y3RNekUwTURBd01TMHhOekkxTWpRd056RTFPRFl4TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 4830,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjo0OC4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5070"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NTAuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZOVEF1Tnl3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 5070,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6NTAuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5435"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjU0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPalUwTGpNMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 5435,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjU0LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5635"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU2LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qVTJMak0xTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 5635,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU2LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6040"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqbzJNQzQwTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 6040,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjo2MC40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6665"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjY2LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPalkyTGpZMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 6665,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjY2LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6885"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6NjguODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk5qZ3VPRFVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 6885,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6NjguODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7245"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjcyLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPamN5TGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 7245,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjcyLjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7405"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo3NC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqbzNOQzR3TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 7405,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjo3NC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7650"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjc2LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pjMkxqVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 7650,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjc2LjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE06VCO|C06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "5"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8050"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRBMlZrTlBmRU13TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzRNQzQxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 8050,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTA2VkNPfEMwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo4MC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4495"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDQuOTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZORFF1T1RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 4495,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDQuOTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5245"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1Mi40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8xTWk0ME5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 5245,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1Mi40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5620"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTYuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TlRZdU1pd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 5620,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTYuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5635"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo1Ni4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzFOaTR6TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 5635,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo1Ni4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6575"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY1Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPalkxTGpjMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 6575,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjY1Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6895"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NjguOTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TmpndU9UVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 6895,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NjguOTUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7045"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3MC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8zTUM0ME5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 7045,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3MC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7120"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo3MS4yLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzNNUzR5TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 7120,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo3MS4yLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7495"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjc0Ljk1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qYzBMamsxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 7495,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjc0Ljk1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8645"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo4Ni40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam80Tmk0ME5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 8645,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo4Ni40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8925"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjg5LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qZzVMakkxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 8925,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjg5LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB09VCO|B09"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "10"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9395"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo5My45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakUzTUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBNVZrTlBmRUl3T1NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam81TXk0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 9395,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE3MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA5VkNPfEIwOSIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo5My45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02170"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1707"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1950"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-4:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-4:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-4:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 4,
                "tripId": "C-4",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021607$202409021620$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021620$202409021624$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021637$202409021707$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021707$202409021950$REN  AVE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H43M",
                "rtDuration": "PT3H43M",
                "checksum": "d318eb45_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "16:07:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "16:20:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107338#TA#1#DA#20924#1S#100010000#1T#1607#LS#100017000#LT#1634#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1607#TO#100017000#TT#1634#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "854",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "16:07:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "16:10:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "16:10:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "16:13:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "16:13:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "16:15:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "16:15:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "16:20:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107338#TA#1#DA#20924#1S#100010000#1T#1607#LS#100017000#LT#1634#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1607#TO#100017000#TT#1634#"
                            },
                            "id": "C-4:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "16:20:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "16:24:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021620$202409021624$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-4:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "16:37:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "17:07:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-4:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "17:07:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 2,
                                "prognosisType": "PROGNOSED",
                                "time": "19:50:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108692#TA#0#DA#20924#1S#100060000#1T#1707#LS#100051003#LT#1950#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1707#TO#100051003#TT#1950#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "242",
                                    "line": "AVE",
                                    "lineId": "6000051003AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 2,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "17:07:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "18:56:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "18:54:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "19:50:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108692#TA#0#DA#20924#1S#100060000#1T#1707#LS#100051003#LT#1950#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1707#TO#100051003#TT#1950#"
                            },
                            "id": "C-4:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H43M",
                            "dist": 413865,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "17:05:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 2,
                    "prognosisType": "PROGNOSED",
                    "time": "20:43:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 9.759735000000001,
                    "dist": 420721,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi",
                        "sDaysB": "0000000E7CF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6425"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOalF1TWpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 6425,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7495"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8zTkM0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 7495,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo3NC45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7565"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo3NS42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzNOUzQyTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 7565,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo3NS42NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8030"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6ODAuMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2T0RBdU15d2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 8030,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6ODAuMywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8825"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjg4LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPamc0TGpJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 8825,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjg4LjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9455"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo5NC41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam81TkM0MU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 9455,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo5NC41NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9850"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6OTguNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2T1RndU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 9850,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6OTguNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10170"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoxMDEuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqb3hNREV1Tnl3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 10170,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjoxMDEuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10705"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjEwNy4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qRXdOeTR3TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 10705,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjEwNy4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11600"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMTYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam94TVRZc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFEzTnkwek1UUXdNREF4TFRFM01qVXlOREEzTVRVNE5qRXRNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 11600,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjoxMTYsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "11975"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qRXhPUzQzTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 11975,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjExOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB06VCO|B06"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "12605"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMjYuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakU0TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBMlZrTlBmRUl3TmlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam94TWpZdU1EVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 12605,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjE4MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwNiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMjYuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02180"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1800"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "2043"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-5:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-5:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-5:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 5,
                "tripId": "C-5",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021705$202409021718$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021718$202409021722$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021730$202409021800$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021800$202409022043$REN  AVE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H38M",
                "rtDuration": "PT3H38M",
                "checksum": "4d286c24_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "17:05:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "17:18:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107395#TA#1#DA#20924#1S#100010000#1T#1705#LS#100017000#LT#1732#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1705#TO#100017000#TT#1732#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "856",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "17:05:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "17:08:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:08:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "17:11:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:11:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "17:13:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:13:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "17:18:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107395#TA#1#DA#20924#1S#100010000#1T#1705#LS#100017000#LT#1732#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1705#TO#100017000#TT#1732#"
                            },
                            "id": "C-5:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "17:18:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "17:22:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021718$202409021722$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-5:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "17:30:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "18:00:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-5:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "18:00:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 2,
                                "prognosisType": "PROGNOSED",
                                "time": "20:43:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108674#TA#1#DA#20924#1S#100060000#1T#1800#LS#100051003#LT#2043#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1800#TO#100051003#TT#2043#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "249",
                                    "line": "AVE",
                                    "lineId": "6000051003AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 2,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "18:00:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "19:49:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "19:47:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "20:43:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108674#TA#1#DA#20924#1S#100060000#1T#1800#LS#100051003#LT#2043#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1800#TO#100051003#TT#2043#"
                            },
                            "id": "C-5:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H43M",
                            "dist": 413865,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 2,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "17:05:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 6,
                    "prognosisType": "PROGNOSED",
                    "time": "21:43:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 15.139980000000001,
                    "dist": 420720,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 13. Sep 2024 Lu - Vi",
                        "sDaysB": "0000000E7CF80000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4185"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDEuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOREV1T0RVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTXkwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd01Ua3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJURlpKUVNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 4185,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NDEuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4885"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo0OC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFMVklBIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8wT0M0NE5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZekxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQXhPUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZNVmtsQkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 4885,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo0OC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFMVklBIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5235"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTIuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TlRJdU16VXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk15MHpNVFF3TURBeExURTNNalV5TkRBMk56UXdNVGt0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVEZaSlFTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 5235,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NTIuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6420"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NjQuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFMVklBIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TmpRdU1pd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZekxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQXhPUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZNVmtsQkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 6420,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NjQuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTYzLTMxNDAwMDEtMTcyNTI0MDY3NDAxOS0wMSIsInRyYWluVHlwZSI6IkFMVklBIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6630"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo2Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQUxWSUEifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzJOaTR6TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOak10TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURFNUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFVeFdTVUVpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 6630,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo2Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjMtMzE0MDAwMS0xNzI1MjQwNjc0MDE5LTAxIiwidHJhaW5UeXBlIjoiQUxWSUEifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE07VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "7"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6980"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjY5LjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak00TkNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBM1ZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qWTVMamdzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJNeTB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TVRrdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlRGWkpRU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 6980,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM4NCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA3VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjY5LjgsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2My0zMTQwMDAxLTE3MjUyNDA2NzQwMTktMDEiLCJ0cmFpblR5cGUiOiJBTFZJQSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02384"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "ALVIA"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1805"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "1956"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-6:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-6:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-6:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL011"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Nino"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1340"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRFV3TlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNU0lzSW5SaGNtbG1aazVoYldVaU9pSk9hVzV2SWl3aWNISnBZMlVpT2pFekxqUXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM01TMHpNVFF3TURBeExURTNNalV5TkRBM01UVTRORE10TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtGT1ZDSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Nino",
                                            "price": 1340,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL031"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRFV3TlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNU0lzSW5SaGNtbG1aazVoYldVaU9pSk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qRTJMamMxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOekV0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RRekxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkJUbFFpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Más Renfe Joven",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL013"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Tfa. Tarjeta Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRFV3TlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNeUlzSW5SaGNtbG1aazVoYldVaU9pSlVabUV1SUZSaGNtcGxkR0VnUkc5eVlXUmhJaXdpY0hKcFkyVWlPakUyTGpjMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpFdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EUXpMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpCVGxRaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Tfa. Tarjeta Dorada",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL030"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1785"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRFV3TlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pFM0xqZzFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56RXRNekUwTURBd01TMHhOekkxTWpRd056RTFPRFF6TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaQlRsUWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "C. Joven < 26",
                                            "price": 1785,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzEtMzE0MDAwMS0xNzI1MjQwNzE1ODQzLTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL410"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Adulto Sólo Ida"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2230"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdPRFV3TlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREUXhNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkJaSFZzZEc4Z1U4T3piRzhnU1dSaElpd2ljSEpwWTJVaU9qSXlMak1zSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNNUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TkRNdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrRk9WQ0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Adulto Sólo Ida",
                                            "price": 2230,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwODUwNSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3MS0zMTQwMDAxLTE3MjUyNDA3MTU4NDMtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "08505"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVANT"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "2050"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "2143"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-6:005"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-6:005"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-6:005"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 5,
                            "toLegId": 5
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "economic": true,
                    "convenient": true,
                    "hintCode": 0
                },
                "idx": 6,
                "tripId": "C-6",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021705$202409021718$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021718$202409021722$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021735$202409021805$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409021805$202409021956$RENALVIA$$1$$$$$$§G@F$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409022020$202409022050$__CI$$1$$$$$$§T$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409022050$202409022143$RENAVANT$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT4H38M",
                "rtDuration": "PT4H38M",
                "checksum": "79748183_3",
                "transferCount": 2,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "17:05:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "17:18:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107395#TA#1#DA#20924#1S#100010000#1T#1705#LS#100017000#LT#1732#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1705#TO#100017000#TT#1732#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "856",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "17:05:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "17:08:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:08:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "17:11:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:11:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "17:13:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "17:13:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "17:18:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107395#TA#1#DA#20924#1S#100010000#1T#1705#LS#100017000#LT#1732#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1705#TO#100017000#TT#1732#"
                            },
                            "id": "C-6:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "17:18:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "17:22:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021718$202409021722$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-6:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "17:35:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "18:05:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-6:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "18:05:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "19:56:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108738#TA#0#DA#20924#1S#100060000#1T#1805#LS#100043019#LT#2202#PU#80#RT#1#CA#107#ZE#ALVIA#ZB#RENALVIA#PC#2#FR#100060000#FT#1805#TO#100043019#TT#2202#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENALVIA",
                                    "internalName": "RENALVIA",
                                    "displayNumber": "ALVIA",
                                    "num": "285",
                                    "line": "ALVIA",
                                    "lineId": "6000043019GL023(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "ALVIA"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "18:05:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Huelva, Huelva"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "arrTime": "19:56:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108738#TA#0#DA#20924#1S#100060000#1T#1805#LS#100043019#LT#2202#PU#80#RT#1#CA#107#ZE#ALVIA#ZB#RENALVIA#PC#2#FR#100060000#FT#1805#TO#100043019#TT#2202#"
                            },
                            "id": "C-6:003",
                            "idx": 3,
                            "name": "RENALVIA",
                            "number": "ALVIA",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Huelva, Huelva",
                            "directionFlag": "0",
                            "duration": "PT1H51M",
                            "dist": 295721,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "time": "20:20:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "time": "20:50:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-6:004",
                            "idx": 4,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "prognosisType": "PROGNOSED",
                                "time": "20:50:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 6,
                                "prognosisType": "PROGNOSED",
                                "time": "21:43:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109271#TA#0#DA#20924#1S#100005000#1T#1857#LS#100051003#LT#2143#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100005000#FT#1857#TO#100051003#TT#2143#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENAVANT",
                                    "internalName": "RENAVANT",
                                    "displayNumber": "AVANT",
                                    "num": "795",
                                    "line": "AVANT",
                                    "lineId": "0500051003AV008(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 5,
                                    "routeIdxTo": 6,
                                    "matchId": "AVANT"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 5,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "20:50:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 6,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "21:43:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109271#TA#0#DA#20924#1S#100005000#1T#1857#LS#100051003#LT#2143#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100005000#FT#1857#TO#100051003#TT#2143#"
                            },
                            "id": "C-6:005",
                            "idx": 5,
                            "name": "RENAVANT",
                            "number": "AVANT",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT53M",
                            "dist": 118144,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 0,
                    "prognosisType": "PROGNOSED",
                    "time": "18:35:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 1,
                    "prognosisType": "PROGNOSED",
                    "time": "22:03:00",
                    "date": "2024-09-02"
                },
                "Eco": {
                    "co2": 9.193981,
                    "dist": 396123,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 6. Sep 2024",
                        "sDaysB": "0000000E7C000000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5140"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTEuNCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZOVEV1TkN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 5140,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6NTEuNCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5995"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1OS45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8xT1M0NU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 5995,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo1OS45NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6280"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2Mi44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzJNaTQ0TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 6280,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo2Mi44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6425"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TmpRdU1qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 6425,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NjQuMjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7325"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjczLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPamN6TGpJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 7325,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjczLjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7850"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3OC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8zT0M0MUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 7850,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo3OC41LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7880"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzguOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TnpndU9Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRjM0xUTXhOREF3TURFdE1UY3lOVEkwTURjeE5UZzJNUzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 7880,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NzguOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8135"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo4MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzRNUzR6TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzRORGMzTFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TlRnMk1TMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 8135,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo4MS4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDc3LTMxNDAwMDEtMTcyNTI0MDcxNTg2MS0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "8565"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjg1LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qZzFMalkxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 8565,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjg1LjY1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9630"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo5Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam81Tmk0ekxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpjdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EWXhMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 9630,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo5Ni4zLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "9940"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk5LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qazVMalFzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOeTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TmpFdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 9940,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjk5LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB08VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "6"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "10465"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMDQuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNak01TUNJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBNFZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam94TURRdU5qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 10465,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjM5MCIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA4VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjoxMDQuNjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02390"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "1930"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "2203"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-7:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-7:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-7:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 7,
                "tripId": "C-7",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409021835$202409021848$Ren   C1$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021848$202409021852$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021900$202409021930$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409021930$202409022203$REN  AVE$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H28M",
                "rtDuration": "PT3H28M",
                "checksum": "98b652dd_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "18:35:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "18:48:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107337#TA#1#DA#20924#1S#100010000#1T#1835#LS#100017000#LT#1903#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1835#TO#100017000#TT#1903#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 117,
                                            "g": 182,
                                            "b": 224,
                                            "hex": "#75B6E0"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C1",
                                    "internalName": "Ren   C1",
                                    "displayNumber": "C1",
                                    "num": "956",
                                    "line": "C1",
                                    "lineId": "10T0001C1(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "C1"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "18:35:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "18:38:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "18:38:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "18:41:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "18:41:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "18:43:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "18:43:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "18:48:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#107337#TA#1#DA#20924#1S#100010000#1T#1835#LS#100017000#LT#1903#PU#80#RT#1#CA#107#ZE#C1#ZB#Ren   C1#PC#2#FR#100010000#FT#1835#TO#100017000#TT#1903#"
                            },
                            "id": "C-7:000",
                            "idx": 0,
                            "name": "Ren C1",
                            "number": "C1",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "18:48:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "18:52:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409021848$202409021852$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-7:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "19:00:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "19:30:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-7:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "19:30:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "22:03:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108739#TA#0#DA#20924#1S#100060000#1T#1930#LS#100051003#LT#2203#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1930#TO#100051003#TT#2203#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "286",
                                    "line": "AVE",
                                    "lineId": "6000051003AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "19:30:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "22:03:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108739#TA#0#DA#20924#1S#100060000#1T#1930#LS#100051003#LT#2203#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#1930#TO#100051003#TT#2203#"
                            },
                            "id": "C-7:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H33M",
                            "dist": 389267,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },*/
            {
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 10,
                    "prognosisType": "PROGNOSED",
                    "time": "20:22:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Llegada Martes, 03.09.2024",
                                "key": "text.connection.section.arrival.date.deviation",
                                "type": "H",
                                "txtN": "Llegada Martes, 03.09.2024"
                            }
                        ]
                    },
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 5,
                    "prognosisType": "PROGNOSED",
                    "time": "00:06:00",
                    "date": "2024-09-03"
                },
                "Eco": {
                    "co2": 15.442848,
                    "dist": 429134,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 12. Sep 2024",
                        "sDaysB": "0000000FFFF00000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "LC012|CB11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Niño Básica"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "500"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxNiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJMQzAxMnxDQjExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJOacOxbyBCw6FzaWNhIiwicHJpY2UiOjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkxPIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TmlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKTVF6QXhNbnhEUWpFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpPYWNPeGJ5QkN3NkZ6YVdOaElpd2ljSEpwWTJVaU9qVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM055MHpNVFF3TURBeExURTNNalV5TkRBM01UVTROakV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmt4UEluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Niño Básica",
                                            "price": 500,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxNiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJMQzAxMnxDQjExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJOacOxbyBCw6FzaWNhIiwicHJpY2UiOjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3Ny0zMTQwMDAxLTE3MjUyNDA3MTU4NjEtMDEiLCJ0cmFpblR5cGUiOiJBVkxPIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "LC107|CB11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básica"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4900"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxNiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJMQzEwN3xDQjExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNhIiwicHJpY2UiOjQ5LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZMTyJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TmlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKTVF6RXdOM3hEUWpFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTmhJaXdpY0hKcFkyVWlPalE1TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOemN0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RZeExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWk1UeUo5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básica",
                                            "price": 4900,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxNiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJMQzEwN3xDQjExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNhIiwicHJpY2UiOjQ5LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzctMzE0MDAwMS0xNzI1MjQwNzE1ODYxLTAxIiwidHJhaW5UeXBlIjoiQVZMTyJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02216"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVLO"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "2110"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0006"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-8:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-8:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-8:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "DESCRIPTION",
                                                    "value": "ida/regreso"
                                                },
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "340"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiIxMDAwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMCIsImZlY2hhVmlhamUiOiIyMDI0MDkwMiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjozLjQsImN1cnJlbmN5IjoiRVVSIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJeE1EQXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TUNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1Ea3dNaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TlNJc0luQnlhV05sSWpvekxqUXNJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "ida/regreso",
                                            "desc": "ida/regreso",
                                            "price": 340,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiIxMDAwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMCIsImZlY2hhVmlhamUiOiIyMDI0MDkwMiIsImNkZ29UYXJpZmEiOiJDRTAxNSIsInByaWNlIjozLjQsImN1cnJlbmN5IjoiRVVSIn0="
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "DESCRIPTION",
                                                    "value": "Sencillo"
                                                },
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "170"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiIxMDAwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMCIsImZlY2hhVmlhamUiOiIyMDI0MDkwMiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjoxLjcsImN1cnJlbmN5IjoiRVVSIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZMlZ5WTJGdWFXRnpJaXdpZG1WeWMybHZiaUk2SWpFdU1qRWlMQ0pqWkdkdlRuVmpiR1Z2SWpvaU1UQWlMQ0pqWkdkdlJYTjBZV05wYjI1UGNtbG5aVzRpT2lJeE1EQXdNQ0lzSW1Oa1oyOUZjM1JoWTJsdmJrUmxjM1JwYm04aU9pSXhPREF3TUNJc0ltWmxZMmhoVm1saGFtVWlPaUl5TURJME1Ea3dNaUlzSW1Oa1oyOVVZWEpwWm1FaU9pSkRSVEF4TUNJc0luQnlhV05sSWpveExqY3NJbU4xY25KbGJtTjVJam9pUlZWU0luMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Sencillo",
                                            "desc": "Sencillo",
                                            "price": 170,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtY2VyY2FuaWFzIiwidmVyc2lvbiI6IjEuMjEiLCJjZGdvTnVjbGVvIjoiMTAiLCJjZGdvRXN0YWNpb25PcmlnZW4iOiIxMDAwMCIsImNkZ29Fc3RhY2lvbkRlc3Rpbm8iOiIxODAwMCIsImZlY2hhVmlhamUiOiIyMDI0MDkwMiIsImNkZ29UYXJpZmEiOiJDRTAxMCIsInByaWNlIjoxLjcsImN1cnJlbmN5IjoiRVVSIn0="
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe Cercanias Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe Cercanias"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-8:000"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-8:000"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-8:000"
                                }
                            ],
                            "name": "Renfe Cercanias Pricing",
                            "fromLegId": 0,
                            "toLegId": 0
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe Cercanias,Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "hintCode": 0
                },
                "idx": 8,
                "tripId": "C-8",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409022022$202409022035$Ren  C10$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022035$202409022039$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022040$202409022110$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409022110$202409030006$REN AVLO$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT3H44M",
                "rtDuration": "PT3H44M",
                "checksum": "b8a8bfa6_3",
                "transferCount": 1,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 10,
                                "prognosisType": "PROGNOSED",
                                "time": "20:22:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 14,
                                "prognosisType": "PROGNOSED",
                                "time": "20:35:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104284#TA#0#DA#20924#1S#100010200#1T#1944#LS#100017000#LT#2049#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#1944#TO#100017000#TT#2049#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 156,
                                            "g": 200,
                                            "b": 62,
                                            "hex": "#9CC83E"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C10",
                                    "internalName": "Ren  C10",
                                    "displayNumber": "C10",
                                    "num": "1081",
                                    "line": "C10",
                                    "lineId": "10T0003C10(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 10,
                                    "routeIdxTo": 14,
                                    "matchId": "C10"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 10,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depTime": "20:22:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 11,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "20:25:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:25:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 12,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "20:28:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:28:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 13,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "20:30:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:30:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 14,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "20:35:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104284#TA#0#DA#20924#1S#100010200#1T#1944#LS#100017000#LT#2049#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#1944#TO#100017000#TT#2049#"
                            },
                            "id": "C-8:000",
                            "idx": 0,
                            "name": "Ren C10",
                            "number": "C10",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "20:35:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "20:39:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022035$202409022039$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-8:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "20:40:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "21:10:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-8:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "21:10:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 5,
                                "prognosisType": "PROGNOSED",
                                "time": "00:06:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108717#TA#0#DA#20924#1S#100060000#1T#2110#LS#100051003#LT#10006#PU#80#RT#1#CA#107#ZE#AVLO#ZB#REN AVLO#PC#2#FR#100060000#FT#2110#TO#100051003#TT#10006#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVLO",
                                    "internalName": "REN AVLO",
                                    "displayNumber": "AVLO",
                                    "num": "266",
                                    "line": "AVLO",
                                    "lineId": "6000051003LC112(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 5,
                                    "matchId": "AVLO"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "21:10:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Ciudad Real, Ciudad Real",
                                        "id": "A=1@O=Estación de tren Ciudad Real, Ciudad Real@X=-3913634@Y=38985300@U=80@L=100037200@",
                                        "extId": "100037200",
                                        "routeIdx": 1,
                                        "lon": -3.913634,
                                        "lat": 38.9853,
                                        "depTime": "22:06:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "22:04:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Puertollano, Puertollano",
                                        "id": "A=1@O=Estación de tren Puertollano, Puertollano@X=-4111657@Y=38691280@U=80@L=100037300@",
                                        "extId": "100037300",
                                        "routeIdx": 2,
                                        "lon": -4.111657,
                                        "lat": 38.69128,
                                        "depTime": "22:21:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "22:19:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Villanueva de Cordoba-Los Pedroches, Villanueva de Córdoba",
                                        "id": "A=1@O=Estación de tren Villanueva de Cordoba-Los Pedroches, Villanueva de Córdoba@X=-4570952@Y=38255403@U=80@L=100037704@",
                                        "extId": "100037704",
                                        "routeIdx": 3,
                                        "lon": -4.570952,
                                        "lat": 38.255403,
                                        "depTime": "22:47:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "22:45:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 4,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "23:12:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "23:10:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 5,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "00:06:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108717#TA#0#DA#20924#1S#100060000#1T#2110#LS#100051003#LT#10006#PU#80#RT#1#CA#107#ZE#AVLO#ZB#REN AVLO#PC#2#FR#100060000#FT#2110#TO#100051003#TT#10006#"
                            },
                            "id": "C-8:003",
                            "idx": 3,
                            "name": "REN AVLO",
                            "number": "AVLO",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H56M",
                            "dist": 422278,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.913634,
                                        "lat": 38.9853
                                    },
                                    {
                                        "order": 2,
                                        "lon": -4.111657,
                                        "lat": 38.69128
                                    },
                                    {
                                        "order": 3,
                                        "lon": -4.570952,
                                        "lat": 38.255403
                                    },
                                    {
                                        "order": 4,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 5,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            /*{
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 10,
                    "prognosisType": "PROGNOSED",
                    "time": "20:51:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Llegada Martes, 03.09.2024",
                                "key": "text.connection.section.arrival.date.deviation",
                                "type": "H",
                                "txtN": "Llegada Martes, 03.09.2024"
                            }
                        ]
                    },
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 6,
                    "prognosisType": "PROGNOSED",
                    "time": "09:07:00",
                    "date": "2024-09-03"
                },
                "Notes": {
                    "Note": [
                        {
                            "value": "Trayecto largo: Salida: 02.09.2024, Llegada: 03.09.2024",
                            "key": "text.connection.duration.oblong.message",
                            "type": "H",
                            "txtN": "Trayecto largo: Salida: 02.09.2024, Llegada: 03.09.2024"
                        }
                    ]
                },
                "Eco": {
                    "co2": 17.161964,
                    "dist": 675778,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 5. Sep 2024",
                        "sDaysB": "0000000C78000000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2035"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjIwLjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qSXdMak0xTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 2035,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjIwLjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2375"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjMuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZNak11TnpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 2375,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjMuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2545"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjI1LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPakkxTGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 2545,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjI1LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2545"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyNS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpveU5TNDBOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 2545,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyNS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2970"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjI5LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qSTVMamNzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 2970,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjI5LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3120"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjMxLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPak14TGpJc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 3120,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjMxLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3180"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozMS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqb3pNUzQ0TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 3180,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozMS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3220"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzIuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk16SXVNaXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 3220,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzIuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3390"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjMzLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPak16TGprc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 3390,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjMzLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3900"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjozOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqb3pPU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 3900,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjozOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4030"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQwLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pRd0xqTXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk5TMHpNVFF3TURBeExURTNNalV5TkRBMk56UXdORGN0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 4030,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQwLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4240"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Mi40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzBNaTQwTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 4240,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Mi40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2705"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MjcuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZNamN1TURVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 2705,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MjcuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3160"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjozMS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam96TVM0MkxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 3160,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjozMS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3385"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MzMuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TXpNdU9EVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk5TMHpNVFF3TURBeExURTNNalV5TkRBMk56UXdORGN0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 3385,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MzMuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3845"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjozOC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqb3pPQzQwTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 3845,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjozOC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4150"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NDEuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TkRFdU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZMUxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQTBOeTB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 4150,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NDEuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4285"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo0Mi44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzBNaTQ0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 4285,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo0Mi44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4490"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjQ0LjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPalEwTGprc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 4490,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjQ0LjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4510"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjQ1LjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qUTFMakVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 4510,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjQ1LjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4810"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo0OC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8wT0M0eExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 4810,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo0OC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5900"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo1OSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam8xT1N3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 5900,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo1OSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6090"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjYwLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qWXdMamtzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 6090,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjYwLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6410"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo2NC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam8yTkM0eExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 6410,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo2NC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02212"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "2139"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0021"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-9:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-9:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-9:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1315"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjEzLjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qRXpMakUxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBNakl0TXpFME1EQXdNUzB4TnpJMU1qUXdOekV4TmpNNExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 1315,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjEzLjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1535"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MTUuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZNVFV1TXpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFF5TWkwek1UUXdNREF4TFRFM01qVXlOREEzTVRFMk16Z3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 1535,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MTUuMzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1580"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoxNS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpveE5TNDRMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME1qSXRNekUwTURBd01TMHhOekkxTWpRd056RXhOak00TFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaRkluMD0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 1580,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoxNS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1645"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjE2LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPakUyTGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 1645,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjE2LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1845"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE4LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qRTRMalExTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBNakl0TXpFME1EQXdNUzB4TnpJMU1qUXdOekV4TmpNNExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 1845,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE4LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1975"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjoxOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqb3hPUzQzTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzROREl5TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TVRZek9DMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 1975,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjoxOS43NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2020"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjIwLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPakl3TGpJc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFF5TWkwek1UUXdNREF4TFRFM01qVXlOREEzTVRFMk16Z3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 2020,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjIwLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2085"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MjAuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk1qQXVPRFVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUXlNaTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVEUyTXpndE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 2085,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MjAuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2195"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjIxLjk1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPakl4TGprMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 2195,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjIxLjk1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2425"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjoyNC4yNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqb3lOQzR5TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzROREl5TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TVRZek9DMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 2425,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjoyNC4yNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2500"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pJMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 2500,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjI1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE10VCO|C12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "3"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2635"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjoyNi4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRFd1ZrTlBmRU14TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqb3lOaTR6TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzROREl5TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TVRZek9DMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 2635,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTEwVkNPfEMxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjoyNi4zNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3505"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MzUuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZNelV1TURVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTRPRFF5TWkwek1UUXdNREF4TFRFM01qVXlOREEzTVRFMk16Z3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 3505,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MzUuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4085"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo0MC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam8wTUM0NE5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRJeUxUTXhOREF3TURFdE1UY3lOVEkwTURjeE1UWXpPQzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 4085,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjo0MC44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4380"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NDMuOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TkRNdU9Dd2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRJeUxUTXhOREF3TURFdE1UY3lOVEkwTURjeE1UWXpPQzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 4380,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6NDMuOCwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4645"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo0Ni40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqbzBOaTQwTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzROREl5TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TVRZek9DMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 4645,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjo0Ni40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5370"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NTMuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TlRNdU55d2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRJeUxUTXhOREF3TURFdE1UY3lOVEkwTURjeE1UWXpPQzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 5370,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NTMuNywiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5415"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU0LjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPalUwTGpFMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 5415,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjU0LjE1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5545"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo1NS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzFOUzQwTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzROREl5TFRNeE5EQXdNREV0TVRjeU5USTBNRGN4TVRZek9DMHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 5545,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo1NS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5805"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo1OC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8xT0M0d05Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGc0TkRJeUxUTXhOREF3TURFdE1UY3lOVEkwTURjeE1UWXpPQzB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 5805,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo1OC4wNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg4NDIyLTMxNDAwMDEtMTcyNTI0MDcxMTYzOC0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5840"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjU4LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qVTRMalFzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUXlNaTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVEUyTXpndE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 5840,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjU4LjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7120"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo3MS4yLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam8zTVM0eUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 7120,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo3MS4yLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7350"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjczLjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qY3pMalVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUXlNaTB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVEUyTXpndE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 7350,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjczLjUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQyMi0zMTQwMDAxLTE3MjUyNDA3MTE2MzgtMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB06VCO|B08"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "7740"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo3Ny40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVd05UQXdJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdNakEyTXlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpBMlZrTlBmRUl3T0NJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam8zTnk0MExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTWpJdE16RTBNREF3TVMweE56STFNalF3TnpFeE5qTTRMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 7740,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUwNTAwIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwMjA2MyIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjA2VkNPfEIwOCIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo3Ny40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0MjItMzE0MDAwMS0xNzI1MjQwNzExNjM4LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02063"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "0628"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0717"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-9:005"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-9:005"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-9:005"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 5,
                            "toLegId": 5
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL011"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Nino"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1340"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NS0zMTQwMDAxLTE3MjUyNDA3MTU4NTUtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFEzTlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNU0lzSW5SaGNtbG1aazVoYldVaU9pSk9hVzV2SWl3aWNISnBZMlVpT2pFekxqUXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0T0RRM05TMHpNVFF3TURBeExURTNNalV5TkRBM01UVTROVFV0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtGT1ZDSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Nino",
                                            "price": 1340,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjEzLjQsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NS0zMTQwMDAxLTE3MjUyNDA3MTU4NTUtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL031"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFEzTlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNU0lzSW5SaGNtbG1aazVoYldVaU9pSk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qRTJMamMxTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOelV0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RVMUxUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkJUbFFpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Más Renfe Joven",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL013"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Tfa. Tarjeta Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1675"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFEzTlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNeUlzSW5SaGNtbG1aazVoYldVaU9pSlVabUV1SUZSaGNtcGxkR0VnUkc5eVlXUmhJaXdpY0hKcFkyVWlPakUyTGpjMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpVdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EVTFMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpCVGxRaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Tfa. Tarjeta Dorada",
                                            "price": 1675,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjE2Ljc1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL030"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "1785"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFEzTlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pFM0xqZzFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56VXRNekUwTURBd01TMHhOekkxTWpRd056RTFPRFUxTFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaQlRsUWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "C. Joven < 26",
                                            "price": 1785,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjE3Ljg1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzUtMzE0MDAwMS0xNzI1MjQwNzE1ODU1LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL410"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Adulto Sólo Ida"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2230"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NS0zMTQwMDAxLTE3MjUyNDA3MTU4NTUtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVXdOVEF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFEzTlNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREUXhNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkJaSFZzZEc4Z1U4T3piRzhnU1dSaElpd2ljSEpwWTJVaU9qSXlMak1zSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TlRVdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrRk9WQ0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Adulto Sólo Ida",
                                            "price": 2230,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjUwNTAwIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODQ3NSIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjIyLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NS0zMTQwMDAxLTE3MjUyNDA3MTU4NTUtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "08475"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVANT"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "0814"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0907"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-9:007"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-9:007"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-9:007"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 7,
                            "toLegId": 7
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "detour": true,
                    "hintCode": 455
                },
                "idx": 9,
                "tripId": "C-9",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409022051$202409022104$Ren  C10$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022104$202409022108$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022109$202409022139$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$202409022139$202409030021$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$202409030558$202409030628$__CI$$1$$$$$$§T$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409030628$202409030717$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$202409030744$202409030814$__CI$$1$$$$$$§T$A=1@O=Estación de tren Cordoba, Córdoba@L=100050500@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409030814$202409030907$RENAVANT$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT12H16M",
                "rtDuration": "PT12H16M",
                "checksum": "4f3c4add_3",
                "transferCount": 3,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 10,
                                "prognosisType": "PROGNOSED",
                                "time": "20:51:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 14,
                                "prognosisType": "PROGNOSED",
                                "time": "21:04:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104281#TA#1#DA#20924#1S#100010200#1T#2013#LS#100017000#LT#2118#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#2013#TO#100017000#TT#2118#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 156,
                                            "g": 200,
                                            "b": 62,
                                            "hex": "#9CC83E"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C10",
                                    "internalName": "Ren  C10",
                                    "displayNumber": "C10",
                                    "num": "1082",
                                    "line": "C10",
                                    "lineId": "10T0003C10(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 10,
                                    "routeIdxTo": 14,
                                    "matchId": "C10"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 10,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depTime": "20:51:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 11,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "20:54:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:54:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 12,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "20:57:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:57:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 13,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "20:59:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:59:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 14,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "21:04:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104281#TA#1#DA#20924#1S#100010200#1T#2013#LS#100017000#LT#2118#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#2013#TO#100017000#TT#2118#"
                            },
                            "id": "C-9:000",
                            "idx": 0,
                            "name": "Ren C10",
                            "number": "C10",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "21:04:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "21:08:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022104$202409022108$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-9:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "21:09:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "21:39:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-9:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "21:39:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "00:21:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108713#TA#0#DA#20924#1S#100060000#1T#2139#LS#54413#LT#10021#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#2139#TO#54413#TT#10021#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "262",
                                    "line": "AVE",
                                    "lineId": "6000054413AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "21:39:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Malaga Maria Zambrano, Málaga"
                                    },
                                    {
                                        "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                        "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                        "extId": "54413",
                                        "routeIdx": 1,
                                        "lon": -4.431385,
                                        "lat": 36.711334,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "00:21:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108713#TA#0#DA#20924#1S#100060000#1T#2139#LS#54413#LT#10021#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#2139#TO#54413#TT#10021#"
                            },
                            "id": "C-9:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Malaga Maria Zambrano, Málaga",
                            "directionFlag": "0",
                            "duration": "PT2H42M",
                            "dist": 416071,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.431385,
                                        "lat": 36.711334
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "time": "05:58:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "time": "06:28:00",
                                "date": "2024-09-03"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-9:004",
                            "idx": 4,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "06:28:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "07:17:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108448#TA#0#DA#30924#1S#54413#1T#628#LS#100060000#LT#918#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#54413#FT#628#TO#100060000#TT#918#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "190",
                                    "line": "AVE",
                                    "lineId": "5441360000AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                        "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                        "extId": "54413",
                                        "routeIdx": 0,
                                        "lon": -4.431385,
                                        "lat": 36.711334,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "06:28:00",
                                        "depDate": "2024-09-03",
                                        "depDir": "Estación de tren Madrid-Puerta de Atocha, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "arrTime": "07:17:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-03",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108448#TA#0#DA#30924#1S#54413#1T#628#LS#100060000#LT#918#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#54413#FT#628#TO#100060000#TT#918#"
                            },
                            "id": "C-9:005",
                            "idx": 5,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                            "directionFlag": "0",
                            "duration": "PT49M",
                            "dist": 134709,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.431385,
                                        "lat": 36.711334
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "time": "07:44:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "time": "08:14:00",
                                "date": "2024-09-03"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-9:006",
                            "idx": 6,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Cordoba, Córdoba",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                "extId": "100050500",
                                "lon": -4.789453,
                                "lat": 37.888292,
                                "routeIdx": 5,
                                "prognosisType": "PROGNOSED",
                                "time": "08:14:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 6,
                                "prognosisType": "PROGNOSED",
                                "time": "09:07:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109269#TA#0#DA#30924#1S#100005000#1T#625#LS#100051003#LT#907#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100005000#FT#625#TO#100051003#TT#907#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENAVANT",
                                    "internalName": "RENAVANT",
                                    "displayNumber": "AVANT",
                                    "num": "793",
                                    "line": "AVANT",
                                    "lineId": "0500051003AV008(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 5,
                                    "routeIdxTo": 6,
                                    "matchId": "AVANT"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 5,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "08:14:00",
                                        "depDate": "2024-09-03",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 6,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "09:07:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-03",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109269#TA#0#DA#30924#1S#100005000#1T#625#LS#100051003#LT#907#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#100005000#FT#625#TO#100051003#TT#907#"
                            },
                            "id": "C-9:007",
                            "idx": 7,
                            "name": "RENAVANT",
                            "number": "AVANT",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT53M",
                            "dist": 118144,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 1,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            },*/
            /*{
                "Origin": {
                    "name": "Estación de tren Madrid-Principe Pio, Madrid",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                    "extId": "100010000",
                    "lon": -3.71908,
                    "lat": 40.421533,
                    "routeIdx": 10,
                    "prognosisType": "PROGNOSED",
                    "time": "20:51:00",
                    "date": "2024-09-02"
                },
                "Destination": {
                    "Notes": {
                        "Note": [
                            {
                                "value": "Llegada Martes, 03.09.2024",
                                "key": "text.connection.section.arrival.date.deviation",
                                "type": "H",
                                "txtN": "Llegada Martes, 03.09.2024"
                            }
                        ]
                    },
                    "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                    "type": "ST",
                    "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                    "extId": "100051003",
                    "lon": -5.975274,
                    "lat": 37.392123,
                    "routeIdx": 4,
                    "prognosisType": "PROGNOSED",
                    "time": "09:15:00",
                    "date": "2024-09-03"
                },
                "Notes": {
                    "Note": [
                        {
                            "value": "Trayecto largo: Salida: 02.09.2024, Llegada: 03.09.2024",
                            "key": "text.connection.duration.oblong.message",
                            "type": "H",
                            "txtN": "Trayecto largo: Salida: 02.09.2024, Llegada: 03.09.2024"
                        }
                    ]
                },
                "Eco": {
                    "co2": 19.095269000000002,
                    "dist": 680837,
                    "type": "PUT",
                    "rating": 3
                },
                "EcoCmp": [
                    {
                        "co2": 72.481308472183,
                        "type": "BEE"
                    }
                ],
                "ServiceDays": [
                    {
                        "planningPeriodBegin": "2024-07-31",
                        "planningPeriodEnd": "2025-05-27",
                        "sDaysR": "no cada día",
                        "sDaysI": "2. hasta 5. Sep 2024",
                        "sDaysB": "0000000C78000000000000000000000000000000000000000000000000000000000000000000"
                    }
                ],
                "TariffResult": {
                    "fareSetItem": [
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1011|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2035"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjIwLjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNWHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTVwdzdGdklpd2ljSEpwWTJVaU9qSXdMak0xTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Niño",
                                            "price": 2035,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE5pw7FvIiwicHJpY2UiOjIwLjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1031|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2375"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjMuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNWHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRTNEb1hNZ1VtVnVabVVnU205MlpXNGlMQ0p3Y21salpTSTZNak11TnpVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico Más Renfe Joven",
                                            "price": 2375,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMXxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIE3DoXMgUmVuZmUgSm92ZW4iLCJwcmljZSI6MjMuNzUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1013|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2545"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjI1LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNM3hEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRlF1Ukc5eVlXUmhJaXdpY0hKcFkyVWlPakkxTGpRMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico T.Dorada",
                                            "price": 2545,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxM3xDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIFQuRG9yYWRhIiwicHJpY2UiOjI1LjQ1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2011|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2545"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyNS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNWHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk9hY094YnlJc0luQnlhV05sSWpveU5TNDBOU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Niño",
                                            "price": 2545,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBOacOxbyIsInByaWNlIjoyNS40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2031|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2970"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjI5LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNWHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qSTVMamNzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Más Renfe Joven",
                                            "price": 2970,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMXxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjI5LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1548|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3120"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjMxLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UVTBPSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRFFnYnlCdHc2RnpJaXdpY0hKcFkyVWlPak14TGpJc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico 4 o más",
                                            "price": 3120,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTU0OHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIDQgbyBtw6FzIiwicHJpY2UiOjMxLjIsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2013|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3180"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozMS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNM3hEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQlVMa1J2Y21Ga1lTSXNJbkJ5YVdObElqb3pNUzQ0TENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige T.Dorada",
                                            "price": 3180,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxM3xDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBULkRvcmFkYSIsInByaWNlIjozMS44LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1030|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3220"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzIuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXpNSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJRU11SUVwdmRtVnVJRHdnTWpZaUxDSndjbWxqWlNJNk16SXVNaXdpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico C. Joven < 26",
                                            "price": 3220,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAzMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIEMuIEpvdmVuIDwgMjYiLCJwcmljZSI6MzIuMiwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N1010|CL11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Básico"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3390"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjMzLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01UQXhNSHhEVERFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpDdzZGemFXTnZJaXdpY0hKcFkyVWlPak16TGprc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Básico",
                                            "price": 3390,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMTAxMHxDTDExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJCw6FzaWNvIiwicHJpY2UiOjMzLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2548|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3900"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjozOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qVTBPSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQTBJRzhnYmNPaGN5SXNJbkJ5YVdObElqb3pPU3dpWTNWeWNtVnVZM2tpT2lKRlZWSWlMQ0oxZFdsa0lqb2lORFE0TVRnM09UWTFMVE14TkRBd01ERXRNVGN5TlRJME1EWTNOREEwTnkwd01TSXNJblJ5WVdsdVZIbHdaU0k2SWtGV1JTSjk=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige 4 o más",
                                            "price": 3900,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjU0OHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSA0IG8gbcOhcyIsInByaWNlIjozOSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2030|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4030"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQwLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXpNSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pRd0xqTXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk5TMHpNVFF3TURBeExURTNNalV5TkRBMk56UXdORGN0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige C. Joven < 26",
                                            "price": 4030,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAzMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjQwLjMsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "ELIGE",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N2010|CE11VCO|C11"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4240"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Mi40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT01qQXhNSHhEUlRFeFZrTlBmRU14TVNJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTSXNJbkJ5YVdObElqbzBNaTQwTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EYzVOalV0TXpFME1EQXdNUzB4TnpJMU1qUXdOamMwTURRM0xUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkZJbjA9",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige",
                                            "price": 4240,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMjAxMHxDRTExVkNPfEMxMSIsInRhcmlmZk5hbWUiOiJFbGlnZSIsInByaWNlIjo0Mi40LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "ELIGE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3011|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2705"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MjcuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNWHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVG1uRHNXOGlMQ0p3Y21salpTSTZNamN1TURVc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Niño",
                                            "price": 2705,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTmnDsW8iLCJwcmljZSI6MjcuMDUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3031|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3160"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjozMS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNWHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVGNPaGN5QlNaVzVtWlNCS2IzWmxiaUlzSW5CeWFXTmxJam96TVM0MkxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort Más Renfe Joven",
                                            "price": 3160,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMXxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgTcOhcyBSZW5mZSBKb3ZlbiIsInByaWNlIjozMS42LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3013|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3385"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MzMuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNM3hDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnVkM1RWIzSmhaR0VpTENKd2NtbGpaU0k2TXpNdU9EVXNJbU4xY25KbGJtTjVJam9pUlZWU0lpd2lkWFZwWkNJNklqUTBPREU0TnprMk5TMHpNVFF3TURBeExURTNNalV5TkRBMk56UXdORGN0TURFaUxDSjBjbUZwYmxSNWNHVWlPaUpCVmtVaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort T.Dorada",
                                            "price": 3385,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxM3xCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgVC5Eb3JhZGEiLCJwcmljZSI6MzMuODUsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4011|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Niño"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3845"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjozOC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNWHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JPYWNPeGJ5SXNJbkJ5YVdObElqb3pPQzQwTlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Niño",
                                            "price": 3845,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBOacOxbyIsInByaWNlIjozOC40NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3548|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4150"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NDEuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016VTBPSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnTkNCdklHM0RvWE1pTENKd2NtbGpaU0k2TkRFdU5Td2lZM1Z5Y21WdVkza2lPaUpGVlZJaUxDSjFkV2xrSWpvaU5EUTRNVGczT1RZMUxUTXhOREF3TURFdE1UY3lOVEkwTURZM05EQTBOeTB3TVNJc0luUnlZV2x1Vkhsd1pTSTZJa0ZXUlNKOQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort 4 o más",
                                            "price": 4150,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzU0OHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgNCBvIG3DoXMiLCJwcmljZSI6NDEuNSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3030|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "E.Confort C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4285"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo0Mi44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXpNSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGTGtOdmJtWnZjblFnUXk0Z1NtOTJaVzRnUENBeU5pSXNJbkJ5YVdObElqbzBNaTQ0TlN3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "E.Confort C. Joven < 26",
                                            "price": 4285,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAzMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFLkNvbmZvcnQgQy4gSm92ZW4gPCAyNiIsInByaWNlIjo0Mi44NSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "CONFORT",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4031|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4490"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjQ0LjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNWHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JOdzZGeklGSmxibVpsSUVwdmRtVnVJaXdpY0hKcFkyVWlPalEwTGprc0ltTjFjbkpsYm1ONUlqb2lSVlZTSWl3aWRYVnBaQ0k2SWpRME9ERTROemsyTlMwek1UUXdNREF4TFRFM01qVXlOREEyTnpRd05EY3RNREVpTENKMGNtRnBibFI1Y0dVaU9pSkJWa1VpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium Más Renfe Joven",
                                            "price": 4490,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMXxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjQ0LjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N3010|BE12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Elige Confort"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4510"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjQ1LjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT016QXhNSHhDUlRFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpGYkdsblpTQkRiMjVtYjNKMElpd2ljSEpwWTJVaU9qUTFMakVzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Elige Confort",
                                            "price": 4510,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJOMzAxMHxCRTEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJFbGlnZSBDb25mb3J0IiwicHJpY2UiOjQ1LjEsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "CONFORT",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4013|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium T.Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4810"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo0OC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNM3hDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JVTGtSdmNtRmtZU0lzSW5CeWFXTmxJam8wT0M0eExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium T.Dorada",
                                            "price": 4810,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxM3xCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBULkRvcmFkYSIsInByaWNlIjo0OC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4548|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium 4 o más"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "5900"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo1OSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EVTBPSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0EwSUc4Z2JjT2hjeUlzSW5CeWFXTmxJam8xT1N3aVkzVnljbVZ1WTNraU9pSkZWVklpTENKMWRXbGtJam9pTkRRNE1UZzNPVFkxTFRNeE5EQXdNREV0TVRjeU5USTBNRFkzTkRBME55MHdNU0lzSW5SeVlXbHVWSGx3WlNJNklrRldSU0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium 4 o más",
                                            "price": 5900,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDU0OHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSA0IG8gbcOhcyIsInByaWNlIjo1OSwiY3VycmVuY3kiOiJFVVIiLCJ1dWlkIjoiNDQ4MTg3OTY1LTMxNDAwMDEtMTcyNTI0MDY3NDA0Ny0wMSIsInRyYWluVHlwZSI6IkFWRSJ9",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "4OMAS",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4030|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6090"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjYwLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXpNSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0JETGlCS2IzWmxiaUE4SURJMklpd2ljSEpwWTJVaU9qWXdMamtzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE56azJOUzB6TVRRd01EQXhMVEUzTWpVeU5EQTJOelF3TkRjdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrVWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium C. Joven < 26",
                                            "price": 6090,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAzMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSBDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjYwLjksImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4Nzk2NS0zMTQwMDAxLTE3MjUyNDA2NzQwNDctMDEiLCJ0cmFpblR5cGUiOiJBVkUifQ==",
                                            "group": {
                                                "type": "PREMIUM",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "CONFORT"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "N4010|BB12VCO|B12"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Prémium"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "4"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "6410"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo2NC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqWXdNREF3SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVME5ERXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TWlJc0luUnlZV2x1U1dRaU9pSXdNakl4TWlJc0luTmxZWFJEYkdGemN5STZJbEFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKT05EQXhNSHhDUWpFeVZrTlBmRUl4TWlJc0luUmhjbWxtWms1aGJXVWlPaUpRY3NPcGJXbDFiU0lzSW5CeWFXTmxJam8yTkM0eExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGM1TmpVdE16RTBNREF3TVMweE56STFNalF3TmpjME1EUTNMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpGSW4wPQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Prémium",
                                            "price": 6410,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjYwMDAwIiwiZGVzdGluYXRpb25JZCI6IjU0NDEzIiwidHJpcERhdGUiOiIyMDI0MDkwMiIsInRyYWluSWQiOiIwMjIxMiIsInNlYXRDbGFzcyI6IlAiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJONDAxMHxCQjEyVkNPfEIxMiIsInRhcmlmZk5hbWUiOiJQcsOpbWl1bSIsInByaWNlIjo2NC4xLCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODc5NjUtMzE0MDAwMS0xNzI1MjQwNjc0MDQ3LTAxIiwidHJhaW5UeXBlIjoiQVZFIn0=",
                                            "group": {
                                                "type": "PREMIUM",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "02212"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVE"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "2139"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0021"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "true"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-10:003"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-10:003"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-10:003"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 3,
                            "toLegId": 3
                        },
                        {
                            "fareItem": [
                                {
                                    "ticket": [
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL011"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Nino"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "2800"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjI4LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFkyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNU0lzSW5SaGNtbG1aazVoYldVaU9pSk9hVzV2SWl3aWNISnBZMlVpT2pJNExDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpRdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EVTBMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpCVGxRaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Nino",
                                            "price": 2800,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMSIsInRhcmlmZk5hbWUiOiJOaW5vIiwicHJpY2UiOjI4LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "child": true
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL031"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Más Renfe Joven"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3505"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjM1LjA1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFkyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNU0lzSW5SaGNtbG1aazVoYldVaU9pSk53NkZ6SUZKbGJtWmxJRXB2ZG1WdUlpd2ljSEpwWTJVaU9qTTFMakExTENKamRYSnlaVzVqZVNJNklrVlZVaUlzSW5WMWFXUWlPaUkwTkRneE9EZzBOelF0TXpFME1EQXdNUzB4TnpJMU1qUXdOekUxT0RVMExUQXhJaXdpZEhKaGFXNVVlWEJsSWpvaVFWWkJUbFFpZlE9PQ==",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Más Renfe Joven",
                                            "price": 3505,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMSIsInRhcmlmZk5hbWUiOiJNw6FzIFJlbmZlIEpvdmVuIiwicHJpY2UiOjM1LjA1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "MASRENFE",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL013"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Tfa. Tarjeta Dorada"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3505"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjM1LjA1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFkyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXhNeUlzSW5SaGNtbG1aazVoYldVaU9pSlVabUV1SUZSaGNtcGxkR0VnUkc5eVlXUmhJaXdpY0hKcFkyVWlPak0xTGpBMUxDSmpkWEp5Wlc1amVTSTZJa1ZWVWlJc0luVjFhV1FpT2lJME5EZ3hPRGcwTnpRdE16RTBNREF3TVMweE56STFNalF3TnpFMU9EVTBMVEF4SWl3aWRISmhhVzVVZVhCbElqb2lRVlpCVGxRaWZRPT0=",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Tfa. Tarjeta Dorada",
                                            "price": 3505,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAxMyIsInRhcmlmZk5hbWUiOiJUZmEuIFRhcmpldGEgRG9yYWRhIiwicHJpY2UiOjM1LjA1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "DORADA",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL030"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "C. Joven < 26"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "3735"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjM3LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ=="
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFkyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREQXpNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkRMaUJLYjNabGJpQThJREkySWl3aWNISnBZMlVpT2pNM0xqTTFMQ0pqZFhKeVpXNWplU0k2SWtWVlVpSXNJblYxYVdRaU9pSTBORGd4T0RnME56UXRNekUwTURBd01TMHhOekkxTWpRd056RTFPRFUwTFRBeElpd2lkSEpoYVc1VWVYQmxJam9pUVZaQlRsUWlmUT09",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "C. Joven < 26",
                                            "price": 3735,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDAzMCIsInRhcmlmZk5hbWUiOiJDLiBKb3ZlbiA8IDI2IiwicHJpY2UiOjM3LjM1LCJjdXJyZW5jeSI6IkVVUiIsInV1aWQiOiI0NDgxODg0NzQtMzE0MDAwMS0xNzI1MjQwNzE1ODU0LTAxIiwidHJhaW5UeXBlIjoiQVZBTlQifQ==",
                                            "group": {
                                                "type": "BASICO",
                                                "discount": "JOVEN",
                                                "child": false
                                            }
                                        },
                                        {
                                            "param": [
                                                {
                                                    "name": "STATUS",
                                                    "value": "AVAILABLE"
                                                },
                                                {
                                                    "name": "SEAT_TYPE",
                                                    "value": "SITTING"
                                                },
                                                {
                                                    "name": "CLASS_TYPE",
                                                    "value": "SITTING_TOURIST"
                                                },
                                                {
                                                    "name": "TICKET_ID",
                                                    "value": "GL410"
                                                },
                                                {
                                                    "name": "NAME",
                                                    "value": "Adulto Sólo Ida"
                                                },
                                                {
                                                    "name": "AVAILABILITY",
                                                    "value": "Si"
                                                },
                                                {
                                                    "name": "PRICE",
                                                    "value": "4670"
                                                },
                                                {
                                                    "name": "BOOKING_CONTEXT",
                                                    "value": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjQ2LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NC0zMTQwMDAxLTE3MjUyNDA3MTU4NTQtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9"
                                                }
                                            ],
                                            "externalContent": {
                                                "content": "ZXlKMGVYQmxJam9pY21WdVptVXRZWFpsSWl3aWRtVnljMmx2YmlJNklqRXVNakVpTENKdmNtbG5hVzVKWkNJNklqVTBOREV6SWl3aVpHVnpkR2x1WVhScGIyNUpaQ0k2SWpVeE1EQXpJaXdpZEhKcGNFUmhkR1VpT2lJeU1ESTBNRGt3TXlJc0luUnlZV2x1U1dRaU9pSXdPRFkyTkNJc0luTmxZWFJEYkdGemN5STZJbFFpTENKdWRXMWlaWEpQWmxObFlYUnpJam94TENKdmNHVnlZWFJwYjI1eklqcGJYU3dpZEdGeWFXWm1TV1FpT2lKSFREUXhNQ0lzSW5SaGNtbG1aazVoYldVaU9pSkJaSFZzZEc4Z1U4T3piRzhnU1dSaElpd2ljSEpwWTJVaU9qUTJMamNzSW1OMWNuSmxibU41SWpvaVJWVlNJaXdpZFhWcFpDSTZJalEwT0RFNE9EUTNOQzB6TVRRd01EQXhMVEUzTWpVeU5EQTNNVFU0TlRRdE1ERWlMQ0owY21GcGJsUjVjR1VpT2lKQlZrRk9WQ0o5",
                                                "text": "Ver oferta",
                                                "contentType": "XBOOK_CTX"
                                            },
                                            "name": "Adulto Sólo Ida",
                                            "price": 4670,
                                            "cur": "EUR",
                                            "shpCtx": "eyJ0eXBlIjoicmVuZmUtYXZlIiwidmVyc2lvbiI6IjEuMjEiLCJvcmlnaW5JZCI6IjU0NDEzIiwiZGVzdGluYXRpb25JZCI6IjUxMDAzIiwidHJpcERhdGUiOiIyMDI0MDkwMyIsInRyYWluSWQiOiIwODY2NCIsInNlYXRDbGFzcyI6IlQiLCJudW1iZXJPZlNlYXRzIjoxLCJvcGVyYXRpb25zIjpbXSwidGFyaWZmSWQiOiJHTDQxMCIsInRhcmlmZk5hbWUiOiJBZHVsdG8gU8OzbG8gSWRhIiwicHJpY2UiOjQ2LjcsImN1cnJlbmN5IjoiRVVSIiwidXVpZCI6IjQ0ODE4ODQ3NC0zMTQwMDAxLTE3MjUyNDA3MTU4NTQtMDEiLCJ0cmFpblR5cGUiOiJBVkFOVCJ9",
                                            "group": {
                                                "type": "BASICO",
                                                "child": false
                                            }
                                        }
                                    ],
                                    "param": [
                                        {
                                            "name": "TRAIN",
                                            "value": "08664"
                                        },
                                        {
                                            "name": "TRAIN_TYPE",
                                            "value": "AVANT"
                                        },
                                        {
                                            "name": "DEPARTURE_TIME",
                                            "value": "0710"
                                        },
                                        {
                                            "name": "ARRIVAL_TIME",
                                            "value": "0915"
                                        },
                                        {
                                            "name": "TYPE",
                                            "value": "OUTWARD"
                                        },
                                        {
                                            "name": "SILENT_CAR",
                                            "value": "false"
                                        }
                                    ]
                                }
                            ],
                            "param": [
                                {
                                    "name": "NAME",
                                    "value": "Renfe AVE LD MD Pricing"
                                },
                                {
                                    "name": "providerId",
                                    "value": "Renfe"
                                },
                                {
                                    "name": "secId",
                                    "value": "C-10:005"
                                },
                                {
                                    "name": "secIdEnd",
                                    "value": "C-10:005"
                                },
                                {
                                    "name": "secIds",
                                    "value": "C-10:005"
                                }
                            ],
                            "name": "Renfe AVE LD MD Pricing",
                            "fromLegId": 5,
                            "toLegId": 5
                        }
                    ],
                    "param": [
                        {
                            "name": "providerId",
                            "value": "Renfe"
                        }
                    ]
                },
                "calculation": "INITIAL",
                "TripStatus": {
                    "detour": true,
                    "convenient": true,
                    "hintCode": 455
                },
                "idx": 10,
                "tripId": "C-10",
                "ctxRecon": "¶HKI¶T$A=1@O=Estación de tren Madrid-Principe Pio, Madrid@L=100010000@a=128@$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$202409022051$202409022104$Ren  C10$$1$$$$$$§W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022104$202409022108$$$1$$$$$$§G@F$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022109$202409022139$__CI$$1$$$$$$§T$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$202409022139$202409030021$REN  AVE$$1$$$$$$§G@F$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$202409030640$202409030710$__CI$$1$$$$$$§T$A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@L=54413@a=128@$A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@L=100051003@a=128@$202409030710$202409030915$RENAVANT$$1$$$$$$¶GP¶ft@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§bt@0@2000@120@1@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§tt@0@5000@120@0@100@1@0@0@@@@@false@0@-1@0@-1@-1@$f@$f@$f@$f@$f@$§¶KC¶#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#¶KRCC¶#VE#1#",
                "duration": "PT12H24M",
                "rtDuration": "PT12H24M",
                "checksum": "80b43aea_3",
                "transferCount": 2,
                "LegList": {
                    "Leg": [
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                "extId": "100010000",
                                "lon": -3.71908,
                                "lat": 40.421533,
                                "routeIdx": 10,
                                "prognosisType": "PROGNOSED",
                                "time": "20:51:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "routeIdx": 14,
                                "prognosisType": "PROGNOSED",
                                "time": "21:04:00",
                                "date": "2024-09-02"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104281#TA#1#DA#20924#1S#100010200#1T#2013#LS#100017000#LT#2118#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#2013#TO#100017000#TT#2118#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 156,
                                            "g": 200,
                                            "b": 62,
                                            "hex": "#9CC83E"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "Renfe Cercanias",
                                        "nameS": "107",
                                        "nameN": "Renfe Ce",
                                        "nameL": "Renfe Cercanias",
                                        "id": "1071VC"
                                    },
                                    "name": "Ren C10",
                                    "internalName": "Ren  C10",
                                    "displayNumber": "C10",
                                    "num": "1082",
                                    "line": "C10",
                                    "lineId": "10T0003C10(1071VC)028",
                                    "catOut": "Renfe Ce",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "Renfe Cercanias",
                                    "operatorCode": "107",
                                    "operator": "Renfe Cercanias",
                                    "admin": "028000",
                                    "routeIdxFrom": 10,
                                    "routeIdxTo": 14,
                                    "matchId": "C10"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Principe Pio, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Principe Pio, Madrid@X=-3719080@Y=40421533@U=80@L=100010000@",
                                        "extId": "100010000",
                                        "routeIdx": 10,
                                        "lon": -3.71908,
                                        "lat": 40.421533,
                                        "depTime": "20:51:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid"
                                    },
                                    {
                                        "name": "Estación de tren Pirámides, Madrid",
                                        "id": "A=1@O=Estación de tren Pirámides, Madrid@X=-3711331@Y=40402593@U=80@L=100018005@",
                                        "extId": "100018005",
                                        "routeIdx": 11,
                                        "lon": -3.711331,
                                        "lat": 40.402593,
                                        "depTime": "20:54:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:54:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Delicias, Madrid",
                                        "id": "A=1@O=Estación de tren Delicias, Madrid@X=-3692760@Y=40400373@U=80@L=100018004@",
                                        "extId": "100018004",
                                        "routeIdx": 12,
                                        "lon": -3.69276,
                                        "lat": 40.400373,
                                        "depTime": "20:57:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:57:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren M.alvaro-P, Madrid",
                                        "id": "A=1@O=Estación de tren M.alvaro-P, Madrid@X=-3677712@Y=40395617@U=80@L=100018003@",
                                        "extId": "100018003",
                                        "routeIdx": 13,
                                        "lon": -3.677712,
                                        "lat": 40.395617,
                                        "depTime": "20:59:00",
                                        "depDate": "2024-09-02",
                                        "arrTime": "20:59:00",
                                        "arrDate": "2024-09-02"
                                    },
                                    {
                                        "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                        "extId": "100018000",
                                        "routeIdx": 14,
                                        "lon": -3.688957,
                                        "lat": 40.406153,
                                        "arrTime": "21:04:00",
                                        "arrDate": "2024-09-02"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#104281#TA#1#DA#20924#1S#100010200#1T#2013#LS#100017000#LT#2118#PU#80#RT#1#CA#107#ZE#C10#ZB#Ren  C10#PC#2#FR#100010200#FT#2013#TO#100017000#TT#2118#"
                            },
                            "id": "C-10:000",
                            "idx": 0,
                            "name": "Ren C10",
                            "number": "C10",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Madrid-Chamartín-Clara Campoamor, Madrid",
                            "directionFlag": "0",
                            "duration": "PT13M",
                            "dist": 6690,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.71908,
                                        "lat": 40.421533
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.711331,
                                        "lat": 40.402593
                                    },
                                    {
                                        "order": 2,
                                        "lon": -3.69276,
                                        "lat": 40.400373
                                    },
                                    {
                                        "order": 3,
                                        "lon": -3.677712,
                                        "lat": 40.395617
                                    },
                                    {
                                        "order": 4,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid - Atocha Cercanías, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@X=-3688957@Y=40406153@U=80@L=100018000@",
                                "extId": "100018000",
                                "lon": -3.688957,
                                "lat": 40.406153,
                                "time": "21:04:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "time": "21:08:00",
                                "date": "2024-09-02"
                            },
                            "GisRef": {
                                "ref": "H|1|W$A=1@O=Estación de tren Madrid - Atocha Cercanías, Madrid@L=100018000@a=128@$A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@L=100060000@a=128@$202409022104$202409022108$$$1$$$$$$|#VE#2#CF#100#CA#0#CM#0#SICT#0#AM#49#AM2#0#RT#4#"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 255,
                                            "g": 255,
                                            "b": 255,
                                            "hex": "#FFFFFF"
                                        },
                                        "backgroundColor": {
                                            "r": 244,
                                            "g": 168,
                                            "b": 0,
                                            "hex": "#F4A800"
                                        },
                                        "res": "prod_walk"
                                    },
                                    "name": "Trayecto a pie",
                                    "internalName": "Trayecto a pie"
                                }
                            ],
                            "id": "C-10:001",
                            "idx": 1,
                            "name": "Trayecto a pie",
                            "type": "WALK",
                            "duration": "PT4M",
                            "dist": 167,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.688957,
                                        "lat": 40.406153
                                    },
                                    {
                                        "order": 1,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    }
                                ],
                                "dist": 167,
                                "durS": "PT4M",
                                "dirGeo": 16
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "21:09:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "time": "21:39:00",
                                "date": "2024-09-02"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-10:002",
                            "idx": 2,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                "extId": "100060000",
                                "lon": -3.69089,
                                "lat": 40.40644,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "21:39:00",
                                "date": "2024-09-02"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 1,
                                "prognosisType": "PROGNOSED",
                                "time": "00:21:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108713#TA#0#DA#20924#1S#100060000#1T#2139#LS#54413#LT#10021#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#2139#TO#54413#TT#10021#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ice"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "REN AVE",
                                    "internalName": "REN  AVE",
                                    "displayNumber": "AVE",
                                    "num": "262",
                                    "line": "AVE",
                                    "lineId": "6000054413AV006(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "1",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 1,
                                    "matchId": "AVE"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Madrid-Puerta de Atocha, Madrid",
                                        "id": "A=1@O=Estación de tren Madrid-Puerta de Atocha, Madrid@X=-3690890@Y=40406440@U=80@L=100060000@",
                                        "extId": "100060000",
                                        "routeIdx": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "21:39:00",
                                        "depDate": "2024-09-02",
                                        "depDir": "Estación de tren Malaga Maria Zambrano, Málaga"
                                    },
                                    {
                                        "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                        "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                        "extId": "54413",
                                        "routeIdx": 1,
                                        "lon": -4.431385,
                                        "lat": 36.711334,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "00:21:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-02",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#108713#TA#0#DA#20924#1S#100060000#1T#2139#LS#54413#LT#10021#PU#80#RT#1#CA#107#ZE#AVE#ZB#REN  AVE#PC#1#FR#100060000#FT#2139#TO#54413#TT#10021#"
                            },
                            "id": "C-10:003",
                            "idx": 3,
                            "name": "REN AVE",
                            "number": "AVE",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Malaga Maria Zambrano, Málaga",
                            "directionFlag": "0",
                            "duration": "PT2H42M",
                            "dist": 416071,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -3.69089,
                                        "lat": 40.40644
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.431385,
                                        "lat": 36.711334
                                    }
                                ]
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "time": "06:40:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "time": "07:10:00",
                                "date": "2024-09-03"
                            },
                            "Product": [
                                {
                                    "icon": {
                                        "res": "check_in"
                                    },
                                    "name": "Ingreso",
                                    "internalName": "Ingreso"
                                }
                            ],
                            "id": "C-10:004",
                            "idx": 4,
                            "name": "Ingreso",
                            "type": "CHKI",
                            "duration": "PT30M",
                            "dist": 0,
                            "GisRoute": {
                                "dist": 0,
                                "durS": "PT30M",
                                "dirGeo": 0
                            }
                        },
                        {
                            "Origin": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Salida Martes, 03.09.2024",
                                            "key": "text.connection.section.departure.date.deviation",
                                            "type": "H",
                                            "txtN": "Salida Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                "extId": "54413",
                                "lon": -4.431385,
                                "lat": 36.711334,
                                "routeIdx": 0,
                                "prognosisType": "PROGNOSED",
                                "time": "07:10:00",
                                "date": "2024-09-03"
                            },
                            "Destination": {
                                "Notes": {
                                    "Note": [
                                        {
                                            "value": "Llegada Martes, 03.09.2024",
                                            "key": "text.connection.section.arrival.date.deviation",
                                            "type": "H",
                                            "txtN": "Llegada Martes, 03.09.2024"
                                        }
                                    ]
                                },
                                "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                "type": "ST",
                                "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                "extId": "100051003",
                                "lon": -5.975274,
                                "lat": 37.392123,
                                "routeIdx": 4,
                                "prognosisType": "PROGNOSED",
                                "time": "09:15:00",
                                "date": "2024-09-03"
                            },
                            "JourneyDetailRef": {
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109275#TA#0#DA#30924#1S#54413#1T#710#LS#100051003#LT#915#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#710#TO#100051003#TT#915#"
                            },
                            "JourneyStatus": "P",
                            "Product": [
                                {
                                    "icon": {
                                        "foregroundColor": {
                                            "r": 0,
                                            "g": 0,
                                            "b": 0,
                                            "hex": "#000000"
                                        },
                                        "backgroundColor": {
                                            "r": 242,
                                            "g": 245,
                                            "b": 245,
                                            "hex": "#F2F5F5"
                                        },
                                        "res": "prod_ic"
                                    },
                                    "operatorInfo": {
                                        "name": "RENFE OPERADORA",
                                        "nameS": "107",
                                        "nameN": "RENFE OP",
                                        "nameL": "RENFE OPERADORA",
                                        "id": "1071"
                                    },
                                    "name": "RENAVANT",
                                    "internalName": "RENAVANT",
                                    "displayNumber": "AVANT",
                                    "num": "799",
                                    "line": "AVANT",
                                    "lineId": "5441351003AV008(1071)030",
                                    "catOut": "RENFE OP",
                                    "catIn": "107",
                                    "catCode": "2",
                                    "cls": "4",
                                    "catOutS": "107",
                                    "catOutL": "RENFE OPERADORA",
                                    "operatorCode": "107",
                                    "operator": "RENFE OPERADORA",
                                    "admin": "030000",
                                    "routeIdxFrom": 0,
                                    "routeIdxTo": 4,
                                    "matchId": "AVANT"
                                }
                            ],
                            "Stops": {
                                "Stop": [
                                    {
                                        "name": "Estación de tren Malaga Maria Zambrano, Málaga",
                                        "id": "A=1@O=Estación de tren Malaga Maria Zambrano, Málaga@X=-4431385@Y=36711334@U=80@L=54413@",
                                        "extId": "54413",
                                        "routeIdx": 0,
                                        "lon": -4.431385,
                                        "lat": 36.711334,
                                        "depPrognosisType": "PROGNOSED",
                                        "depTime": "07:10:00",
                                        "depDate": "2024-09-03",
                                        "depDir": "Estación de tren Sevilla-Santa Justa, Sevilla"
                                    },
                                    {
                                        "name": "Estación de tren Antequera-Santa Ana, Antequera",
                                        "id": "A=1@O=Estación de tren Antequera-Santa Ana, Antequera@X=-4719013@Y=37069878@U=80@L=100002003@",
                                        "extId": "100002003",
                                        "routeIdx": 1,
                                        "lon": -4.719013,
                                        "lat": 37.069878,
                                        "depTime": "07:33:00",
                                        "depDate": "2024-09-03",
                                        "arrTime": "07:31:00",
                                        "arrDate": "2024-09-03"
                                    },
                                    {
                                        "name": "Estación de tren Puente Genil-Herrera, Puente Genil",
                                        "id": "A=1@O=Estación de tren Puente Genil-Herrera, Puente Genil@X=-4821634@Y=37357902@U=80@L=100002002@",
                                        "extId": "100002002",
                                        "routeIdx": 2,
                                        "lon": -4.821634,
                                        "lat": 37.357902,
                                        "depTime": "07:47:00",
                                        "depDate": "2024-09-03",
                                        "arrTime": "07:46:00",
                                        "arrDate": "2024-09-03"
                                    },
                                    {
                                        "name": "Estación de tren Cordoba, Córdoba",
                                        "id": "A=1@O=Estación de tren Cordoba, Córdoba@X=-4789453@Y=37888292@U=80@L=100050500@",
                                        "extId": "100050500",
                                        "routeIdx": 3,
                                        "lon": -4.789453,
                                        "lat": 37.888292,
                                        "depTime": "08:21:00",
                                        "depDate": "2024-09-03",
                                        "arrTime": "08:16:00",
                                        "arrDate": "2024-09-03"
                                    },
                                    {
                                        "name": "Estación de tren Sevilla-Santa Justa, Sevilla",
                                        "id": "A=1@O=Estación de tren Sevilla-Santa Justa, Sevilla@X=-5975274@Y=37392123@U=80@L=100051003@",
                                        "extId": "100051003",
                                        "routeIdx": 4,
                                        "lon": -5.975274,
                                        "lat": 37.392123,
                                        "arrPrognosisType": "PROGNOSED",
                                        "arrTime": "09:15:00",
                                        "arrDate": "2024-09-03"
                                    }
                                ]
                            },
                            "JourneyDetail": {
                                "dayOfOperation": "2024-09-03",
                                "ref": "2|#VN#1#ST#1725018256#PI#0#ZI#109275#TA#0#DA#30924#1S#54413#1T#710#LS#100051003#LT#915#PU#80#RT#1#CA#107#ZE#AVANT#ZB#RENAVANT#PC#2#FR#54413#FT#710#TO#100051003#TT#915#"
                            },
                            "id": "C-10:005",
                            "idx": 5,
                            "name": "RENAVANT",
                            "number": "AVANT",
                            "category": "107",
                            "type": "JNY",
                            "reachable": true,
                            "direction": "Estación de tren Sevilla-Santa Justa, Sevilla",
                            "directionFlag": "0",
                            "duration": "PT2H5M",
                            "dist": 257911,
                            "GisRoute": {
                                "coordinates": [
                                    {
                                        "order": 0,
                                        "lon": -4.431385,
                                        "lat": 36.711334
                                    },
                                    {
                                        "order": 1,
                                        "lon": -4.719013,
                                        "lat": 37.069878
                                    },
                                    {
                                        "order": 2,
                                        "lon": -4.821634,
                                        "lat": 37.357902
                                    },
                                    {
                                        "order": 3,
                                        "lon": -4.789453,
                                        "lat": 37.888292
                                    },
                                    {
                                        "order": 4,
                                        "lon": -5.975274,
                                        "lat": 37.392123
                                    }
                                ]
                            }
                        }
                    ]
                }
            }*/
        ]
    }
}
}
